var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};

// src/configs/ad-unit-config.ts
var _AdUnitConfig = class _AdUnitConfig {
  constructor(options) {
    this.providers = options.providers;
    this.units = options.units;
  }
};
__name(_AdUnitConfig, "AdUnitConfig");
var AdUnitConfig = _AdUnitConfig;

// src/types/providers.ts
var isAdUnitProviders = /* @__PURE__ */ __name((providers) => typeof providers === "object" && !Array.isArray(providers) && Object.keys(providers).length > 0 && Object.keys(providers).every((key) => typeof key === "string"), "isAdUnitProviders");
var isProvidersConfig = /* @__PURE__ */ __name((providersConfig) => typeof providersConfig === "object" && !Array.isArray(providersConfig) && Object.keys(providersConfig).length > 0 && Object.entries(providersConfig).every(([key, value]) => typeof key === "string" && typeof value === "string"), "isProvidersConfig");

// src/types/ad-sizes.ts
var isAdSizes = /* @__PURE__ */ __name((adSizes) => Array.isArray(adSizes) && adSizes.every((adSize) => Array.isArray(adSize) && (adSize.every((dimension) => Number.isInteger(dimension)) && adSize.length % 2 === 0 || adSize.every((dimension) => typeof dimension === "string" && dimension === "fluid"))), "isAdSizes");

// src/types/breakpoints.ts
var BreakpointTypes;
(function(BreakpointTypes2) {
  BreakpointTypes2["Mobile"] = "mobile";
  BreakpointTypes2["Desktop"] = "desktop";
})(BreakpointTypes || (BreakpointTypes = {}));
var isBreakpointTypes = /* @__PURE__ */ __name((breakpoints) => Array.isArray(breakpoints) && breakpoints.every((breakpoint) => Object.values(BreakpointTypes).includes(breakpoint)), "isBreakpointTypes");

// src/types/metrics.ts
var AdEventType;
(function(AdEventType2) {
  AdEventType2["RefreshBiddingStarted"] = "refreshBiddingStarted";
  AdEventType2["RefreshBiddingCompleted"] = "refreshBiddingCompleted";
  AdEventType2["RefreshAdUnitPopulated"] = "refreshAdUnitPopulated";
  AdEventType2["DynamicBiddingStarted"] = "dynamicBiddingStarted";
  AdEventType2["DynamicBiddingCompleted"] = "dynamicBiddingCompleted";
  AdEventType2["DynamicAdUnitPopulated"] = "dynamicAdUnitPopulated";
  AdEventType2["AdUnitViewable"] = "adUnitViewable";
})(AdEventType || (AdEventType = {}));
var PageEventType;
(function(PageEventType2) {
  PageEventType2["AdblockDetected"] = "adblockDetected";
  PageEventType2["ProcessingStarted"] = "processingStarted";
  PageEventType2["BiddingStarted"] = "biddingStarted";
  PageEventType2["BiddingCompleted"] = "biddingCompleted";
  PageEventType2["AdUnitPopulated"] = "adUnitPopulated";
  PageEventType2["ReinitializeBiddingStarted"] = "reinitializeBiddingStarted";
  PageEventType2["ReinitializeBiddingCompleted"] = "reinitializeBiddingCompleted";
  PageEventType2["ReinitializeAdUnitPopulated"] = "reinitializeAdUnitPopulated";
})(PageEventType || (PageEventType = {}));
var EventTypes = {
  ...AdEventType,
  ...PageEventType
};
var adEventTypes = [
  EventTypes.RefreshBiddingStarted,
  EventTypes.RefreshBiddingCompleted,
  EventTypes.RefreshAdUnitPopulated,
  EventTypes.DynamicBiddingStarted,
  EventTypes.DynamicBiddingCompleted,
  EventTypes.DynamicAdUnitPopulated,
  EventTypes.AdUnitViewable
];
var pageEventTypes = [
  EventTypes.AdblockDetected,
  EventTypes.ProcessingStarted,
  EventTypes.BiddingStarted,
  EventTypes.BiddingCompleted,
  EventTypes.AdUnitPopulated,
  EventTypes.ReinitializeBiddingStarted,
  EventTypes.ReinitializeBiddingCompleted,
  EventTypes.ReinitializeAdUnitPopulated
];
var refreshEventTypes = [
  EventTypes.RefreshBiddingStarted,
  EventTypes.RefreshBiddingCompleted,
  EventTypes.RefreshAdUnitPopulated
];
var dynamicEventTypes = [
  EventTypes.DynamicBiddingStarted,
  EventTypes.DynamicBiddingCompleted,
  EventTypes.DynamicAdUnitPopulated
];
var reinitializeEventTypes = [
  EventTypes.ReinitializeBiddingStarted,
  EventTypes.ReinitializeBiddingCompleted,
  EventTypes.ReinitializeAdUnitPopulated
];
var isPageMetrics = /* @__PURE__ */ __name((metrics) => Array.isArray(metrics) && metrics.every((metric) => pageEventTypes.includes(metric)), "isPageMetrics");
var isAdMetrics = /* @__PURE__ */ __name((metrics) => Array.isArray(metrics) && metrics.every((metric) => adEventTypes.includes(metric)), "isAdMetrics");
var isRefreshMetrics = /* @__PURE__ */ __name((metrics) => Array.isArray(metrics) && metrics.every((metric) => refreshEventTypes.includes(metric)), "isRefreshMetrics");
var isDynamicMetrics = /* @__PURE__ */ __name((metrics) => Array.isArray(metrics) && metrics.every((metric) => dynamicEventTypes.includes(metric)), "isDynamicMetrics");
var isReinitializeMetrics = /* @__PURE__ */ __name((metrics) => Array.isArray(metrics) && metrics.every((metric) => reinitializeEventTypes.includes(metric)), "isReinitializeMetrics");

// src/entities/ad-unit.ts
var isDefaultOptions = /* @__PURE__ */ __name((options) => "providers" in options && "breakpoints" in options && "metrics" in options && typeof options === "object", "isDefaultOptions");
var _AdUnit = class _AdUnit {
  constructor(options) {
    if (options.name) {
      this.name = options.name;
    }
    if (options.sizes) {
      this.sizes = options.sizes;
    }
    if (options.providers) {
      this.providers = options.providers;
    }
    if (options.breakpoints) {
      this.breakpoints = options.breakpoints;
    }
    if (options.metrics) {
      this.metrics = options.metrics;
    }
    if (options.dynamic) {
      this.dynamic = options.dynamic;
    }
  }
};
__name(_AdUnit, "AdUnit");
var AdUnit = _AdUnit;

// src/entities/ad-unit-transformer.ts
var _AdUnitTransformer = class _AdUnitTransformer {
  static transformFromData(name5, data, adUnitProviders, adUnitDefaults) {
    const { sizes, dynamic } = data;
    const providers = data.providers ?? adUnitDefaults.providers;
    const isProvidersDefault = adUnitDefaults.providers === providers;
    const adUnitProviderKeys = Object.keys(providers);
    const breakpoints = data.breakpoints ?? adUnitDefaults.breakpoints;
    const isBreakpointsDefault = adUnitDefaults.breakpoints === breakpoints;
    const metrics = data.metrics ?? adUnitDefaults.metrics;
    const isMetricsDefault = adUnitDefaults.metrics === metrics;
    if (!sizes) {
      throw new Error('Must specify "sizes" property in ad units config.');
    }
    if (!isAdSizes(sizes)) {
      throw new Error(`
        Invalid "sizes" property ("${JSON.stringify(data.sizes)}") supplied to ad unit "${name5}" in ad units config.
        
"sizes" property must be an array with dual paired, integer values which specify the width/height of an ad slot (e.g. [[200, 400], [100, 200]]), or the string 'fluid'
      `);
    }
    if (!isAdUnitProviders(providers)) {
      throw new Error(`
        Invalid "providers" property ("${JSON.stringify(data.providers)}") supplied to ${isProvidersDefault ? "defaults" : `ad unit "${name5}"`} in ad units config.
        
"providers" property must be an object of valid ad providers (e.g. { "provider1": { data: 0 } }).
      `);
    }
    adUnitProviderKeys.forEach((adUnitProviderName) => {
      if (!adUnitProviders[adUnitProviderName]) {
        if (!isProvidersDefault) {
          throw new Error(`Provider "${adUnitProviderName}" defined in provider data in ad "${name5}" is not defined in ad unit config.`);
        }
        throw new Error(`Default Provider "${adUnitProviderName}" defined in provider data is not defined in ad unit config.`);
      }
    });
    if (!isBreakpointTypes(breakpoints)) {
      throw new Error(`
        Invalid "breakpoints" property ("${JSON.stringify(data.breakpoints)}") supplied to ${isBreakpointsDefault ? "defaults" : `ad unit "${name5}"`} in ad units config.
        
"breakpoints" property must be an array of valid breakpoints (e.g. ["breakpoint1", "breakpoint2"]).'
      `);
    }
    if (metrics && !isAdMetrics(metrics)) {
      throw new Error(`
        Invalid "metrics" property ("${JSON.stringify(data.metrics)}") supplied to ${isMetricsDefault ? "defaults" : `ad unit "${name5}"`} in ad units config.
        
"metrics" property must be an array of valid metrics (e.g. ["metric1", "metric2"]).
      `);
    }
    if (dynamic && typeof dynamic !== "boolean") {
      throw new Error(`
        Invalid "dynamic" property ("${JSON.stringify(data.dynamic)}") supplied to ad unit "${name5}" in ad units config.
        
"dynamic" property must be a boolean.
      `);
    }
    return new AdUnit({
      name: name5,
      sizes,
      providers,
      breakpoints,
      metrics,
      dynamic
    });
  }
};
__name(_AdUnitTransformer, "AdUnitTransformer");
var AdUnitTransformer = _AdUnitTransformer;

// src/configs/ad-unit-config-transformer.ts
var _AdUnitConfigTransformer = class _AdUnitConfigTransformer {
  static transformFromJson(json) {
    const { providers, defaults, units } = json;
    if (!providers) {
      throw new Error('Must specify "providers" property in ad units config.');
    }
    if (!isProvidersConfig(providers)) {
      throw new Error(`
        Invalid "providers" property ("${JSON.stringify(providers)}") in ad units config.
        
"providers" property must be an object of valid ad providers and connectors (e.g. { "provider1": "ProviderConnector1", "provider2": "ProviderConnector2" }).
      `);
    }
    if (!defaults) {
      throw new Error('Must specify "defaults" property in ad unit config.');
    }
    if (!isDefaultOptions(defaults)) {
      throw new Error(`
        Invalid "defaults" property ("${JSON.stringify(defaults)}") in ad units config.
        
"defaults" property must by an object with the following properties: refresh, providers, breakpoints, metric
      `);
    }
    if (!units) {
      throw new Error('Must specify "units" property in ad units config.');
    }
    const adUnitsArray = Object.entries(units).map(([name5, data]) => AdUnitTransformer.transformFromData(name5, data, providers, defaults));
    return new AdUnitConfig({
      providers,
      units: adUnitsArray
    });
  }
};
__name(_AdUnitConfigTransformer, "AdUnitConfigTransformer");
var AdUnitConfigTransformer = _AdUnitConfigTransformer;

// src/configs/overrides-config.ts
var _OverridesConfig = class _OverridesConfig {
  constructor(options) {
    this.rules = options.rules;
    this.pages = options.pages;
  }
};
__name(_OverridesConfig, "OverridesConfig");
var OverridesConfig = _OverridesConfig;

// src/entities/rule.ts
var _Rule = class _Rule {
  constructor(options) {
    this.name = options.name;
    this.ruleset = options.ruleset;
  }
};
__name(_Rule, "Rule");
var Rule = _Rule;

// src/types/rule-definition.ts
var isRuleDefinition = /* @__PURE__ */ __name((ruleDef) => typeof ruleDef === "object" && ruleDef !== null && "rule" in ruleDef && typeof ruleDef.rule === "string" && "match" in ruleDef && typeof ruleDef.match === "boolean", "isRuleDefinition");

// src/entities/rule-transformer.ts
var _RuleTransformer = class _RuleTransformer {
  static transformFromData(name5, data) {
    if (!data.ruleset) {
      throw new Error(`Must specify "ruleset" property for rule "${name5}" in overrides config.`);
    }
    if (!(Symbol.iterator in Object(data.ruleset))) {
      throw new Error(`The "ruleset" property for rule "${name5}" in overrides config must be an array.`);
    }
    const ruleList = Array.from(data.ruleset).map((ruleDef) => {
      if (!isRuleDefinition(ruleDef)) {
        throw new Error(`
          Invalid rule definition supplied: ("${JSON.stringify(ruleDef)}") supplied to ruleset for rule "${name5}" in overrides config.
          
a rule definition must be an object with a "rule" and "match" property (e.g. { "rule": "isCookied", "match": false }).
        `);
      }
      return ruleDef;
    });
    return new Rule({
      name: name5,
      ruleset: ruleList
    });
  }
};
__name(_RuleTransformer, "RuleTransformer");
var RuleTransformer = _RuleTransformer;

// src/types/refresh.ts
var isPageRefresh = /* @__PURE__ */ __name((refresh) => typeof refresh === "object" && refresh !== null && "rate" in refresh && typeof refresh.rate === "number" && "limit" in refresh && typeof refresh.limit === "number", "isPageRefresh");

// src/entities/ad.ts
var _Ad = class _Ad {
  constructor(options) {
    this.name = options.name;
    this.placement = options.placement;
    if (options.unit) {
      this.unit = options.unit;
    }
    if (options.overrides) {
      this.overrides = options.overrides;
    }
  }
};
__name(_Ad, "Ad");
var Ad = _Ad;

// src/entities/ad-override.ts
var _AdOverride = class _AdOverride {
  constructor(options) {
    this.name = options.name;
    if (options.configurations) {
      this.configurations = options.configurations;
    }
    if (options.tests) {
      this.tests = options.tests;
    }
  }
};
__name(_AdOverride, "AdOverride");
var AdOverride = _AdOverride;

// src/entities/configuration.ts
var _Configuration = class _Configuration {
  constructor(options) {
    this.name = options.name;
    this.rules = options.rules;
  }
};
__name(_Configuration, "Configuration");
var Configuration = _Configuration;

// src/entities/ad-unit-override.ts
var _AdUnitOverride = class _AdUnitOverride {
  constructor(options) {
    this.name = options.name;
    if (options.sizes) {
      this.sizes = options.sizes;
    }
    if (options.providers) {
      this.providers = options.providers;
    }
    if (options.breakpoints) {
      this.breakpoints = options.breakpoints;
    }
    if (options.metrics) {
      this.metrics = options.metrics;
    }
    if (options.dynamic) {
      this.dynamic = options.dynamic;
    }
  }
};
__name(_AdUnitOverride, "AdUnitOverride");
var AdUnitOverride = _AdUnitOverride;

// src/entities/ad-unit-override-transformer.ts
var _AdUnitOverrideTransformer = class _AdUnitOverrideTransformer {
  static transformFromOverrides(name5, data) {
    const {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      sizes,
      providers,
      breakpoints,
      metrics,
      dynamic
    } = data;
    if (sizes && !isAdSizes(sizes)) {
      throw new Error(`
        Invalid "sizes" property: ("${JSON.stringify(sizes)}") supplied to ad unit "${name5}" in overrides config.
        
"sizes" property must be an array with dual paired, integer values which specify the width/height of an ad slot (e.g. [[200, 400], [100, 200]]), or the string 'fluid'
      `);
    }
    if (providers && !isAdUnitProviders(providers)) {
      throw new Error(`
        Invalid "providers" property: ("${JSON.stringify(providers)}") supplied to ad unit "${name5}" in overrides config.
        
"providers" property must be an array of valid ad providers (e.g. ["provider1", "provider2"]).
      `);
    }
    if (breakpoints && !isBreakpointTypes(data.breakpoints)) {
      throw new Error(`
        Invalid "breakpoints" property: ("${JSON.stringify(breakpoints)}") supplied to ad unit "${name5}" in overrides config.
        
"breakpoints" property must be an array of valid breakpoints (e.g. ["breakpoint1", "breakpoint2"]).
      `);
    }
    if (metrics && !isAdMetrics(metrics)) {
      throw new Error(`
        Invalid "metrics" property: ("${JSON.stringify(metrics)}") supplied to ad unit "${name5}" in overrides config.
        
"metrics" property must be an array of valid metrics (e.g. ["metric1", "metric2"]).
      `);
    }
    if (dynamic && typeof dynamic !== "boolean") {
      throw new Error(`
        Invalid "dynamic" property ("${JSON.stringify(dynamic)}") found in production config.
        
"dynamic" property must be a boolean.
      `);
    }
    return new AdUnitOverride({
      name: name5,
      sizes,
      providers,
      breakpoints,
      metrics,
      dynamic
    });
  }
};
__name(_AdUnitOverrideTransformer, "AdUnitOverrideTransformer");
var AdUnitOverrideTransformer = _AdUnitOverrideTransformer;

// src/entities/configuration-transformer.ts
var _ConfigurationTransformer = class _ConfigurationTransformer {
  static transformFromData(name5, data) {
    if (!data.rules) {
      throw new Error(`Must specify "rules" property for configuration "${name5}" in overrides config.`);
    }
    if (Object.keys(data.rules).length === 0) {
      throw new Error(`"rules" property for configuration "${name5}" in overrides config must not be empty.`);
    }
    if (Object.keys(data.rules).length > 1) {
      throw new Error(`"rules" property for configuration "${name5}" in overrides config should only have 1 entry.`);
    }
    const rulesArray = Object.entries(data.rules).map(([configName, configData]) => AdUnitOverrideTransformer.transformFromOverrides(configName, configData));
    return new Configuration({
      name: name5,
      rules: rulesArray
    });
  }
};
__name(_ConfigurationTransformer, "ConfigurationTransformer");
var ConfigurationTransformer = _ConfigurationTransformer;

// src/entities/ab-test.ts
var _AbTest = class _AbTest {
  constructor(options) {
    this.name = options.name;
    this.variants = options.variants;
  }
};
__name(_AbTest, "AbTest");
var AbTest = _AbTest;

// src/entities/ab-test-transformer.ts
var _AbTestTransformer = class _AbTestTransformer {
  static transformFromData(name5, data) {
    if (!data.variants) {
      throw new Error(`Must specify "variants" property for ab test "${name5}" in overrides config.`);
    }
    if (Object.keys(data.variants).length === 0) {
      throw new Error(`"variants" property for ab test "${name5}" in overrides config must not be empty.`);
    }
    const variantsArray = Object.entries(data.variants).map(([variantName, variantData]) => AdUnitOverrideTransformer.transformFromOverrides(variantName, variantData));
    return new AbTest({
      name: name5,
      variants: variantsArray
    });
  }
};
__name(_AbTestTransformer, "AbTestTransformer");
var AbTestTransformer = _AbTestTransformer;

// src/entities/ad-transformer.ts
var _AdTransformer = class _AdTransformer {
  static transformFromData(name5, data) {
    const { unit, placement, overrides } = data;
    if (!unit) {
      throw new Error(`Must specify "unit" property for ad "${name5}" in page slots config.`);
    }
    if (typeof unit !== "string") {
      throw new Error(`
        Invalid "unit" property for ad "${name5}" in page slots config.
        
"unit" property must be a string (e.g. "testUnit").
      `);
    }
    if (!placement) {
      throw new Error(`Must specify "placement" property for ad "${name5}" in page slots config.`);
    }
    if (typeof placement !== "string") {
      throw new Error(`
        Invalid "placement" property for ad "${name5}" in page slots config.
        
"placement" property must be a string (e.g. "300BTF1").
      `);
    }
    if (overrides) {
      const {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        breakpoints,
        metrics,
        providers,
        dynamic
      } = overrides;
      if (breakpoints && !isBreakpointTypes(breakpoints)) {
        throw new Error(`
          Invalid "breakpoints" property ("${JSON.stringify(breakpoints)}") supplied to to ad "${name5}" in page slots config.
          
"breakpoints" property must be an array of valid breakpoints (e.g. ["breakpoint1", "breakpoint2"]).'
        `);
      }
      if (metrics && !isAdMetrics(metrics)) {
        throw new Error(`
          Invalid "metrics" property ("${JSON.stringify(metrics)}") supplied to ad "${name5}" in page slots config.
          
"metrics" property must be an array of valid metrics (e.g. ["metric1", "metric2"]).
        `);
      }
      if (providers && !isAdUnitProviders(providers)) {
        throw new Error(`
          Invalid "providers" property ("${JSON.stringify(providers)}") supplied to ad "${name5}" in page slots config.
          
"providers" property must be an object of valid ad providers (e.g. { "provider1": { data: 0 } }).
        `);
      }
      if (dynamic && typeof dynamic !== "boolean") {
        throw new Error(`
          Invalid "dynamic" property ("${JSON.stringify(dynamic)}") supplied to ad "${name5}" in page slots config.
          
"dynamic" property must be a boolean.
        `);
      }
    }
    return new Ad({
      name: name5,
      unit,
      placement,
      overrides
    });
  }
  static transformFromOverrides(name5, data) {
    const configurationsArray = Object.entries(data?.configurations).map(([configName, configData]) => ConfigurationTransformer.transformFromData(configName, configData));
    const testsArray = Object.entries(data?.tests).map(([testName, testData]) => AbTestTransformer.transformFromData(testName, testData));
    if (!data.configurations && !data.tests) {
      throw new Error(`Must specify at least one of "configurations" or "tests" properties for ad "${name5}" in overrides config.`);
    }
    return new AdOverride({
      name: name5,
      configurations: configurationsArray,
      tests: testsArray
    });
  }
};
__name(_AdTransformer, "AdTransformer");
var AdTransformer = _AdTransformer;

// src/entities/page.ts
var isDefaultOptions2 = /* @__PURE__ */ __name((options) => "metrics" in options && "refresh" in options && typeof options === "object", "isDefaultOptions");
var _Page = class _Page {
  constructor(options) {
    this.name = options.name;
    this.ads = options.ads;
    if (options.metrics) {
      this.metrics = options.metrics;
    }
    if (options.refresh) {
      this.refresh = options.refresh;
    }
  }
};
__name(_Page, "Page");
var Page = _Page;

// src/entities/page-override.ts
var _PageOverride = class _PageOverride {
  constructor(options) {
    this.name = options.name;
    this.ads = options.adOverrides;
  }
};
__name(_PageOverride, "PageOverride");
var PageOverride = _PageOverride;

// src/entities/page-transformer.ts
var _PageTransformer = class _PageTransformer {
  static transformFromData(name5, data, pageDefaults) {
    const { ads } = data;
    const metrics = data.metrics ?? pageDefaults.metrics;
    const isMetricsDefault = pageDefaults.metrics === metrics;
    const refresh = data.refresh ?? pageDefaults.refresh;
    const isRefreshDefault = pageDefaults.refresh === refresh;
    if (!ads) {
      throw new Error(`Must specify "ads" property for page "${name5}" in page slots config.`);
    }
    const adsArray = Object.entries(ads).map(([adName, adData]) => AdTransformer.transformFromData(adName, adData));
    if (!isPageMetrics(metrics)) {
      throw new Error(`
        Invalid "metrics" property ("${JSON.stringify(metrics)}") supplied to ${isMetricsDefault ? "defaults" : `page "${name5}"`} in page slots config.
        
"metrics" property must be an array of valid metrics (e.g. ["metric1", "metric2"]).
      `);
    }
    if (!isPageRefresh(refresh)) {
      throw new Error(`
        Invalid "refresh" property ("${JSON.stringify(refresh)}") supplied to ${isRefreshDefault ? "defaults" : `page "${name5}"`} in page slots config.
        
"refresh" property must be an object with the following properties: { "rate", "limit" }(e.g. { "rate": 30, "limit": 10 }).
      `);
    }
    return new Page({
      name: name5,
      ads: adsArray,
      metrics,
      refresh
    });
  }
  static transformFromOverrides(name5, data) {
    if (!data.ads) {
      throw new Error(`Must specify "ads" property for page "${name5}" in overrides config.`);
    }
    const adsArray = Object.entries(data.ads).map(([adName, adData]) => AdTransformer.transformFromOverrides(adName, adData));
    return new PageOverride({
      name: name5,
      adOverrides: adsArray
    });
  }
};
__name(_PageTransformer, "PageTransformer");
var PageTransformer = _PageTransformer;

// src/configs/overrides-config-transformer.ts
var _OverridesConfigTransformer = class _OverridesConfigTransformer {
  static transformFromJson(json) {
    if (!json.rules) {
      throw new Error('Must specify "rules" property in overrides config.');
    }
    const rulesArray = Object.entries(json.rules).map(([name5, data]) => RuleTransformer.transformFromData(name5, data));
    if (!json.pages) {
      throw new Error('Must specify "pages" property in overrides config.');
    }
    const pagesArray = Object.entries(json.pages).map(([name5, data]) => PageTransformer.transformFromOverrides(name5, data));
    return new OverridesConfig({
      rules: rulesArray,
      pages: pagesArray
    });
  }
};
__name(_OverridesConfigTransformer, "OverridesConfigTransformer");
var OverridesConfigTransformer = _OverridesConfigTransformer;

// src/configs/page-slots-config.ts
var _PageSlotsConfig = class _PageSlotsConfig {
  constructor(options) {
    this.pages = options.pages;
  }
};
__name(_PageSlotsConfig, "PageSlotsConfig");
var PageSlotsConfig = _PageSlotsConfig;

// src/configs/page-slots-config-transformer.ts
var _PageSlotsConfigTransformer = class _PageSlotsConfigTransformer {
  static transformFromJson(json) {
    const { defaults, pages } = json;
    if (!defaults) {
      throw new Error('Must specify "defaults" property in page slots config.');
    }
    if (!isDefaultOptions2(defaults)) {
      throw new Error(`
        Invalid "defaults" property ("${JSON.stringify(defaults)}") in page slots config.
        
"defaults" property must by an object with the following properties: metrics, refresh
      `);
    }
    if (!pages) {
      throw new Error('Must specify "pages" property in page slots config.');
    }
    const pagesArray = Object.entries(pages).map(([name5, data]) => PageTransformer.transformFromData(name5, data, defaults));
    return new PageSlotsConfig({
      pages: pagesArray
    });
  }
};
__name(_PageSlotsConfigTransformer, "PageSlotsConfigTransformer");
var PageSlotsConfigTransformer = _PageSlotsConfigTransformer;

// src/configs/plugins-config.ts
var _PluginsConfig = class _PluginsConfig {
  constructor(options) {
    this.plugins = options.plugins;
  }
};
__name(_PluginsConfig, "PluginsConfig");
var PluginsConfig = _PluginsConfig;

// src/entities/plugin.ts
var _Plugin = class _Plugin {
  constructor(options) {
    this.name = options.name;
    this.connector = options.connector;
    this.data = options.data;
  }
  getJsonFormat() {
    return {
      [this.name]: {
        connector: this.connector,
        data: {
          ...this.data
        }
      }
    };
  }
};
__name(_Plugin, "Plugin");
var Plugin = _Plugin;

// src/entities/plugin-transformer.ts
var _PluginTransformer = class _PluginTransformer {
  static transformFromData(name5, data) {
    const { connector, data: pluginData } = data;
    if (!connector) {
      throw new Error(`Must specify "connector" property for plugin "${name5}" in plugins config.`);
    }
    if (typeof connector !== "string") {
      throw new Error(`Invalid "connector" property ("${JSON.stringify(connector)}") supplied to plugin "${name5}" in plugins config.`);
    }
    if (typeof pluginData !== "object") {
      throw new Error(`
        Invalid "data" property supplied to plugin "${name5}" in plugins config.
        
"data" property must be an object containing plugin information (e.g. { ... data: { pluginData: 'testInfo' } })
      `);
    }
    if (Object.keys(pluginData).length === 0) {
      throw new Error(`Must specify data for plugin "${name5}". It cannot be an empty object.`);
    }
    return new Plugin({
      name: name5,
      connector,
      data: pluginData
    });
  }
};
__name(_PluginTransformer, "PluginTransformer");
var PluginTransformer = _PluginTransformer;

// src/configs/plugins-config-transformer.ts
var _PluginsConfigTransformer = class _PluginsConfigTransformer {
  static transformFromJson(json) {
    if (!json.plugins) {
      throw new Error('Must specify "plugins" property in plugins config.');
    }
    const pluginsArray = Object.entries(json.plugins).map(([name5, data]) => PluginTransformer.transformFromData(name5, data));
    return new PluginsConfig({
      plugins: pluginsArray
    });
  }
};
__name(_PluginsConfigTransformer, "PluginsConfigTransformer");
var PluginsConfigTransformer = _PluginsConfigTransformer;

// src/configs/production-config.ts
var _ProductionConfig = class _ProductionConfig {
  constructor(options) {
    this.name = options.name;
    this.metrics = options.metrics;
    this.refresh = options.refresh;
    this.ads = options.ads;
    if (options.plugins) {
      this.plugins = options.plugins;
    }
  }
  toJson() {
    const adsObject = {};
    const pluginsObject = {};
    this.ads.forEach((ad) => {
      const adObject = ad.getJsonFormat();
      const adKey = Object.keys(adObject)[0];
      adsObject[adKey] = adObject[adKey];
    });
    if (this.plugins) {
      this.plugins.forEach((plugin) => {
        const pluginObject = plugin.getJsonFormat();
        const pluginKey = Object.keys(pluginObject)[0];
        pluginsObject[pluginKey] = pluginObject[pluginKey];
      });
    }
    return JSON.stringify({
      metrics: this.metrics,
      plugins: pluginsObject,
      ads: adsObject
    }, null, 2);
  }
};
__name(_ProductionConfig, "ProductionConfig");
var ProductionConfig = _ProductionConfig;

// src/utilities/gpid.ts
var getGpid = /* @__PURE__ */ __name((adSlot) => {
  return `${adSlot.adUnitPath}#${adSlot.divId}`;
}, "getGpid");

// src/entities/production-ad-slot.ts
var _ProductionAdSlot = class _ProductionAdSlot {
  constructor(adUnit, ad) {
    this.name = ad.name;
    this.placement = ad.placement;
    this.sizes = adUnit.sizes;
    if (adUnit.breakpoints) {
      this.breakpoints = adUnit.breakpoints;
    }
    if (ad?.overrides?.breakpoints) {
      this.breakpoints = ad.overrides.breakpoints;
    }
    if (adUnit.metrics) {
      this.metrics = adUnit.metrics;
    }
    if (ad?.overrides?.metrics) {
      this.metrics = ad.overrides.metrics;
    }
    if (adUnit.providers) {
      this.providers = adUnit.providers;
    }
    if (ad?.overrides?.providers) {
      this.providers = ad.overrides.providers;
    }
    if (adUnit.dynamic) {
      this.dynamic = adUnit.dynamic;
    }
    if (ad?.overrides?.dynamic) {
      this.dynamic = ad.overrides.dynamic;
    }
  }
  getJsonFormat() {
    return {
      [this.name]: {
        placement: this.placement,
        sizes: this.sizes,
        breakpoints: this.breakpoints,
        metrics: this.metrics,
        providers: this.providers,
        dynamic: this.dynamic
      }
    };
  }
  getGpid() {
    return getGpid({
      adUnitPath: this.placement,
      divId: this.name
    });
  }
};
__name(_ProductionAdSlot, "ProductionAdSlot");
var ProductionAdSlot = _ProductionAdSlot;

// src/entities/production-ad-slot-transformer.ts
var _ProductionAdSlotTransformer = class _ProductionAdSlotTransformer {
  static transformFromData(adUnitConfig, ad) {
    const adUnit = adUnitConfig.units.find((unit) => unit.name === ad.unit);
    if (!adUnit) {
      throw new Error(`Ad unit "${ad.unit}" is not defined in ad unit config.`);
    }
    return new ProductionAdSlot(adUnit, ad);
  }
  static transformFromJson(name5, data) {
    const {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      placement,
      sizes,
      providers,
      breakpoints,
      metrics,
      dynamic
    } = data;
    if (!sizes) {
      throw new Error('Must specify "sizes" property in production config.');
    }
    if (!isAdSizes(sizes)) {
      throw new Error(`
        Invalid "sizes" property: ("${JSON.stringify(sizes)}") found in production config.
        
"sizes" property must be an array of arrays with dual paired, integer values which specify the width/height of an ad slot (e.g. [[200, 400], [100, 200]]), or the string 'fluid'
      `);
    }
    if (!providers) {
      throw new Error('Must specify "providers" property in production config.');
    }
    if (!isAdUnitProviders(providers)) {
      throw new Error(`
        Invalid "providers" property ("${JSON.stringify(providers)}") found in production config.
        
"providers" property must be an object of valid ad providers (e.g. { "provider1": { data: 0 } }).
      `);
    }
    if (!breakpoints) {
      throw new Error('Must specify "breakpoints" property in production config.');
    }
    if (!isBreakpointTypes(breakpoints)) {
      throw new Error(`
        Invalid "breakpoints" property ("${JSON.stringify(breakpoints)}") found in production config.
        
"breakpoints" property must be an array of valid breakpoints (e.g. ["breakpoint1", "breakpoint2"]).
      `);
    }
    if (metrics && !isAdMetrics(metrics)) {
      throw new Error(`
        Invalid "metrics" property ("${JSON.stringify(metrics)}") found in production config.
        
"metrics" property must be an array of valid metrics (e.g. ["metric1", "metric2"]).
      `);
    }
    if (dynamic && typeof dynamic !== "boolean") {
      throw new Error(`
        Invalid "dynamic" property ("${JSON.stringify(dynamic)}") found in production config.
        
"dynamic" property must be a boolean.
      `);
    }
    const adUnit = new AdUnit({
      name: name5,
      sizes,
      providers,
      breakpoints,
      metrics,
      dynamic
    });
    if (!placement) {
      throw new Error('"placement" property not found in production config!');
    }
    if (typeof data.placement !== "string") {
      throw new Error(`
        Invalid "placement" property for ad "${name5}" in production config!
        
"placement" property must be a string (e.g. "300BTF1").
      `);
    }
    const ad = new Ad({
      name: name5,
      placement
    });
    return new ProductionAdSlot(adUnit, ad);
  }
};
__name(_ProductionAdSlotTransformer, "ProductionAdSlotTransformer");
var ProductionAdSlotTransformer = _ProductionAdSlotTransformer;

// src/configs/production-config-transformer.ts
var _ProductionConfigTransformer = class _ProductionConfigTransformer {
  static transformFromEntities(options) {
    const adsArray = options.page.ads.map((ad) => ProductionAdSlotTransformer.transformFromData(options.adUnitConfig, ad));
    const pluginsArray = options?.pluginsConfig?.plugins;
    return new ProductionConfig({
      name: options.page.name,
      metrics: options.page.metrics,
      refresh: options.page.refresh,
      ads: adsArray,
      plugins: pluginsArray
    });
  }
  static transformFromJson(json) {
    const { metrics, refresh, ads, plugins } = json;
    if (!json.metrics) {
      throw new Error('"metrics" property not found in production config!');
    }
    if (!isPageMetrics(metrics)) {
      throw new Error(`
        Invalid "metrics" property ("${JSON.stringify(metrics)}") found in production config.
        
"metrics" property must be an array of valid metrics (e.g. ["metric1", "metric2"]).
      `);
    }
    if (!refresh) {
      throw new Error('"refresh" property not found in production config!');
    }
    if (!isPageRefresh(refresh)) {
      throw new Error(`
        Invalid "refresh" property ("${JSON.stringify(refresh)}") found in production config.
        
"refresh" property must be a number (e.g. 60).
      `);
    }
    if (!ads) {
      throw new Error('"ads" property not found in production config!');
    }
    const adSlotsArray = Object.entries(ads).map(([name5, data]) => ProductionAdSlotTransformer.transformFromJson(name5, data));
    if (!plugins) {
      throw new Error('"plugins" property not found in production config!');
    }
    const pluginsArray = Object.entries(plugins).map(([name5, data]) => PluginTransformer.transformFromData(name5, data));
    return new ProductionConfig({
      name: "productionConfig",
      metrics,
      refresh,
      ads: adSlotsArray,
      plugins: pluginsArray
    });
  }
  static transformFromOverrides(page, pageOverride, overrideMap) {
    page.ads.forEach((ad) => {
      const adOverride = pageOverride.ads.find((override) => override.name === ad.name);
      if (!adOverride) {
        return;
      }
      if (adOverride.configurations) {
        adOverride.configurations.forEach((configuration) => {
          configuration.rules.forEach((rule) => {
            const { name: name5 } = configuration;
            if (!overrideMap.get(name5)) {
              overrideMap.set(name5, /* @__PURE__ */ new Map());
            }
            if (overrideMap.get(name5)?.get(ad.name)) {
              throw new Error(`
                Configuration override "${name5}" already has an entry for adSlot "${ad.name}"!
                
please check your overrides config to make sure you are not overriding your own overrides!!
              `);
            }
            overrideMap.get(name5)?.set(ad.name, rule);
          });
        });
      }
      if (adOverride.tests) {
        adOverride.tests.forEach((test) => {
          test.variants.forEach((variant) => {
            const name5 = `${test.name}-${variant.name}`;
            if (!overrideMap.get(name5)) {
              overrideMap.set(name5, /* @__PURE__ */ new Map());
            }
            if (overrideMap.get(name5)?.get(ad.name)) {
              throw new Error(`
                AbTest override "${name5}" already has an entry for adSlot "${ad.name}"!
                
please check your overrides config to make sure you are not overriding your own overrides!!
              `);
            }
            overrideMap.get(name5)?.set(ad.name, variant);
          });
        });
      }
    });
  }
};
__name(_ProductionConfigTransformer, "ProductionConfigTransformer");
var ProductionConfigTransformer = _ProductionConfigTransformer;

// src/container/container.ts
import "reflect-metadata";
import { Container } from "inversify";

// src/container/utilities.ts
import { ContainerModule } from "inversify";

// src/utilities/ad-events.ts
var AdEventListeners;
(function(AdEventListeners2) {
  AdEventListeners2["DynamicAdEvent"] = "slickdeals:ads:dynamicAdEvent";
  AdEventListeners2["ReplaceAdEvent"] = "slickdeals:ads:replaceAdEvent";
  AdEventListeners2["DestroyAdsEvent"] = "slickdeals:ads:destroyAdsEvent";
  AdEventListeners2["ReinitializeAdsEvent"] = "slickdeals:ads:reinitializeAdsEvent";
  AdEventListeners2["AdStackInitialized"] = "slickdeals:ads:adStackInitialized";
  AdEventListeners2["InitializeAdEvent"] = "slickdeals:ads:initializeAdEvent";
  AdEventListeners2["AdLoaderReadiness"] = "slickdeals:ads:adLoaderReadiness";
  AdEventListeners2["AdStackConfigurationData"] = "slickdeals:ads:adStackConfigurationData";
  AdEventListeners2["AdRefreshTimerStart"] = "slickdeals:ads:adRefreshTimerStart";
  AdEventListeners2["UserInitiateRefresh"] = "slickdeals:ads:userInitiateRefresh";
})(AdEventListeners || (AdEventListeners = {}));

// src/utilities/await-property.ts
var awaitProperty = /* @__PURE__ */ __name(async (propertyName, obj, numberOfTries = 10, delay = 50) => new Promise((resolve, reject) => {
  if (propertyName in obj && obj[propertyName]) {
    resolve(obj[propertyName]);
  }
  let depth = 0;
  const interval = setInterval(() => {
    if (propertyName in obj && obj[propertyName]) {
      clearInterval(interval);
      resolve(obj[propertyName]);
    } else {
      depth += 1;
      if (depth > numberOfTries) {
        clearInterval(interval);
        reject(new AwaitedPropertyTimeoutError(propertyName, depth * numberOfTries));
      }
    }
  }, delay);
}), "awaitProperty");
var _a;
var AwaitedPropertyTimeoutError = (_a = class extends Error {
  constructor(propertyName, totalWaitTime) {
    const message = `Failed while awaiting property '${propertyName}' for ${totalWaitTime}ms`;
    super(message);
  }
}, __name(_a, "AwaitedPropertyTimeoutError"), _a);

// src/utilities/configuration-loader.ts
import keyd from "keyd";
var configurationKey = "durangoConfiguration";
var _ConfigurationLoader = class _ConfigurationLoader {
  static set(key, value) {
    _ConfigurationLoader.loadConfig();
    if (typeof keyd(_ConfigurationLoader.config).get(key) === "undefined") {
      keyd(_ConfigurationLoader.config).set(key, value);
    } else {
      console.warn(`Attempted to modify an immutable config path: ${key}`);
    }
  }
  static get(key) {
    _ConfigurationLoader.loadConfig();
    return keyd(_ConfigurationLoader.config).get(key);
  }
  static loadConfig() {
    if (typeof _ConfigurationLoader.config === "undefined") {
      _ConfigurationLoader.config = globalThis[configurationKey];
      if (typeof _ConfigurationLoader.config === "undefined") {
        _ConfigurationLoader.config = {};
        console.warn(`Unable to load Configuration object from globalThis['${configurationKey}']`);
      }
    }
  }
  static getConfig() {
    _ConfigurationLoader.loadConfig();
    return _ConfigurationLoader.config;
  }
  static reset() {
    _ConfigurationLoader.config = void 0;
  }
};
__name(_ConfigurationLoader, "ConfigurationLoader");
var ConfigurationLoader = _ConfigurationLoader;

// src/utilities/breakpoints.ts
var getBreakpoint = /* @__PURE__ */ __name((width) => {
  const breakpoints = ConfigurationLoader.get("breakpoints");
  const matchedBreakpoint = Object.values(breakpoints).find((breakpoint) => {
    if (width >= breakpoint.minimum && width < breakpoint.maximum) {
      return breakpoint;
    }
    return false;
  });
  if (!matchedBreakpoint) {
    throw new UnmatchedBreakpointError(width);
  }
  return matchedBreakpoint;
}, "getBreakpoint");
var getBreakpointByName = /* @__PURE__ */ __name((breakpointName) => {
  const { [breakpointName]: breakpoint } = ConfigurationLoader.get("breakpoints");
  return breakpoint;
}, "getBreakpointByName");
var getCurrentBreakpoint = /* @__PURE__ */ __name(() => {
  const width = document.body.offsetWidth;
  return getBreakpoint(width);
}, "getCurrentBreakpoint");
var isCurrentBreakpoint = /* @__PURE__ */ __name((breakpoint) => {
  if (getCurrentBreakpoint() === breakpoint) {
    return true;
  }
  return false;
}, "isCurrentBreakpoint");
var _a2;
var UnmatchedBreakpointError = (_a2 = class extends Error {
  constructor(width) {
    const message = `Unable to determine breakpoint for provided width: ${width}`;
    super(message);
  }
}, __name(_a2, "UnmatchedBreakpointError"), _a2);

// src/utilities/broadcast-channel.ts
import { inject, injectable } from "inversify";
var __decorate = function(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
    r = Reflect.decorate(decorators, target, key, desc);
  else
    for (var i = decorators.length - 1; i >= 0; i--)
      if (d = decorators[i])
        r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = function(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
    return Reflect.metadata(k, v);
};
var __param = function(paramIndex, decorator) {
  return function(target, key) {
    decorator(target, key, paramIndex);
  };
};
var EventNamespace = "sdacbc";
var _a3;
var BroadcastChannel = (_a3 = class {
  constructor(channelName2) {
    this.channelName = channelName2;
  }
  postMessage(message) {
    window.dispatchEvent(new CustomEvent(`${EventNamespace}-message-${this.channelName}`, {
      detail: message
    }));
  }
  addEventListener(type, listener) {
    window.addEventListener(`${EventNamespace}-${type}-${this.channelName}`, listener);
  }
  close() {
  }
}, __name(_a3, "BroadcastChannel"), _a3);
BroadcastChannel = __decorate([
  injectable(),
  __param(0, inject("ChannelName")),
  __metadata("design:type", Function),
  __metadata("design:paramtypes", [
    String
  ])
], BroadcastChannel);

// src/utilities/dataLayer.ts
var DataLayer = {
  get(key) {
    return window.dataLayer[key];
  }
};

// src/utilities/observable.ts
import { injectable as injectable2, unmanaged } from "inversify";
import { Subject as RxSubject } from "rxjs";
var __decorate2 = function(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
    r = Reflect.decorate(decorators, target, key, desc);
  else
    for (var i = decorators.length - 1; i >= 0; i--)
      if (d = decorators[i])
        r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata2 = function(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
    return Reflect.metadata(k, v);
};
var __param2 = function(paramIndex, decorator) {
  return function(target, key) {
    decorator(target, key, paramIndex);
  };
};
var _a4;
var Observable = (_a4 = class {
  /**
  * @param subject A class extending from the RxJS Subject class, used as the subject type for this observable
  */
  constructor(subject) {
    this.subject = subject;
  }
  /**
  * Fire off an "event" to any subscribers
  *
  * @param data The data to be sent to any subscribers
  */
  notify(data) {
    this.subject.next(data);
  }
  /**
  * Register a new subscriber to be notified when the observable fires off new events
  *
  * @param observer The function to be called when new data is sent to the observable
  */
  subscribe(observer) {
    return this.subject.subscribe(observer);
  }
  /**
  * Remove a subscriber from the observers that get notified with updates
  *
  * @param subscription The subscription object returned by Observable.subscribe()
  */
  static unsubscribe(subscription) {
    subscription.unsubscribe();
  }
  /**
  * Get the RxJS Observable object for further manipulation via streams
  */
  getObservable() {
    return this.subject.asObservable();
  }
}, __name(_a4, "Observable"), _a4);
Observable = __decorate2([
  injectable2(),
  __param2(0, unmanaged()),
  __metadata2("design:type", Function),
  __metadata2("design:paramtypes", [
    typeof RxSubject === "undefined" ? Object : RxSubject
  ])
], Observable);

// src/utilities/logger.ts
var _Logger = class _Logger {
  static debug(...args) {
    return _Logger.parser(console.debug, ...args);
  }
  static error(...args) {
    return _Logger.parser(console.error, ...args);
  }
  static log(...args) {
    return _Logger.parser(console.log, ...args);
  }
  static warn(...args) {
    return _Logger.parser(console.warn, ...args);
  }
  static parser(logFunction, ...args) {
    if (_Logger.isEnabled) {
      return logFunction(...args);
    }
  }
  static setIsEnabled(isEnabled) {
    _Logger.isEnabled = isEnabled;
  }
};
__name(_Logger, "Logger");
__publicField(_Logger, "isEnabled", false);
var Logger = _Logger;

// src/utilities/replay-observable.ts
import { ReplaySubject } from "rxjs";
import { injectable as injectable3 } from "inversify";
var __decorate3 = function(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
    r = Reflect.decorate(decorators, target, key, desc);
  else
    for (var i = decorators.length - 1; i >= 0; i--)
      if (d = decorators[i])
        r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata3 = function(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
    return Reflect.metadata(k, v);
};
var _a5;
var ReplayObservable = (_a5 = class extends Observable {
  constructor() {
    super(new ReplaySubject());
  }
}, __name(_a5, "ReplayObservable"), _a5);
ReplayObservable = __decorate3([
  injectable3(),
  __metadata3("design:type", Function),
  __metadata3("design:paramtypes", [])
], ReplayObservable);

// src/utilities/interval-timer.ts
var _timer, _startTime, _remainingTime, _intervalTime, _paused, _stopped, _originalIntervalTime, _savedCallback;
var _IntervalTimer = class _IntervalTimer {
  constructor(callback, timeout) {
    __privateAdd(this, _timer, void 0);
    __privateAdd(this, _startTime, void 0);
    __privateAdd(this, _remainingTime, void 0);
    __privateAdd(this, _intervalTime, void 0);
    __privateAdd(this, _paused, void 0);
    __privateAdd(this, _stopped, void 0);
    __privateAdd(this, _originalIntervalTime, void 0);
    __privateAdd(this, _savedCallback, void 0);
    __privateSet(this, _originalIntervalTime, timeout);
    __privateSet(this, _savedCallback, callback);
    __privateSet(this, _paused, false);
    __privateSet(this, _stopped, false);
    this.start();
  }
  /**
  * Starts the timer with original timer settings
  */
  start() {
    if (__privateGet(this, _timer)) {
      window.clearInterval(__privateGet(this, _timer));
    }
    if (__privateGet(this, _paused)) {
      __privateSet(this, _paused, false);
    }
    if (__privateGet(this, _stopped)) {
      __privateSet(this, _stopped, false);
    }
    __privateSet(this, _intervalTime, __privateGet(this, _originalIntervalTime));
    __privateSet(this, _remainingTime, __privateGet(this, _originalIntervalTime));
    __privateSet(this, _startTime, Date.now());
    __privateSet(this, _timer, window.setInterval(() => {
      __privateGet(this, _savedCallback).call(this);
      __privateSet(this, _startTime, Date.now());
    }, __privateGet(this, _intervalTime)));
  }
  /**
  * Pauses the timer by recording the remaining time left on the interval, then clearing the setInterval
  */
  pause() {
    if (__privateGet(this, _paused) || __privateGet(this, _stopped)) {
      return;
    }
    __privateSet(this, _paused, true);
    __privateSet(this, _remainingTime, __privateGet(this, _intervalTime) - (Date.now() - __privateGet(this, _startTime)));
    window.clearInterval(__privateGet(this, _timer));
  }
  /**
  * Resumes the timer by setting a timeout for the recorded remaining them, then renews an interval timer
  */
  resume() {
    if (!__privateGet(this, _remainingTime) || __privateGet(this, _stopped)) {
      return;
    }
    if (__privateGet(this, _paused)) {
      __privateSet(this, _paused, false);
    }
    __privateSet(this, _intervalTime, __privateGet(this, _remainingTime));
    __privateSet(this, _startTime, Date.now());
    __privateSet(this, _timer, window.setTimeout(() => {
      __privateGet(this, _savedCallback).call(this);
      __privateSet(this, _startTime, Date.now());
      __privateSet(this, _intervalTime, __privateGet(this, _originalIntervalTime));
      __privateSet(this, _timer, window.setInterval(() => {
        __privateGet(this, _savedCallback).call(this);
        __privateSet(this, _startTime, Date.now());
      }, __privateGet(this, _intervalTime)));
    }, __privateGet(this, _intervalTime)));
  }
  /**
  * Resets the timer to a certain time left, regardless of remaining time, then renews an interval timer
  *
  * @param {number} milliseconds number of milliseconds the resetted timer has
  */
  reset(milliseconds) {
    if (!__privateGet(this, _timer)) {
      return;
    }
    if (__privateGet(this, _paused)) {
      __privateSet(this, _paused, false);
    }
    window.clearInterval(__privateGet(this, _timer));
    const remainingTime = __privateGet(this, _intervalTime) - (Date.now() - __privateGet(this, _startTime));
    __privateSet(this, _intervalTime, milliseconds > remainingTime ? milliseconds : remainingTime);
    __privateSet(this, _startTime, Date.now());
    __privateSet(this, _timer, window.setTimeout(() => {
      __privateGet(this, _savedCallback).call(this);
      __privateSet(this, _startTime, Date.now());
      __privateSet(this, _intervalTime, __privateGet(this, _originalIntervalTime));
      __privateSet(this, _timer, window.setInterval(() => {
        __privateGet(this, _savedCallback).call(this);
        __privateSet(this, _startTime, Date.now());
      }, __privateGet(this, _intervalTime)));
    }, __privateGet(this, _intervalTime)));
  }
  /**
  * Stops the timer by clearing the current setInterval
  */
  stop() {
    if (!__privateGet(this, _timer)) {
      return;
    }
    window.clearInterval(__privateGet(this, _timer));
    __privateSet(this, _stopped, true);
  }
  /**
  * Gets the remaining time left on the timer
  */
  getRemainingTime() {
    return __privateGet(this, _intervalTime) - (Date.now() - __privateGet(this, _startTime));
  }
};
_timer = new WeakMap();
_startTime = new WeakMap();
_remainingTime = new WeakMap();
_intervalTime = new WeakMap();
_paused = new WeakMap();
_stopped = new WeakMap();
_originalIntervalTime = new WeakMap();
_savedCallback = new WeakMap();
__name(_IntervalTimer, "IntervalTimer");
var IntervalTimer = _IntervalTimer;

// src/container/utilities.ts
import { ReplaySubject as ReplaySubject2 } from "rxjs";
var utilities = new ContainerModule((bind) => {
  bind("BroadcastChannel").to(BroadcastChannel);
  bind("ReplayObservable").to(ReplayObservable);
  bind("ReplaySubject<AdPlatformEvent>").to(ReplaySubject2);
});

// src/container/core.ts
import { ContainerModule as ContainerModule2 } from "inversify";

// src/controllers/ad-event-manager.ts
import { filter, iif } from "rxjs";
import { injectable as injectable4, inject as inject2 } from "inversify";

// src/controllers/ad-event.ts
var PlatformName = "modern";
var isEventType = /* @__PURE__ */ __name((eventType) => typeof eventType === "string" && Object.values(EventTypes).includes(eventType), "isEventType");
var isAdEventObject = /* @__PURE__ */ __name((eventObject) => typeof eventObject === "object" && "adUnitId" in eventObject, "isAdEventObject");
var _AdEvent = class _AdEvent {
  static create(eventType, pageName, data) {
    let eventData = {};
    let eventRuntime;
    let startEvent = "";
    const breakpoint = getCurrentBreakpoint();
    if (typeof data !== "undefined") {
      if (_AdEvent.isAdEventType(eventType)) {
        eventData = _AdEvent.transformToAdEventData(data);
      } else if (_AdEvent.isPageEventType(eventType)) {
        eventData = _AdEvent.transformToPageEventData(data);
      }
    }
    if (isRefreshMetrics([
      eventType
    ])) {
      startEvent = EventTypes.RefreshBiddingStarted;
    } else if (isDynamicMetrics([
      eventType
    ])) {
      startEvent = EventTypes.DynamicBiddingStarted;
    } else if (isReinitializeMetrics([
      eventType
    ])) {
      startEvent = EventTypes.ReinitializeBiddingStarted;
    }
    if (startEvent) {
      try {
        const measure = performance.measure("fetchAdDuration", startEvent);
        eventRuntime = measure.duration;
      } catch (e) {
        eventRuntime = performance.now();
      }
    } else {
      eventRuntime = performance.now();
    }
    return {
      event: eventType,
      timestamp: Date.now(),
      platform: PlatformName,
      eventRuntime,
      breakpoint: breakpoint.name,
      pageName,
      ...eventData
    };
  }
  static isPageEventType(eventType) {
    return pageEventTypes.includes(eventType);
  }
  static isAdEventType(eventType) {
    return adEventTypes.includes(eventType);
  }
  static transformToAdEventData(data) {
    let adUnitId = "";
    if (data.adUnitId && typeof data.adUnitId === "string") {
      adUnitId = data.adUnitId;
    }
    const adEventData = {
      adUnitId
    };
    if (data.provider) {
      adEventData.provider = data.provider;
    }
    if (data.adPath) {
      adEventData.adPath = data.adPath;
    }
    return adEventData;
  }
  static transformToPageEventData(data) {
    const pageEventData = {};
    if (data.numberOfAds) {
      pageEventData.numberOfAds = data.numberOfAds;
    }
    return pageEventData;
  }
};
__name(_AdEvent, "AdEvent");
var AdEvent = _AdEvent;

// src/controllers/ad-event-manager.ts
var __decorate4 = function(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
    r = Reflect.decorate(decorators, target, key, desc);
  else
    for (var i = decorators.length - 1; i >= 0; i--)
      if (d = decorators[i])
        r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata4 = function(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
    return Reflect.metadata(k, v);
};
var __param3 = function(paramIndex, decorator) {
  return function(target, key) {
    decorator(target, key, paramIndex);
  };
};
var channelName = "durango.adPlatform";
var _a6;
var AdEventManager = (_a6 = class {
  /**
  * @param channel observers/BroadcastChannel instance
  * @param observable observers/ReplayObservable instance
  * @param adEvent ads/AdEvent instance
  */
  constructor(observable, channel) {
    this.observable = observable;
    this.channel = channel;
    this.channel.addEventListener("message", (event) => {
      let eventData = null;
      if (event instanceof CustomEvent) {
        eventData = event.detail;
      } else if (event instanceof MessageEvent) {
        eventData = event.data;
      }
      if (!eventData) {
        return;
      }
      this.observable.notify(eventData);
    });
  }
  /**
  * Sends the page's name down to ad event to be registered
  *
  * @param pageName the name of the entrypoint/page
  */
  registerPageName(pageName) {
    this.pageName = pageName;
  }
  /**
  * Fire an event to send data to all observers
  *
  * @param eventType The type of event to be fired, from the Events enum
  * @param data Additional data that can be appended to the object fired with the even (optional)
  */
  async fire(eventType, data) {
    const event = AdEvent.create(eventType, this.pageName, data);
    this.channel.postMessage(event);
  }
  subscribe(observerOrEventType, optionalObserver) {
    let eventType;
    let observer;
    if (isEventType(observerOrEventType)) {
      eventType = observerOrEventType;
      observer = optionalObserver;
    } else {
      observer = observerOrEventType;
    }
    return iif(() => typeof eventType === "undefined", this.observable.getObservable(), this.observable.getObservable().pipe(filter((event) => event.event === eventType))).subscribe(observer);
  }
}, __name(_a6, "AdEventManager"), _a6);
AdEventManager = __decorate4([
  injectable4(),
  __param3(0, inject2("ReplayObservable")),
  __param3(1, inject2("BroadcastChannel")),
  __metadata4("design:type", Function),
  __metadata4("design:paramtypes", [
    typeof ReplayObservable === "undefined" ? Object : ReplayObservable,
    typeof BroadcastChannel === "undefined" ? Object : BroadcastChannel
  ])
], AdEventManager);

// src/controllers/adblock-detect.ts
import { inject as inject3, injectable as injectable5 } from "inversify";
var __decorate5 = function(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
    r = Reflect.decorate(decorators, target, key, desc);
  else
    for (var i = decorators.length - 1; i >= 0; i--)
      if (d = decorators[i])
        r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata5 = function(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
    return Reflect.metadata(k, v);
};
var __param4 = function(paramIndex, decorator) {
  return function(target, key) {
    decorator(target, key, paramIndex);
  };
};
var isConfigurationOptions = /* @__PURE__ */ __name((options) => typeof options === "object" && "endpoints" in options, "isConfigurationOptions");
var AdBlockEndpointNamespace = "adBlockEndpoints";
var _a7;
var AdblockDetect = (_a7 = class {
  constructor(eventManager) {
    this.eventManager = eventManager;
    this.endpoints = /* @__PURE__ */ new Set();
    const configOptions = ConfigurationLoader.get(AdBlockEndpointNamespace);
    if (!isConfigurationOptions(configOptions)) {
      return;
    }
    configOptions.endpoints.forEach((endpoint) => {
      this.endpoints.add(endpoint);
    });
    void this.detectAdblock();
  }
  async detectAdblock() {
    const isBlocked = await this.isAdBlocked();
    if (isBlocked) {
      await this.eventManager.fire(EventTypes.AdblockDetected);
    }
  }
  async isAdBlocked() {
    let isBlocked = false;
    for (const endpoint of this.endpoints.values()) {
      if (isBlocked) {
        break;
      }
      try {
        await fetch(endpoint, {
          method: "HEAD",
          mode: "no-cors"
        });
        isBlocked = false;
      } catch (e) {
        isBlocked = true;
      }
    }
    return isBlocked;
  }
}, __name(_a7, "AdblockDetect"), _a7);
AdblockDetect = __decorate5([
  injectable5(),
  __param4(0, inject3("AdEventManager")),
  __metadata5("design:type", Function),
  __metadata5("design:paramtypes", [
    typeof AdEventManager === "undefined" ? Object : AdEventManager
  ])
], AdblockDetect);

// src/controllers/ad-configuration-loader.ts
import { injectable as injectable6 } from "inversify";
var __decorate6 = function(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
    r = Reflect.decorate(decorators, target, key, desc);
  else
    for (var i = decorators.length - 1; i >= 0; i--)
      if (d = decorators[i])
        r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var scriptTagId = "productionConfig";
var _a8;
var AdConfigurationLoader = (_a8 = class {
  static loadConfig() {
    const scriptElement = document.getElementById(scriptTagId);
    if (!scriptElement) {
      throw new Error("config not loaded, script tag not found!");
    }
    const config = ProductionConfigTransformer.transformFromJson(JSON.parse(scriptElement.textContent));
    return config;
  }
}, __name(_a8, "AdConfigurationLoader"), _a8);
AdConfigurationLoader = __decorate6([
  injectable6()
], AdConfigurationLoader);

// src/controllers/ad-controller.ts
import { injectable as injectable12, inject as inject7 } from "inversify";

// src/controllers/feature-flag-loader.ts
import { injectable as injectable7 } from "inversify";
var __decorate7 = function(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
    r = Reflect.decorate(decorators, target, key, desc);
  else
    for (var i = decorators.length - 1; i >= 0; i--)
      if (d = decorators[i])
        r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata6 = function(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
    return Reflect.metadata(k, v);
};
var featureFlagLoaderScriptId = "featureFlags";
var FlagTypes;
(function(FlagTypes2) {
  FlagTypes2["Providers"] = "providers";
  FlagTypes2["Plugins"] = "plugins";
  FlagTypes2["Features"] = "features";
})(FlagTypes || (FlagTypes = {}));
var Features;
(function(Features2) {
  Features2["Refresh"] = "refresh";
  Features2["Sticky"] = "sticky";
  Features2["Events"] = "events";
})(Features || (Features = {}));
var _a9;
var FeatureFlagLoader = (_a9 = class {
  constructor() {
    // The providers from the feature flag object
    __publicField(this, "providers", /* @__PURE__ */ new Map());
    // The plugins from the feature flag object
    __publicField(this, "plugins", /* @__PURE__ */ new Map());
    // The features from the feature flag object
    __publicField(this, "features", /* @__PURE__ */ new Map());
    Object.values(Features).forEach((feature) => {
      this.features.set(feature, true);
    });
  }
  /**
  * Loads the feature flag settings from the embedded <script> tag
  */
  init() {
    const scriptElement = document.getElementById(featureFlagLoaderScriptId);
    if (typeof scriptElement !== "undefined") {
      const featureFlags = JSON.parse(scriptElement.textContent);
      _a9.initFeature(FlagTypes.Providers, this.providers, featureFlags);
      _a9.initFeature(FlagTypes.Plugins, this.plugins, featureFlags);
      _a9.initFeature(FlagTypes.Features, this.features, featureFlags);
    }
  }
  /**
  * Set the class properties for each feature flag type from the parsed JSON
  *
  * @param type Type of feature being initialized
  * @param flagMap The class property to set the flags on
  * @param featureFlags The parsed JSON object
  */
  static initFeature(type, flagMap, featureFlags) {
    if (type in featureFlags) {
      Object.entries(featureFlags[type]).forEach(([flagName, isEnabled]) => {
        flagMap.set(flagName, isEnabled);
      });
    }
  }
  /**
  * Get a collection of enabled providers
  *
  * @returns Array of enabled provider slugs
  */
  getEnabledProviders() {
    return _a9.getEnabledFlags(this.providers);
  }
  /**
  * Get a collection of enabled plugins
  *
  * @returns Array of enabled plugin slugs
  */
  getEnabledPlugins() {
    return _a9.getEnabledFlags(this.plugins);
  }
  /**
  * Get a collection of enabled features
  *
  * @returns Array of enabled feature slugs
  */
  getEnabledFeatures() {
    return _a9.getEnabledFlags(this.features);
  }
  /**
  *
  * @param flagMap The source for filtering the enabled flags
  *
  * @returns Array containing slug of all enabled flags
  */
  static getEnabledFlags(flagMap) {
    const enabledFlags = [];
    flagMap.forEach((isEnabled, flagName) => {
      if (isEnabled) {
        enabledFlags.push(flagName);
      }
    });
    return enabledFlags;
  }
  /**
  * Check if specified provider is enabled. If the provided slug is not found in the parsed flags, false is returned.
  *
  * @param providerSlug Provider slug to check flag status of
  */
  isProviderEnabled(providerSlug) {
    return this.providers.has(providerSlug) ? this.providers.get(providerSlug) : false;
  }
  /**
  * Check if specified plugin is enabled.  If the provided slug is not found in the parsed flags, false is returned.
  *
  * @param pluginSlug Plugin slug to check flag status of
  */
  isPluginEnabled(pluginSlug) {
    return this.plugins.has(pluginSlug) ? this.plugins.get(pluginSlug) : false;
  }
  /**
  * Check if specified feature is enabled.  If the provided slug is not found in the parsed flags, true is returned.
  *
  * @param featureSlug Feature slug to check flag status of
  */
  isFeatureEnabled(featureSlug) {
    return this.features.has(featureSlug) ? this.features.get(featureSlug) : true;
  }
}, __name(_a9, "FeatureFlagLoader"), _a9);
FeatureFlagLoader = __decorate7([
  injectable7(),
  __metadata6("design:type", Function),
  __metadata6("design:paramtypes", [])
], FeatureFlagLoader);

// src/controllers/ad-unit-manager.ts
import { injectable as injectable8, inject as inject4 } from "inversify";
var __decorate8 = function(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
    r = Reflect.decorate(decorators, target, key, desc);
  else
    for (var i = decorators.length - 1; i >= 0; i--)
      if (d = decorators[i])
        r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata7 = function(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
    return Reflect.metadata(k, v);
};
var __param5 = function(paramIndex, decorator) {
  return function(target, key) {
    decorator(target, key, paramIndex);
  };
};
var _a10;
var AdUnitManager = (_a10 = class {
  constructor(eventManager) {
    this.eventManager = eventManager;
    this.adUnits = /* @__PURE__ */ new Map();
  }
  init(config) {
    this.loadAdUnits(config.ads);
  }
  getAdUnits() {
    return this.adUnits;
  }
  /**
  * Registers an ad unit to the ad unit manager and observes it.
  *
  * @param config the config data of the ad unit being registered.
  */
  registerAd(config, adContainer) {
    if (this.adUnits.has(config.name)) {
      return;
    }
    if (adContainer && adContainer instanceof HTMLElement) {
      this.adUnits.set(config.name, adContainer);
    }
  }
  /**
  * Replaces an ad unit already registered to the ad unit manager and re-observes it.
  *
  * @param config the config data of the ad unit being registered.
  */
  replaceAd(config, adContainer) {
    if (!this.adUnits.has(config.name)) {
      return;
    }
    if (adContainer && adContainer instanceof HTMLElement) {
      this.adUnits.set(config.name, adContainer);
    }
  }
  /**
  * Clears all ads from the ad unit manager
  */
  clearAds() {
    this.adUnits.clear();
  }
  loadAdUnits(adUnits) {
    adUnits.forEach((adUnit) => {
      if (adUnit.dynamic) {
        return;
      }
      const adContainer = document.getElementById(adUnit.name);
      if (adContainer && adContainer instanceof HTMLElement) {
        this.adUnits.set(adUnit.name, adContainer);
      }
    });
  }
}, __name(_a10, "AdUnitManager"), _a10);
AdUnitManager = __decorate8([
  injectable8(),
  __param5(0, inject4("AdEventManager")),
  __metadata7("design:type", Function),
  __metadata7("design:paramtypes", [
    typeof AdEventManager === "undefined" ? Object : AdEventManager
  ])
], AdUnitManager);

// src/controllers/plugin-manager.ts
import { injectable as injectable9 } from "inversify";

// src/controllers/plugin-adapter.ts
var hasInit = /* @__PURE__ */ __name((x) => x.init !== void 0, "hasInit");
var hasStart = /* @__PURE__ */ __name((x) => x.start !== void 0, "hasStart");
var hasStop = /* @__PURE__ */ __name((x) => x.stop !== void 0, "hasStop");
var hasDestroy = /* @__PURE__ */ __name((x) => x.destroy !== void 0, "hasDestroy");
var isPluginAdapter = /* @__PURE__ */ __name((x) => {
  if (x === void 0) {
    return false;
  }
  return hasInit(x) && hasStart(x);
}, "isPluginAdapter");
var isDestroyablePlugin = /* @__PURE__ */ __name((x) => {
  if (!isPluginAdapter(x)) {
    return false;
  }
  return hasStop(x) && hasDestroy(x);
}, "isDestroyablePlugin");

// src/controllers/plugin-manager.ts
var __decorate9 = function(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
    r = Reflect.decorate(decorators, target, key, desc);
  else
    for (var i = decorators.length - 1; i >= 0; i--)
      if (d = decorators[i])
        r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var _a11;
var PluginManager = (_a11 = class {
  constructor() {
    __publicField(this, "pluginAdapters", /* @__PURE__ */ new Map());
  }
  init(config, enabledPlugins) {
    enabledPlugins.forEach((pluginName) => {
      const pluginAdapter = container.get(pluginName);
      if (!isPluginAdapter(pluginAdapter)) {
        return;
      }
      pluginAdapter.init(config);
      this.pluginAdapters.set(pluginName, pluginAdapter);
    });
  }
  start() {
    this.pluginAdapters.forEach((pluginAdapter) => {
      if (!isPluginAdapter(pluginAdapter)) {
        return;
      }
      pluginAdapter.start();
    });
  }
  stop(plugins) {
    plugins.forEach((pluginName) => {
      const plugin = this.pluginAdapters.get(pluginName);
      if (!isDestroyablePlugin(plugin)) {
        return;
      }
      plugin.stop();
    });
  }
  /**
  * Destroys all destroyable plugins registered or a specified list of plugins
  *
  * @param plugins Array of plugin names to be destroyed
  */
  destroy(plugins) {
    if (!plugins) {
      this.pluginAdapters.forEach((pluginAdapter, pluginName) => {
        if (!isDestroyablePlugin(pluginAdapter)) {
          return;
        }
        pluginAdapter.destroy();
        this.pluginAdapters.delete(pluginName);
      });
    } else {
      plugins.forEach((pluginName) => {
        const plugin = this.pluginAdapters.get(pluginName);
        if (!isDestroyablePlugin(plugin)) {
          return;
        }
        plugin.destroy();
        this.pluginAdapters.delete(pluginName);
      });
    }
  }
}, __name(_a11, "PluginManager"), _a11);
PluginManager = __decorate9([
  injectable9()
], PluginManager);

// src/controllers/provider-manager.ts
import { injectable as injectable10, inject as inject5 } from "inversify";

// src/controllers/provider-adapter.ts
var hasInit2 = /* @__PURE__ */ __name((x) => x.init !== void 0, "hasInit");
var hasInitAdUnit = /* @__PURE__ */ __name((x) => x.initAdUnit !== void 0, "hasInitAdUnit");
var hasStart2 = /* @__PURE__ */ __name((x) => x.start !== void 0, "hasStart");
var hasUnload = /* @__PURE__ */ __name((x) => x.unload !== void 0, "hasUnload");
var hasDestroy2 = /* @__PURE__ */ __name((x) => x.destroy !== void 0, "hasDestroy");
var isProviderAdapter = /* @__PURE__ */ __name((x) => {
  if (!x) {
    return false;
  }
  return hasInit2(x) && hasInitAdUnit(x) && hasStart2(x) && hasUnload(x) && hasDestroy2(x);
}, "isProviderAdapter");

// src/controllers/provider-manager.ts
var __decorate10 = function(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
    r = Reflect.decorate(decorators, target, key, desc);
  else
    for (var i = decorators.length - 1; i >= 0; i--)
      if (d = decorators[i])
        r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata8 = function(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
    return Reflect.metadata(k, v);
};
var __param6 = function(paramIndex, decorator) {
  return function(target, key) {
    decorator(target, key, paramIndex);
  };
};
var _a12;
var ProviderManager = (_a12 = class {
  constructor(eventManager) {
    this.eventManager = eventManager;
    this.adSlots = /* @__PURE__ */ new Map();
    this.providerAdapters = /* @__PURE__ */ new Map();
  }
  async init(config, enabledProviders) {
    config.ads.forEach((ad) => {
      const currentBreakpoint = getCurrentBreakpoint().name;
      const supported = ad.breakpoints;
      if (ad.dynamic) {
        return;
      }
      if (!(supported.includes(currentBreakpoint) || currentBreakpoint === "tablet" && supported.includes("desktop"))) {
        return;
      }
      this.adSlots.set(ad.name, ad);
    });
    const initProviders = enabledProviders.map(async (providerName) => {
      const providerAdapter = container.get(providerName);
      if (!isProviderAdapter(providerAdapter)) {
        return;
      }
      const isInitialized = await providerAdapter.init();
      if (!isInitialized) {
        return;
      }
      this.providerAdapters.set(providerName, providerAdapter);
    });
    await Promise.all(initProviders);
    this.initAdUnits(this.adSlots);
  }
  initAdUnits(adUnits) {
    adUnits.forEach((adUnit) => {
      Object.entries(adUnit.providers).forEach(([providerName, providerData]) => {
        const adapter = this.providerAdapters.get(providerName);
        if (!adapter) {
          return;
        }
        adapter.initAdUnit(adUnit, providerData);
      });
    });
  }
  /**
  * Registers an ad unit to the ad unit manager and starts bidding on it.
  *
  * @param config the config data of the ad unit being registered.
  */
  registerAd(config) {
    if (!this.adSlots.get(config.name)) {
      this.adSlots.set(config.name, config);
      Object.entries(config.providers).forEach(([providerName, providerData]) => {
        const adapter = this.providerAdapters.get(providerName);
        if (!adapter) {
          return;
        }
        adapter.initAdUnit(config, providerData);
        adapter.start(config.name);
      });
    }
  }
  /**
  * Replaces an ad unit already registered to the ad unit manager and restarts bidding on it.
  *
  * @param config the config data of the ad unit being registered.
  */
  replaceAd(config) {
    if (!this.adSlots.get(config.name)) {
      return;
    }
    this.adSlots.set(config.name, config);
    Object.entries(config.providers).forEach(([providerName, providerData]) => {
      const adapter = this.providerAdapters.get(providerName);
      if (!adapter) {
        return;
      }
      adapter.initAdUnit(config, providerData);
      adapter.start(config.name);
    });
  }
  /**
  * Clears all ads from the ad refresh manager
  */
  clearAds() {
    this.adSlots.clear();
  }
  start(adUnits) {
    Array.from(adUnits.keys()).forEach((adUnitId) => {
      const adSlot = this.adSlots.get(adUnitId);
      if (!adSlot) {
        return;
      }
      Object.keys(adSlot.providers).forEach((providerName) => {
        const adapter = this.providerAdapters.get(providerName);
        if (!adapter) {
          return;
        }
        adapter.start(adUnitId);
      });
    });
  }
  refresh(adUnitId) {
    const adSlot = this.adSlots.get(adUnitId);
    if (!adSlot) {
      return;
    }
    Object.keys(adSlot.providers).forEach((providerName) => {
      const adapter = this.providerAdapters.get(providerName);
      if (!adapter) {
        return;
      }
      adapter.start(adUnitId, true);
    });
  }
  refreshAllAds() {
    this.adSlots.forEach((adSlot) => {
      Object.keys(adSlot.providers).forEach((providerName) => {
        const adapter = this.providerAdapters.get(providerName);
        if (!adapter) {
          return;
        }
        adapter.start(adSlot.name, true);
      });
    });
  }
  unload(adUnitId) {
    const adSlot = this.adSlots.get(adUnitId);
    if (!adSlot) {
      return;
    }
    Object.keys(adSlot.providers).forEach((providerName) => {
      const adapter = this.providerAdapters.get(providerName);
      if (!adapter) {
        return;
      }
      adapter.unload(adUnitId);
    });
  }
  destroy(adUnitId) {
    const adSlot = this.adSlots.get(adUnitId);
    if (!adSlot) {
      return;
    }
    Object.keys(adSlot.providers).forEach((providerName) => {
      const adapter = this.providerAdapters.get(providerName);
      if (!adapter) {
        return;
      }
      adapter.destroy(adUnitId);
    });
  }
}, __name(_a12, "ProviderManager"), _a12);
ProviderManager = __decorate10([
  injectable10(),
  __param6(0, inject5("AdEventManager")),
  __metadata8("design:type", Function),
  __metadata8("design:paramtypes", [
    typeof AdEventManager === "undefined" ? Object : AdEventManager
  ])
], ProviderManager);

// src/controllers/ad-refresh-manager.ts
import { injectable as injectable11, inject as inject6 } from "inversify";

// src/utilities/ad-debug.ts
var prefix = "Ad Stack debug:";
var isAdDebugSwitchEnabled = /* @__PURE__ */ __name(() => {
  if (typeof window.isAdDebugEnabled === "undefined") {
    window.isAdDebugEnabled = !!window.location?.host?.endsWith(".dev");
  }
  return window.isAdDebugEnabled;
}, "isAdDebugSwitchEnabled");
var printDebug = /* @__PURE__ */ __name((message, ...args) => {
  Logger.setIsEnabled(isAdDebugSwitchEnabled());
  Logger.debug(`${prefix} ${message}`, ...args);
}, "printDebug");

// src/controllers/ad-refresh-manager.ts
var __decorate11 = function(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
    r = Reflect.decorate(decorators, target, key, desc);
  else
    for (var i = decorators.length - 1; i >= 0; i--)
      if (d = decorators[i])
        r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata9 = function(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
    return Reflect.metadata(k, v);
};
var __param7 = function(paramIndex, decorator) {
  return function(target, key) {
    decorator(target, key, paramIndex);
  };
};
var AdThresholds;
(function(AdThresholds2) {
  AdThresholds2[AdThresholds2["HalfVisible"] = 0.5] = "HalfVisible";
  AdThresholds2[AdThresholds2["NonVisible"] = 0] = "NonVisible";
})(AdThresholds || (AdThresholds = {}));
var RefreshStrategy;
(function(RefreshStrategy2) {
  RefreshStrategy2["Control"] = "control";
  RefreshStrategy2["Mobile"] = "mobile";
  RefreshStrategy2["Test"] = "test";
})(RefreshStrategy || (RefreshStrategy = {}));
var _a13;
var AdRefreshManager = (_a13 = class {
  constructor(adUnitManager, providerManager, eventManager) {
    this.adUnitManager = adUnitManager;
    this.providerManager = providerManager;
    this.eventManager = eventManager;
    this.adTimers = /* @__PURE__ */ new Map();
    this.visibleAds = /* @__PURE__ */ new Set();
    this.viewableAds = /* @__PURE__ */ new Set();
    this.scrolledPastAds = /* @__PURE__ */ new Set();
    this.refreshStrategy = "";
    this.refreshQueued = false;
  }
  init(config) {
    this.currentBreakpoint = getCurrentBreakpoint().name;
    this.registerAdUnits(config.ads);
    this.adRefreshTimer = config.refresh.rate;
    this.adRefreshLimit = config.refresh.limit;
    this.currentRefreshes = 0;
    this.globalRefreshCooldown = 10;
    this.configureRefreshStrategy(this.refreshStrategy);
  }
  setRefreshStrategy(strategy) {
    this.refreshStrategy = strategy;
  }
  configureRefreshStrategy(strategy) {
    this.registerObservers();
    if (this.currentBreakpoint !== "mobile" && strategy !== RefreshStrategy.Mobile) {
      document.addEventListener(AdEventListeners.AdRefreshTimerStart, () => {
        this.refreshInterval = new IntervalTimer(this.handleRefreshInterval.bind(this), this.adRefreshTimer * 1e3);
      }, {
        once: true
      });
    }
    document.addEventListener(AdEventListeners.UserInitiateRefresh, () => this.userInitiateRefresh());
    return;
  }
  /**
  * Registers an ad unit to the ad refresh manager and observes it.
  *
  * @param config the config data of the ad unit being registered.
  */
  registerAd(config, adElement) {
    if (!this.refreshStrategy)
      return;
    if (!this.adUnits.has(config.name)) {
      this.adUnits.set(config.name, adElement);
    }
    if (!this.adTimers.has(config.name)) {
      this.adTimers.set(config.name, {
        refreshes: 0,
        lastRefresh: Date.now()
      });
    }
    this.observer.observe(adElement);
  }
  /**
  * Replaces an ad unit already registered with the ad refresh manager and re-observes it.
  *
  * @param config the config data of the ad unit being registered.
  */
  replaceAd(config, adElement) {
    if (!this.refreshStrategy)
      return;
    if (!this.adUnits.has(config.name)) {
      return;
    }
    this.adUnits.set(config.name, adElement);
    this.observer.observe(adElement);
  }
  /**
  * Clears all ads from the ad refresh manager
  */
  clearAds() {
    this.observer?.disconnect();
    this.adUnits.clear();
    this.adTimers.clear();
    this.visibleAds.clear();
    this.currentRefreshes = 0;
    this.clearAdTimer();
  }
  /**
  * Ends the ad timer interval and stops the document from checking ad timings
  */
  clearAdTimer() {
    if (!this.refreshInterval) {
      return;
    }
    this.refreshInterval.stop();
  }
  /**
  * Restarts the ad timer interval
  */
  reinitializeAdTimer() {
    if (!this.refreshInterval) {
      return;
    }
    this.refreshInterval.start();
  }
  registerAdUnits(adUnitsConfig) {
    this.adUnits = new Map(this.adUnitManager.getAdUnits());
    const lastRefresh = Date.now();
    adUnitsConfig.forEach((adUnit) => {
      this.adTimers.set(adUnit.name, {
        refreshes: 0,
        lastRefresh
      });
    });
  }
  registerObservers() {
    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: [
        AdThresholds.NonVisible,
        AdThresholds.HalfVisible
      ]
    };
    this.observer = new IntersectionObserver(this.adIntersectionCallback.bind(this), observerOptions);
    this.adUnits.forEach((adElement) => {
      this.observer.observe(adElement);
    });
  }
  refreshAd(adUnitId) {
    const timer = this.adTimers.get(adUnitId);
    if (timer) {
      const now = Date.now();
      if (now - timer.lastRefresh < this.globalRefreshCooldown * 1e3) {
        return false;
      }
      timer.lastRefresh = now;
      timer.refreshes += 1;
    }
    if (this.refreshStrategy === RefreshStrategy.Mobile) {
      performance.mark(EventTypes.DynamicBiddingStarted);
    } else {
      performance.mark(EventTypes.RefreshBiddingStarted);
    }
    this.providerManager.refresh(adUnitId);
    return true;
  }
  /**
  * Event handler for every second passed
  *
  * for all visible ads, update their timers and check against timer thresholds
  */
  handleRefreshInterval() {
    if (document.visibilityState === "hidden") {
      return;
    }
    printDebug("handleRefreshInterval", {
      currentRefreshes: this.currentRefreshes
    });
    this.visibleAds.forEach((adUnitId) => {
      this.refreshAd(adUnitId);
    });
    this.currentRefreshes += 1;
    if (this.currentRefreshes >= this.adRefreshLimit) {
      this.refreshInterval.stop();
    }
  }
  /**
  * Force an ad refresh of all viewable (50% visibility) ad units.
  * Resets the refresh timer back to 30 seconds. Queues the forced refresh for 2 seconds.
  *
  * Conditions:
  * If a refresh of any kind has happened within the last 10 seconds, do not refresh.
  * If a user initiated refresh is already queued, do not refresh.
  */
  userInitiateRefresh() {
    printDebug("userInitiateRefresh request received...");
    if (this.refreshInterval?.getRemainingTime() > (this.adRefreshTimer - this.globalRefreshCooldown) * 1e3) {
      const lastRefreshInSeconds = Math.round(this.adRefreshTimer - this.refreshInterval.getRemainingTime() / 1e3);
      printDebug(`Refresh occurred ${lastRefreshInSeconds} seconds ago. Skip!`);
      return;
    }
    if (this.refreshQueued) {
      printDebug("The ads are already scheduled to refresh in ~ 2 seconds. Skip!");
      return;
    }
    this.refreshQueued = true;
    const refreshDelay = this.refreshStrategy === RefreshStrategy.Mobile ? 10 : 2e3;
    printDebug(`Scheduled new refresh in ${refreshDelay / 1e3} seconds.`);
    window.setTimeout(() => {
      this.viewableAds.forEach((adUnitId) => {
        if (this.refreshStrategy === RefreshStrategy.Mobile) {
          if (!this.scrolledPastAds.has(adUnitId))
            return;
          if (this.refreshAd(adUnitId)) {
            this.scrolledPastAds.delete(adUnitId);
          }
        } else {
          this.refreshAd(adUnitId);
        }
      });
      this.refreshQueued = false;
      printDebug("The ads are now refreshing...");
    }, refreshDelay);
    this.refreshInterval?.reset(this.adRefreshTimer * 1e3);
  }
  /**
  * Adds and removes ids from visible ads based on their document intersection status
  *
  * @param entries a list of observed intersection events
  */
  adIntersectionCallback(entries) {
    entries.forEach((entry) => {
      const adUnit = entry.target;
      const adUnitId = adUnit.dataset.adContainerId || adUnit.id || "";
      const timer = this.adTimers.get(adUnitId);
      if (!timer) {
        return;
      }
      if (entry.isIntersecting) {
        this.visibleAds.add(adUnitId);
        if (entry.intersectionRatio >= AdThresholds.HalfVisible) {
          this.viewableAds.add(adUnitId);
        }
        if (entry.intersectionRatio <= AdThresholds.HalfVisible) {
          this.viewableAds.delete(adUnitId);
        }
      } else {
        if (this.visibleAds.has(adUnitId) && entry.boundingClientRect.y < 0 && this.refreshStrategy === RefreshStrategy.Mobile) {
          this.scrolledPastAds.add(adUnitId);
        }
        this.visibleAds.delete(adUnitId);
        this.viewableAds.delete(adUnitId);
      }
    });
  }
  /**
  * Resets the ad refresh timer to a specified number of seconds
  *
  * @param seconds the number of seconds to reset the refresh timer to
  */
  resetRefreshTimer(seconds) {
    if (!this.refreshInterval) {
      return;
    }
    this.refreshInterval.reset(seconds);
  }
}, __name(_a13, "AdRefreshManager"), _a13);
AdRefreshManager = __decorate11([
  injectable11(),
  __param7(0, inject6("AdUnitManager")),
  __param7(1, inject6("ProviderManager")),
  __param7(2, inject6("AdEventManager")),
  __metadata9("design:type", Function),
  __metadata9("design:paramtypes", [
    typeof AdUnitManager === "undefined" ? Object : AdUnitManager,
    typeof ProviderManager === "undefined" ? Object : ProviderManager,
    typeof AdEventManager === "undefined" ? Object : AdEventManager
  ])
], AdRefreshManager);

// src/controllers/ad-controller.ts
var __decorate12 = function(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
    r = Reflect.decorate(decorators, target, key, desc);
  else
    for (var i = decorators.length - 1; i >= 0; i--)
      if (d = decorators[i])
        r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata10 = function(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
    return Reflect.metadata(k, v);
};
var __param8 = function(paramIndex, decorator) {
  return function(target, key) {
    decorator(target, key, paramIndex);
  };
};
var _a14;
var AdController = (_a14 = class {
  constructor(adUnitManager, providerManager, pluginManager, eventManager, featureFlags, adblockDetect, adRefreshManager) {
    this.adUnitManager = adUnitManager;
    this.providerManager = providerManager;
    this.pluginManager = pluginManager;
    this.eventManager = eventManager;
    this.featureFlags = featureFlags;
    this.adblockDetect = adblockDetect;
    this.adRefreshManager = adRefreshManager;
    try {
      this.loadAdConfig();
    } catch (e) {
      console.warn(e.message);
      return;
    }
    void this.eventManager.fire(EventTypes.ProcessingStarted);
    this.featureFlags.init();
    this.adUnitManager.init(this.config);
  }
  init() {
    void this.providerManager.init(this.config, this.featureFlags.getEnabledProviders()).then(() => {
      this.initAdUnits();
    });
    this.adRefreshManager.init(this.config);
    this.pluginManager.init(this.config, this.featureFlags.getEnabledPlugins());
    this.initDynamicAdListener();
    this.initAdReplacementListener();
    this.initAdDestructionListener();
    this.initAdReinitializationListener();
    const initializedEvent = new Event(AdEventListeners.AdStackInitialized);
    document.dispatchEvent(initializedEvent);
  }
  loadAdConfig() {
    this.config = AdConfigurationLoader.loadConfig();
  }
  initAdUnits() {
    const adUnits = this.adUnitManager.getAdUnits();
    this.providerManager.start(adUnits);
    this.pluginManager.start();
  }
  /**
  * this method registers a new ad's config with an incoming config set
  */
  initDynamicAdListener() {
    document.addEventListener(AdEventListeners.DynamicAdEvent, (event) => {
      const eventData = event.detail;
      const adElement = event.target;
      const adUnit = eventData?.config ? ProductionAdSlotTransformer.transformFromJson(eventData.config.name, eventData.config) : this.config.ads.find((ad) => ad.name === eventData.id);
      if (!adUnit) {
        return;
      }
      this.adUnitManager.registerAd(adUnit, adElement);
      this.providerManager.registerAd(adUnit);
      this.adRefreshManager.registerAd(adUnit, adElement);
    });
  }
  /**
  * this method replaces an existing ad's config with an incoming config set
  */
  initAdReplacementListener() {
    document.addEventListener(AdEventListeners.ReplaceAdEvent, (event) => {
      const eventData = event.detail;
      const adElement = event.target;
      if (!eventData?.config) {
        return;
      }
      const adUnit = ProductionAdSlotTransformer.transformFromJson(eventData.config.name, eventData.config);
      if (!adUnit) {
        return;
      }
      this.adUnitManager.replaceAd(adUnit, adElement);
      this.providerManager.replaceAd(adUnit);
      this.adRefreshManager.replaceAd(adUnit, adElement);
    });
  }
  /**
  * this method will destroy all currently registered ads on the page
  */
  initAdDestructionListener() {
    document.addEventListener(AdEventListeners.DestroyAdsEvent, () => {
      this.adUnitManager.clearAds();
      this.providerManager.clearAds();
      this.adRefreshManager.clearAds();
    });
  }
  /**
  * this method will re-initialize all static ads on a page after an ad destruction event has occurred
  */
  initAdReinitializationListener() {
    document.addEventListener(AdEventListeners.ReinitializeAdsEvent, (event) => {
      const adUnitCount = this.adUnitManager.getAdUnits();
      this.adRefreshManager.reinitializeAdTimer();
      if (adUnitCount.size > 0) {
        return;
      }
      const eventData = event.detail;
      if (!eventData.ads) {
        return;
      }
      eventData.ads.forEach((ad) => {
        const adContainer = document.getElementById(ad.id);
        const adUnit = ad.config;
        if (!(adContainer && adUnit)) {
          return;
        }
        this.adUnitManager.registerAd(adUnit, adContainer);
        this.providerManager.registerAd(adUnit);
        this.adRefreshManager.registerAd(adUnit, adContainer);
      });
    });
  }
}, __name(_a14, "AdController"), _a14);
AdController = __decorate12([
  injectable12(),
  __param8(0, inject7("AdUnitManager")),
  __param8(1, inject7("ProviderManager")),
  __param8(2, inject7("PluginManager")),
  __param8(3, inject7("AdEventManager")),
  __param8(4, inject7("FeatureFlagLoader")),
  __param8(5, inject7("AdblockDetect")),
  __param8(6, inject7("AdRefreshManager")),
  __metadata10("design:type", Function),
  __metadata10("design:paramtypes", [
    typeof AdUnitManager === "undefined" ? Object : AdUnitManager,
    typeof ProviderManager === "undefined" ? Object : ProviderManager,
    typeof PluginManager === "undefined" ? Object : PluginManager,
    typeof AdEventManager === "undefined" ? Object : AdEventManager,
    typeof FeatureFlagLoader === "undefined" ? Object : FeatureFlagLoader,
    typeof AdblockDetect === "undefined" ? Object : AdblockDetect,
    typeof AdRefreshManager === "undefined" ? Object : AdRefreshManager
  ])
], AdController);

// src/controllers/metrics-reporter.ts
import { injectable as injectable13, inject as inject8 } from "inversify";
var __decorate13 = function(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
    r = Reflect.decorate(decorators, target, key, desc);
  else
    for (var i = decorators.length - 1; i >= 0; i--)
      if (d = decorators[i])
        r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata11 = function(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
    return Reflect.metadata(k, v);
};
var __param9 = function(paramIndex, decorator) {
  return function(target, key) {
    decorator(target, key, paramIndex);
  };
};
var isConfigurationOptions2 = /* @__PURE__ */ __name((options) => typeof options === "object" && "maxRequestsPerBatch" in options && "batchFireTimeout" in options && "endpointUrl" in options, "isConfigurationOptions");
var _a15;
var MetricsReporter = (_a15 = class {
  constructor(eventManager) {
    this.eventManager = eventManager;
    this.batchRequestQueue = [];
    this.startedPageEvents = /* @__PURE__ */ new Map();
    this.startedAdEvents = /* @__PURE__ */ new Map();
  }
  init(token) {
    const configOptions = ConfigurationLoader.get("metricsReporter");
    if (!isConfigurationOptions2(configOptions)) {
      return;
    }
    this.options = configOptions;
    this.csrfToken = token;
    this.subscriber = this.start();
  }
  modifyRequestHeaders(callback) {
    this.modifyHeadersCallback = callback;
  }
  /**
  * Start queuing event to be dispatched - configured by the configuration loader
  *
  * @param {AdPlatformEvent} eventData Event data sent from the ad platform
  */
  onEvent(eventData) {
    clearTimeout(this.batchRequestTimer);
    this.batchRequestQueue.push(eventData);
    if (this.batchRequestQueue.length === this.options.maxRequestsPerBatch) {
      void this.report(this.batchRequestQueue);
      return;
    }
    this.batchRequestTimer = setTimeout(() => {
      void this.report(this.batchRequestQueue);
    }, this.options.batchFireTimeout);
  }
  /**
  * Will dispatch events to supplied endpoint
  *
  * @param {AdPlatformEvent[]} batchRequests All queued requests from the onEvent callback
  * @returns
  */
  async report(batchRequests) {
    if (!this.csrfToken) {
      return;
    }
    const headers = new Headers({
      "Content-Type": "application/json",
      "Csrf-Token": this.csrfToken
    });
    const response = await fetch(this.options.endpointUrl, {
      method: "POST",
      headers: typeof this.modifyHeadersCallback === "function" ? this.modifyHeadersCallback(headers) : headers,
      body: JSON.stringify(batchRequests)
    });
    if (response.status !== 200) {
      return;
    }
    this.batchRequestQueue = [];
    const responseJson = await response.json();
    this.csrfToken = responseJson.token;
  }
  /**
  * Will unsubscribe from the observable that's firing events from the ad platform
  */
  stop() {
    if (!this.subscriber) {
      return;
    }
    Observable.unsubscribe(this.subscriber);
    this.subscriber = null;
  }
  /**
  * Will subscribe to the observable that's firing events form the ad platform
  *
  * @returns {Subscription} The subscription to the observable
  */
  start() {
    if (this.subscriber) {
      return this.subscriber;
    }
    return this.eventManager.subscribe(this.onEvent.bind(this));
  }
  /**
  * Sets each started event in the associated started events map
  *
  * @param {AdPlatformEvent} eventData Event data sent from the ad platform
  */
  handleStartedEvents(eventData) {
    if (AdEvent.isPageEventType(eventData.event)) {
      this.startedPageEvents.set(eventData.event, eventData.timestamp);
      return;
    }
    if (!isAdEventObject(eventData)) {
      return;
    }
    if (!this.startedAdEvents.get(eventData.event)) {
      this.startedAdEvents.set(eventData.adUnitId, /* @__PURE__ */ new Map([
        [
          eventData.event,
          eventData.timestamp
        ]
      ]));
    } else {
      this.startedAdEvents.get(eventData.event)?.set(eventData.event, eventData.timestamp);
    }
  }
}, __name(_a15, "MetricsReporter"), _a15);
MetricsReporter = __decorate13([
  injectable13(),
  __param9(0, inject8("AdEventManager")),
  __metadata11("design:type", Function),
  __metadata11("design:paramtypes", [
    typeof AdEventManager === "undefined" ? Object : AdEventManager
  ])
], MetricsReporter);

// src/container/core.ts
var core = new ContainerModule2((bind) => {
  bind("AdblockDetect").to(AdblockDetect).inSingletonScope();
  bind("AdConfigurationLoader").to(AdConfigurationLoader).inSingletonScope();
  bind("AdController").to(AdController).inSingletonScope();
  bind("AdEventManager").to(AdEventManager).inSingletonScope();
  bind("AdRefreshManager").to(AdRefreshManager).inSingletonScope();
  bind("AdUnitManager").to(AdUnitManager).inSingletonScope();
  bind("ChannelName").toConstantValue(channelName);
  bind("FeatureFlagLoader").to(FeatureFlagLoader).inSingletonScope();
  bind("MetricsReporter").to(MetricsReporter).inSingletonScope();
  bind("PluginManager").to(PluginManager).inSingletonScope();
  bind("ProviderManager").to(ProviderManager).inSingletonScope();
});

// src/container/container.ts
var freshContainer = new Container();
freshContainer.load(utilities);
freshContainer.load(core);
var container = freshContainer;

// src/hooks/useAdsCore.ts
import readyState from "ready-state";

// src/providers/gptCommonProvider.ts
import { injectable as injectable15, inject as inject9 } from "inversify";
import Cookies from "js-cookie";

// src/providers/googlePublisherTag.ts
var _GooglePublisherTag = class _GooglePublisherTag {
  constructor() {
    __publicField(this, "refreshTargetingCount", 1);
  }
  async init(isEventDriven, env, segments) {
    if (!await this.awaitGlobals()) {
      return false;
    }
    this.clearTargeting();
    this.setGeneralTargeting(isEventDriven, env, segments);
    return true;
  }
  setGeneralTargeting(_isEventDriven, env, segmentsString) {
    if (env) {
      this.setTargeting("env", env);
    }
    if (segmentsString) {
      const segmentData = JSON.parse(segmentsString);
      const segments = segmentData.targeting;
      Object.entries(segments).forEach(([_index, segment]) => {
        segments.forEach(() => {
          this.setTargeting(segment[0], segment[1]);
        });
      });
    }
  }
  clearAd() {
    this.googleTag.pubads().clear();
  }
  defineSlot(slotName, size, slotID) {
    const slot = this.googleTag.defineSlot(slotName, size, slotID);
    if (slot !== null) {
      slot.setTargeting("refresh", this.refreshTargetingCount);
      slot.addService(this.googleTag.pubads());
    }
    return slot;
  }
  destroySlots() {
    this.googleTag.destroySlots();
  }
  enableServices() {
    if (!_GooglePublisherTag.servicesEnabled) {
      this.googleTag.enableServices();
      _GooglePublisherTag.servicesEnabled = true;
    }
  }
  enableSingleRequest() {
    this.googleTag.pubads().enableSingleRequest();
  }
  pushCommand(fn) {
    this.googleTag.cmd.push(fn);
  }
  refreshAds(slot) {
    this.googleTag.pubads().refresh(slot);
  }
  setPrivacySettings(settings) {
    this.googleTag.pubads().setPrivacySettings(settings);
  }
  displayAd(slotId) {
    this.googleTag.display(slotId);
  }
  disableInitialLoad() {
    this.googleTag.pubads().disableInitialLoad();
  }
  enableLazyLoad(config = {
    fetchMarginPercent: 100,
    renderMarginPercent: 50,
    mobileScaling: 2
  }) {
    printDebug("enableLazyLoad", config);
    this.googleTag.pubads().enableLazyLoad(config);
  }
  /**
  * Configure page-level targeting.
  * See https://developers.google.com/publisher-tag/guides/key-value-targeting
  */
  setTargeting(key, value) {
    this.googleTag.pubads().setTargeting(key, value);
  }
  /**
  * Clear page-level targeting
  */
  clearTargeting() {
    this.googleTag.pubads().clearTargeting();
  }
  addEventListener(eventName, callback) {
    this.googleTag.pubads().addEventListener(eventName, callback);
  }
  removeEventListener(eventName, callback) {
    this.googleTag.pubads().removeEventListener(eventName, callback);
  }
  /**
  * Configure PPID.
  * See https://support.google.com/admanager/answer/2880055?hl=en
  */
  setPublisherProvidedId(id) {
    this.googleTag.pubads().setPublisherProvidedId(id);
  }
  async awaitGlobals() {
    if (!this.googleTag) {
      try {
        await awaitProperty("googletag", window, 80);
        await awaitProperty("defineSlot", window.googletag, 80);
        this.googleTag = window.googletag;
      } catch (e) {
        Logger.error("Unable to initialize window.googletag", e);
        return false;
      }
    }
    return true;
  }
};
__name(_GooglePublisherTag, "GooglePublisherTag");
__publicField(_GooglePublisherTag, "servicesEnabled", false);
var GooglePublisherTag = _GooglePublisherTag;

// src/plugins/ccpaPluginAdapter.ts
import { injectable as injectable14 } from "inversify";
var __decorate14 = function(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
    r = Reflect.decorate(decorators, target, key, desc);
  else
    for (var i = decorators.length - 1; i >= 0; i--)
      if (d = decorators[i])
        r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var name = "CcpaPluginAdapter";
var _a16;
var CcpaPluginAdapter = (_a16 = class {
  constructor() {
    __publicField(this, "iFrameName", "__uspapiLocator");
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars,class-methods-use-this
  init(config) {
    window.__uspapi = this.getUspApi();
  }
  start() {
    this.ensureIFrame();
    window.addEventListener("message", this.handleUspApiMessage, false);
  }
  static checkForOptOutPreference() {
    return document.cookie.indexOf("opt_out_pixel") !== -1 || // eslint-disable-next-line @typescript-eslint/no-explicit-any
    navigator.globalPrivacyControl === true;
  }
  static debugInfoConsole(message, ...args) {
    if (window.location.search.indexOf("debugUSPAPI") !== -1) {
      console.info.apply(window, [
        "__uspapi: ",
        message
      ].concat(args));
    }
  }
  static getUSPData(apiVer, callback) {
    _a16.debugInfoConsole("getUSPData version and callback: ", apiVer, callback);
    if (apiVer !== null && apiVer !== _a16.API_VERSION) {
      callback(null, false);
      return;
    }
    const callbackObjectArg = {
      version: _a16.API_VERSION,
      uspString: _a16.checkForOptOutPreference() ? _a16.OPTED_OUT : _a16.getUSPNormalString()
    };
    _a16.debugInfoConsole(_a16.checkForOptOutPreference() ? "opted out" : "opted in", callbackObjectArg);
    callback(callbackObjectArg, true);
  }
  static getUSPNormalString() {
    return DataLayer.get("visitor").isCaliforniaIP ? [
      _a16.API_VERSION,
      "YN-"
    ].join("") : _a16.NORMAL;
  }
  ensureIFrame() {
    if (!window.frames[this.iFrameName]) {
      if (document.body) {
        const iFrame = document.createElement("iframe");
        iFrame.style.cssText = "display: none";
        iFrame.name = this.iFrameName;
        document.body.appendChild(iFrame);
      } else {
        setTimeout(this.ensureIFrame, 5);
      }
    }
  }
  getUspApi() {
    if (window.__uspapi) {
      try {
        if (window.__uspapi("__uspapi")) {
          return window.__uspapi;
        }
      } catch (err) {
        return window.__uspapi;
      }
    }
    return this.uspapi;
  }
  // eslint-disable-next-line class-methods-use-this
  handleUspApiMessage(event) {
    const data = event && event.data && event.data.__uspapiCall;
    if (data) {
      window.__uspapi(data.command, data.version, (returnValue, success) => {
        const messageBody = {
          __uspapiReturn: {
            returnValue,
            success,
            callId: data.callId
          }
        };
        _a16.debugInfoConsole("Posting message: ", messageBody);
        if (event.source !== null) {
          if (!(event.source instanceof MessagePort) && !(event.source instanceof ServiceWorker)) {
            event.source.postMessage(messageBody, "*");
          }
        }
      });
    }
  }
  // eslint-disable-next-line class-methods-use-this
  uspapi(cmd, ...args) {
    _a16.debugInfoConsole("__uspapi call: ", cmd);
    _a16.debugInfoConsole("__uspapi args: ", args);
    try {
      if (cmd === "getUSPData") {
        _a16.getUSPData.apply(null, args);
        return {
          getUSPData: _a16.getUSPData,
          __uspapi: () => true
        };
      }
    } catch (err) {
      console.error(`__uspapi: invalid command:`, err);
    }
    return {
      __uspapi: () => false
    };
  }
}, __name(_a16, "CcpaPluginAdapter"), __publicField(_a16, "API_VERSION", 1), // Based on: https://github.com/InteractiveAdvertisingBureau/USPrivacy/blob/master/CCPA/US%20Privacy%20String.md
__publicField(_a16, "OPTED_OUT", [
  _a16.API_VERSION,
  "YY-"
].join("")), __publicField(_a16, "NORMAL", [
  _a16.API_VERSION,
  "---"
].join("")), _a16);
CcpaPluginAdapter = __decorate14([
  injectable14()
], CcpaPluginAdapter);

// src/providers/gptCommonProvider.ts
var __decorate15 = function(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
    r = Reflect.decorate(decorators, target, key, desc);
  else
    for (var i = decorators.length - 1; i >= 0; i--)
      if (d = decorators[i])
        r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata12 = function(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
    return Reflect.metadata(k, v);
};
var __param10 = function(paramIndex, decorator) {
  return function(target, key) {
    decorator(target, key, paramIndex);
  };
};
var name2 = "gptCommonProvider";
var _a17;
var GptCommonProvider = (_a17 = class {
  constructor(eventManager, adUnitManager) {
    this.eventManager = eventManager;
    this.adUnitManager = adUnitManager;
    this.PARALLEL_TIMEOUT = 2e3;
    this.adUnitSlots = /* @__PURE__ */ new Map();
    this.biddingDetails = /* @__PURE__ */ new Map();
    this.adsDestroyed = false;
    this.refreshTargetingCount = 2;
    this.slotLevelTargeting = /* @__PURE__ */ new Map();
    this.adUnitSlotsSize = 0;
    this.isInitialized = false;
    this.googlePublisherTag = new GooglePublisherTag();
    this.adUnits = this.adUnitManager.getAdUnits();
  }
  async init(isEventDriven, env, segments) {
    if (!await this.googlePublisherTag.init(isEventDriven, env, segments)) {
      return false;
    }
    const visitor = DataLayer.get("visitor");
    if (!CcpaPluginAdapter.checkForOptOutPreference()) {
      if (visitor.userId === 0) {
        this.googlePublisherTag.setPublisherProvidedId(this.getAuuidCookie());
      } else if (visitor.emailHashes?.[1]) {
        this.googlePublisherTag.setPublisherProvidedId(visitor.emailHashes[1]);
      }
    }
    if (this.isInitialized) {
      return true;
    }
    this.initialAdUnitPopulatedCallback("slotRenderEnded");
    document.addEventListener("initialSlotRenderEnded", this.adUnitPopulatedCallback.bind(this, "slotRenderEnded"));
    document.addEventListener(AdEventListeners.DestroyAdsEvent, () => {
      this.adsDestroyed = true;
      this.resetAds();
    });
    this.googlePublisherTag.pushCommand(() => {
      this.googlePublisherTag.disableInitialLoad();
      this.googlePublisherTag.setPrivacySettings({
        restrictDataProcessing: CcpaPluginAdapter.checkForOptOutPreference()
      });
    });
    this.googlePublisherTag.addEventListener("impressionViewable", (event) => {
      void this.eventManager.fire(EventTypes.AdUnitViewable, {
        adUnitId: event.slot.getSlotElementId()
      });
    });
    this.isInitialized = true;
    return true;
  }
  initAdUnit(adUnit) {
    const element = this.adUnits.get(adUnit.name);
    const gptAdSlot = this.adUnitSlots.get(adUnit.name);
    if (this.adUnitSlotsSize > this.adUnitSlots.size) {
      this.adUnitSlotsSize = 0;
    }
    this.addPositionToAdSlots();
    if (element && !gptAdSlot) {
      const slot = this.googlePublisherTag.defineSlot(adUnit.placement, adUnit.sizes, adUnit.name);
      this.adUnitSlots.set(adUnit.name, {
        name: adUnit.name,
        placement: adUnit.placement,
        slot,
        providers: [],
        dynamic: adUnit.dynamic
      });
      this.addPositionToAdSlots();
    }
  }
  setAdUnitProvider(adUnit, provider) {
    const gptAdSlot = this.adUnitSlots.get(adUnit.name);
    if (gptAdSlot && provider && !gptAdSlot.providers.includes(provider)) {
      gptAdSlot.providers.push(provider);
    }
  }
  startBiddingProcess(adUnitSlotName, refresh, biddingHandler) {
    const gptAdSlot = this.adUnitSlots.get(adUnitSlotName);
    if (!gptAdSlot) {
      return;
    }
    if (refresh) {
      if (!this.biddingDetails.has(adUnitSlotName)) {
        const biddingProviders = /* @__PURE__ */ new Map();
        gptAdSlot.providers.forEach((provider) => biddingProviders.set(provider, false));
        this.biddingDetails.set(adUnitSlotName, {
          providers: biddingProviders,
          timeoutId: window.setTimeout(() => {
            printDebug("refreshing ads: timeout occurred; fetching ads...");
            this.fetchAds(refresh, gptAdSlot);
          }, this.PARALLEL_TIMEOUT)
        });
      }
      biddingHandler();
      return;
    }
    _a17.requestBidsQueue.push(biddingHandler);
    if (_a17.requestBidsQueue.length === 2) {
      printDebug("initial ads: dequeue all providers");
      this.dequeue(gptAdSlot);
      _a17.initialAdsTimeoutId = window.setTimeout(() => {
        printDebug("initial ads: timeout occurred; fetching ads...");
        this.fetchAds(refresh);
      }, this.PARALLEL_TIMEOUT);
    }
  }
  bidsCompleteHandler(refresh, provider, adUnitSlotName) {
    if (!adUnitSlotName) {
      return;
    }
    const gptAdSlot = this.adUnitSlots.get(adUnitSlotName);
    if (!gptAdSlot) {
      return;
    }
    if (refresh) {
      if (!this.biddingDetails.has(adUnitSlotName)) {
        return;
      }
      const biddingDetails = this.biddingDetails.get(adUnitSlotName);
      if (!biddingDetails) {
        return;
      }
      biddingDetails.providers.set(provider, true);
      if (!Array.from(biddingDetails.providers.values()).includes(false)) {
        window.clearTimeout(biddingDetails.timeoutId);
        this.fetchAds(refresh, gptAdSlot);
        this.biddingDetails.delete(adUnitSlotName);
      } else {
        this.biddingDetails.set(adUnitSlotName, biddingDetails);
      }
      return;
    }
    if (_a17.prebidBidsReceived && _a17.amazonBidsReceived) {
      window.clearTimeout(_a17.initialAdsTimeoutId);
      if (gptAdSlot.dynamic) {
        this.fetchAds(true, gptAdSlot);
      } else {
        this.fetchAds(refresh);
      }
    }
  }
  dequeue(gptAdSlot) {
    if (gptAdSlot.dynamic) {
      performance.mark(EventTypes.DynamicBiddingStarted);
    } else if (this.adsDestroyed) {
      performance.mark(EventTypes.ReinitializeBiddingStarted);
    } else {
      void this.eventManager.fire(EventTypes.BiddingStarted);
    }
    _a17.requestBidsQueue.forEach((fn) => fn());
  }
  fetchAds(refresh, gptAdSlot) {
    let eventName = null;
    if (refresh && !gptAdSlot?.dynamic && window["adRefreshStrategy"] !== "mobile") {
      eventName = EventTypes.RefreshBiddingCompleted;
    } else if (gptAdSlot?.dynamic || refresh && window["adRefreshStrategy"] === "mobile") {
      eventName = EventTypes.DynamicBiddingCompleted;
    }
    printDebug("fetchAds", {
      slotName: gptAdSlot?.name,
      eventName,
      refresh,
      gptAdSlot
    });
    if (eventName && gptAdSlot) {
      void this.eventManager.fire(eventName, {
        adUnitId: gptAdSlot.name
      });
    } else if (this.adsDestroyed) {
      void this.eventManager.fire(EventTypes.ReinitializeBiddingCompleted);
    } else {
      void this.eventManager.fire(EventTypes.BiddingCompleted);
    }
    this.addPositionToAdSlots();
    this.googlePublisherTag.pushCommand(() => {
      if (refresh && gptAdSlot) {
        if (!this.slotLevelTargeting.has(gptAdSlot.name)) {
          this.slotLevelTargeting.set(gptAdSlot.name, {
            refresh: this.refreshTargetingCount
          });
          gptAdSlot.slot.setTargeting("refresh", this.refreshTargetingCount);
        } else {
          let count = this.slotLevelTargeting.get(gptAdSlot.name).refresh;
          this.slotLevelTargeting.set(gptAdSlot.name, {
            refresh: ++count
          });
          gptAdSlot.slot.setTargeting("refresh", count);
        }
        printDebug(`refresh setTargeting for ${gptAdSlot.name}`, this.slotLevelTargeting.get(gptAdSlot.name));
        this.googlePublisherTag.refreshAds([
          gptAdSlot.slot
        ]);
      } else {
        this.googlePublisherTag.enableSingleRequest();
        googletag.pubads().addEventListener("slotRequested", (event) => {
          printDebug(`fetched ${event.slot.getSlotElementId()}`);
        });
        googletag.pubads().addEventListener("slotOnload", (event) => {
          printDebug(`rendered ${event.slot.getSlotElementId()}`);
        });
        this.googlePublisherTag.enableServices();
        Array.from(this.adUnitSlots.keys()).forEach((slot) => this.googlePublisherTag.displayAd(slot));
        this.googlePublisherTag.refreshAds();
        document.dispatchEvent(new Event(AdEventListeners.AdRefreshTimerStart));
      }
      this.resetBidProperties();
    });
  }
  addPositionToAdSlots() {
    if (this.adUnitSlots.size <= this.adUnitSlotsSize || !this.isFrontpageMobileWeb()) {
      return;
    }
    let count = 1;
    for (const gptAdSlot of this.adUnitSlots.values()) {
      this.slotLevelTargeting.set(gptAdSlot.name, {
        position: count
      });
      gptAdSlot.slot.setTargeting("position", count);
      count++;
    }
    this.adUnitSlotsSize = this.adUnitSlots.size;
  }
  initialAdUnitPopulatedCallback(eventName) {
    const onSlotRenderEnded = /* @__PURE__ */ __name(() => {
      this.googlePublisherTag.removeEventListener(eventName, onSlotRenderEnded);
      void this.eventManager.fire(EventTypes.AdUnitPopulated);
      setTimeout(() => {
        document.dispatchEvent(new Event("initialSlotRenderEnded"));
      }, this.PARALLEL_TIMEOUT);
    }, "onSlotRenderEnded");
    this.googlePublisherTag.addEventListener(eventName, onSlotRenderEnded);
  }
  adUnitPopulatedCallback(eventName) {
    const onSlotRenderEnded = /* @__PURE__ */ __name((event) => {
      let eventTypeName;
      if (this.adsDestroyed) {
        this.googlePublisherTag.removeEventListener(eventName, onSlotRenderEnded);
      }
      if (this.isFrontpageMobileWeb() && !this.adsDestroyed) {
        eventTypeName = EventTypes.DynamicAdUnitPopulated;
      } else if (this.adsDestroyed) {
        eventTypeName = EventTypes.ReinitializeAdUnitPopulated;
      } else {
        eventTypeName = EventTypes.RefreshAdUnitPopulated;
      }
      void this.eventManager.fire(eventTypeName, {
        adUnitId: event.slot.getSlotElementId()
      });
      if (this.adsDestroyed) {
        setTimeout(() => {
          document.dispatchEvent(new Event("initialSlotRenderEnded"));
        }, this.PARALLEL_TIMEOUT);
        this.adsDestroyed = false;
      }
    }, "onSlotRenderEnded");
    this.googlePublisherTag.addEventListener(eventName, onSlotRenderEnded);
  }
  isFrontpageMobileWeb() {
    const page = DataLayer.get("page");
    return page.section === "Frontpage" && page.layout === "Mobile Web";
  }
  getAuuidCookie() {
    return Cookies.get("auuid") ?? "";
  }
  resetAds() {
    this.adUnitSlots.clear();
    this.googlePublisherTag.destroySlots();
    this.googlePublisherTag.clearAd();
    this.resetBidProperties();
  }
  resetBidProperties() {
    _a17.requestBidsQueue = [];
    _a17.amazonBidsRequested = false;
    _a17.amazonBidsReceived = false;
    _a17.prebidBidsRequested = false;
    _a17.prebidBidsReceived = false;
  }
}, __name(_a17, "GptCommonProvider"), __publicField(_a17, "prebidBidsRequested", false), __publicField(_a17, "prebidBidsReceived", false), __publicField(_a17, "amazonBidsRequested", false), __publicField(_a17, "amazonBidsReceived", false), __publicField(_a17, "requestBidsQueue", []), _a17);
GptCommonProvider = __decorate15([
  injectable15(),
  __param10(0, inject9("AdEventManager")),
  __param10(1, inject9("AdUnitManager")),
  __metadata12("design:type", Function),
  __metadata12("design:paramtypes", [
    typeof AdEventManager === "undefined" ? Object : AdEventManager,
    typeof AdUnitManager === "undefined" ? Object : AdUnitManager
  ])
], GptCommonProvider);

// src/providers/amazonProviderAdapter.ts
import { injectable as injectable16, inject as inject10 } from "inversify";

// src/providers/amazon/config.ts
var generalConfig = {
  pubID: "3097",
  adServer: "googletag",
  bidTimeout: 2e3,
  signals: {
    ortb2: {
      site: {
        cat: [
          "473"
        ],
        cattax: 7,
        privacypolicy: 1,
        page: "",
        publisher: {
          id: "e14f27bc-f461-4766-982f-7ef423d39ad5"
        }
      }
    }
  }
};
var signalDataConfigMap = {
  Auto: {
    sectioncat: 1,
    pagecat: 1
  },
  "Auto Electronic Accessories": {
    sectioncat: 1,
    pagecat: 1
  },
  "Auto Parts": {
    sectioncat: 32,
    pagecat: 32
  },
  "Auto Parts & Supplies": {
    sectioncat: 32,
    pagecat: 32
  },
  "Auto Detailing & Car Care": {
    sectioncat: 1,
    pagecat: 1
  },
  "Auto Detailing": {
    sectioncat: 1,
    pagecat: 1
  },
  "Auto Tools": {
    sectioncat: 1,
    pagecat: 1
  },
  "Automotive Tools": {
    sectioncat: 1,
    pagecat: 1
  },
  Gas: {
    sectioncat: 1,
    pagecat: 1
  },
  "Oil Change": {
    sectioncat: 1,
    pagecat: 1
  },
  "Motor Oil": {
    sectioncat: 1,
    pagecat: 1
  },
  "Motorcycle Accessories": {
    sectioncat: 1,
    pagecat: 1
  },
  "Motorcycle Gear & Accessories": {
    sectioncat: 1,
    pagecat: 1
  },
  Wheels: {
    sectioncat: 1,
    pagecat: 1
  },
  "Wheels & Tires": {
    sectioncat: 1,
    pagecat: 1
  },
  Finance: {
    sectioncat: 391,
    pagecat: 391
  },
  "Babies & Kids": {
    sectioncat: 482,
    pagecat: 482
  },
  Chidren: {
    sectioncat: 482,
    pagecat: 482
  },
  Babies: {
    sectioncat: 482,
    pagecat: 482
  },
  "Baby Toys & Books": {
    sectioncat: 482,
    pagecat: 482
  },
  "Baby Toys": {
    sectioncat: 482,
    pagecat: 482
  },
  "Car Seats": {
    sectioncat: 482,
    pagecat: 482
  },
  Carseat: {
    sectioncat: 482,
    pagecat: 482
  },
  Nursery: {
    sectioncat: 482,
    pagecat: 482
  },
  Strollers: {
    sectioncat: 482,
    pagecat: 482
  },
  Stroller: {
    sectioncat: 482,
    pagecat: 482
  },
  Kids: {
    sectioncat: 482,
    pagecat: 482
  },
  "Educational Toys": {
    sectioncat: 482,
    pagecat: 482
  },
  "Kids Games & Books": {
    sectioncat: 482,
    pagecat: 482
  },
  "Kids Game": {
    sectioncat: 482,
    pagecat: 482
  },
  "Kids Toys": {
    sectioncat: 482,
    pagecat: 482
  },
  "Diapers & Wipes": {
    sectioncat: 479,
    pagecat: 479
  },
  Diapers: {
    sectioncat: 479,
    pagecat: 479
  },
  "Bags & Luggage": {
    sectioncat: 552,
    pagecat: 552
  },
  Bags: {
    sectioncat: 552,
    pagecat: 552
  },
  Backpacks: {
    sectioncat: 552,
    pagecat: 552
  },
  "Duffel Bags": {
    sectioncat: 552,
    pagecat: 552
  },
  "Duffle Bags": {
    sectioncat: 552,
    pagecat: 552
  },
  "Laptop Bags": {
    sectioncat: 552,
    pagecat: 552
  },
  "Laptop Bag": {
    sectioncat: 552,
    pagecat: 552
  },
  Luggage: {
    sectioncat: 552,
    pagecat: 552
  },
  "Luggage Bags": {
    sectioncat: 552,
    pagecat: 552
  },
  "Formula & Baby Food": {
    sectioncat: 479,
    pagecat: 479
  },
  "Baby Formula": {
    sectioncat: 479,
    pagecat: 479
  },
  "Books & Magazines": {
    sectioncat: 42,
    pagecat: 42
  },
  "Books Magazines": {
    sectioncat: 42,
    pagecat: 42
  },
  Books: {
    sectioncat: 42,
    pagecat: 42
  },
  Magazines: {
    sectioncat: 42,
    pagecat: 42
  },
  Magazine: {
    sectioncat: 42,
    pagecat: 42
  },
  Ebooks: {
    sectioncat: 42,
    pagecat: 42
  },
  Ebook: {
    sectioncat: 42,
    pagecat: 42
  },
  Textbooks: {
    sectioncat: 42,
    pagecat: 42
  },
  "Clothing & Accessories": {
    sectioncat: 552,
    pagecat: 552
  },
  Apparel: {
    sectioncat: 552,
    pagecat: 552
  },
  "Babies & Kids Clothes & Accessories": {
    sectioncat: 552,
    pagecat: 575
  },
  "Babies And Kids": {
    sectioncat: 552,
    pagecat: 575
  },
  "Baby & Infant Clothes": {
    sectioncat: 552,
    pagecat: 575
  },
  "Baby Clothes": {
    sectioncat: 552,
    pagecat: 575
  },
  "Kids Clothes": {
    sectioncat: 552,
    pagecat: 575
  },
  Jewelry: {
    sectioncat: 552,
    pagecat: 565
  },
  Diamond: {
    sectioncat: 552,
    pagecat: 565
  },
  Diamonds: {
    sectioncat: 552,
    pagecat: 565
  },
  "Earrings, Bracelets & Rings": {
    sectioncat: 552,
    pagecat: 565
  },
  Earrings: {
    sectioncat: 552,
    pagecat: 565
  },
  Necklaces: {
    sectioncat: 552,
    pagecat: 565
  },
  Mens: {
    sectioncat: 552,
    pagecat: 582
  },
  "Men's Clothing & Accessories": {
    sectioncat: 552,
    pagecat: 582
  },
  "Big Tall": {
    sectioncat: 552,
    pagecat: 582
  },
  "Big & Tall": {
    sectioncat: 552,
    pagecat: 582
  },
  "Mens Accessories": {
    sectioncat: 552,
    pagecat: 580
  },
  "Men's Accessories": {
    sectioncat: 552,
    pagecat: 580
  },
  "Mens Athletic Wear": {
    sectioncat: 552,
    pagecat: 587
  },
  "Men's Activewear": {
    sectioncat: 552,
    pagecat: 587
  },
  "Mens Apparel": {
    sectioncat: 552,
    pagecat: 582
  },
  "Men's Apparel": {
    sectioncat: 552,
    pagecat: 582
  },
  "Mens Jeans": {
    sectioncat: 552,
    pagecat: 582
  },
  "Men's Jeans": {
    sectioncat: 552,
    pagecat: 582
  },
  "Mens Outerwear": {
    sectioncat: 552,
    pagecat: 586
  },
  "Men's Outerwear": {
    sectioncat: 552,
    pagecat: 586
  },
  "Men's Pajamas & Loungewear": {
    sectioncat: 552,
    pagecat: 588
  },
  "Mens Pajamas": {
    sectioncat: 552,
    pagecat: 588
  },
  "Mens Pants": {
    sectioncat: 552,
    pagecat: 582
  },
  "Men's Pants & Shorts": {
    sectioncat: 552,
    pagecat: 582
  },
  "Mens Shirt": {
    sectioncat: 552,
    pagecat: 582
  },
  "Men's Shirts": {
    sectioncat: 552,
    pagecat: 582
  },
  "Mens Underwear": {
    sectioncat: 552,
    pagecat: 588
  },
  "Men's Underwear & Socks": {
    sectioncat: 552,
    pagecat: 588
  },
  "Young Mens": {
    sectioncat: 552,
    pagecat: 582
  },
  Shoes: {
    sectioncat: 552,
    pagecat: 552
  },
  "Athletic Shoes": {
    sectioncat: 552,
    pagecat: 552
  },
  "Baby & Kids Shoes": {
    sectioncat: 552,
    pagecat: 575
  },
  "Kids Shoes": {
    sectioncat: 552,
    pagecat: 575
  },
  Boots: {
    sectioncat: 552,
    pagecat: 552
  },
  "Mens Shoes": {
    sectioncat: 552,
    pagecat: 589
  },
  "Men's Shoes": {
    sectioncat: 552,
    pagecat: 589
  },
  Sunglasses: {
    sectioncat: 552,
    pagecat: 552
  },
  "Womens Shoes": {
    sectioncat: 552,
    pagecat: 552
  },
  "Women's Shoes": {
    sectioncat: 552,
    pagecat: 552
  },
  Watches: {
    sectioncat: 552,
    pagecat: 552
  },
  "Mens Watches": {
    sectioncat: 552,
    pagecat: 581
  },
  "Men's Watches": {
    sectioncat: 552,
    pagecat: 581
  },
  "Womens Watches": {
    sectioncat: 552,
    pagecat: 565
  },
  "Women's Watches": {
    sectioncat: 552,
    pagecat: 565
  },
  "Women's Clothing & Accessories": {
    sectioncat: 552,
    pagecat: 566
  },
  Womens: {
    sectioncat: 552,
    pagecat: 566
  },
  "Designer Brands": {
    sectioncat: 552,
    pagecat: 576
  },
  "Handbags & Purses": {
    sectioncat: 552,
    pagecat: 563
  },
  Handbags: {
    sectioncat: 552,
    pagecat: 563
  },
  "Juniors Apparel": {
    sectioncat: 552,
    pagecat: 566
  },
  Juniors: {
    sectioncat: 552,
    pagecat: 566
  },
  Maternity: {
    sectioncat: 552,
    pagecat: 566
  },
  "Plus Size Clothing": {
    sectioncat: 552,
    pagecat: 566
  },
  "Plus Size": {
    sectioncat: 552,
    pagecat: 566
  },
  "Womens Accessories": {
    sectioncat: 552,
    pagecat: 561
  },
  "Women's Accessories": {
    sectioncat: 552,
    pagecat: 561
  },
  "Womens Activewear": {
    sectioncat: 552,
    pagecat: 572
  },
  "Women's Activewear": {
    sectioncat: 552,
    pagecat: 572
  },
  "Womens Apparel": {
    sectioncat: 552,
    pagecat: 566
  },
  "Women's Apparel": {
    sectioncat: 552,
    pagecat: 566
  },
  "Womens Dresses": {
    sectioncat: 552,
    pagecat: 566
  },
  "Women's Dresses & Skirts": {
    sectioncat: 552,
    pagecat: 566
  },
  "Womens Outerwear": {
    sectioncat: 552,
    pagecat: 571
  },
  "Women's Outerwear": {
    sectioncat: 552,
    pagecat: 571
  },
  "Womens Pajamas": {
    sectioncat: 552,
    pagecat: 570
  },
  "Women's Pajamas & Loungewear": {
    sectioncat: 552,
    pagecat: 570
  },
  "Womens Pants": {
    sectioncat: 552,
    pagecat: 566
  },
  "Women's Pants & Shorts": {
    sectioncat: 552,
    pagecat: 566
  },
  "Womens Shirts": {
    sectioncat: 552,
    pagecat: 566
  },
  "Women's Shirts": {
    sectioncat: 552,
    pagecat: 566
  },
  "Womens Lingerie": {
    sectioncat: 552,
    pagecat: 570
  },
  "Women's Underwear & Socks": {
    sectioncat: 552,
    pagecat: 570
  },
  "Credit Cards": {
    sectioncat: 405,
    pagecat: 406
  },
  "Credit Card Offers": {
    sectioncat: 405,
    pagecat: 406
  },
  Computers: {
    sectioncat: 599,
    pagecat: 599
  },
  "Computer Deals": {
    sectioncat: 599,
    pagecat: 599
  },
  "Computer Accessories": {
    sectioncat: 599,
    pagecat: 601
  },
  "Computer Speakers": {
    sectioncat: 599,
    pagecat: 601
  },
  Keyboards: {
    sectioncat: 599,
    pagecat: 601
  },
  Keyboard: {
    sectioncat: 599,
    pagecat: 601
  },
  Mice: {
    sectioncat: 599,
    pagecat: 601
  },
  Mouse: {
    sectioncat: 599,
    pagecat: 601
  },
  Webcams: {
    sectioncat: 599,
    pagecat: 601
  },
  Webcam: {
    sectioncat: 599,
    pagecat: 601
  },
  "Computer Networking": {
    sectioncat: 599,
    pagecat: 600
  },
  Networking: {
    sectioncat: 599,
    pagecat: 600
  },
  Modems: {
    sectioncat: 599,
    pagecat: 600
  },
  Modem: {
    sectioncat: 599,
    pagecat: 600
  },
  Routers: {
    sectioncat: 599,
    pagecat: 600
  },
  Router: {
    sectioncat: 599,
    pagecat: 600
  },
  Switches: {
    sectioncat: 599,
    pagecat: 600
  },
  Switch: {
    sectioncat: 599,
    pagecat: 600
  },
  Wireless: {
    sectioncat: 599,
    pagecat: 600
  },
  "Wireless Router": {
    sectioncat: 599,
    pagecat: 600
  },
  "Computer Parts": {
    sectioncat: 599,
    pagecat: 599
  },
  CPUs: {
    sectioncat: 599,
    pagecat: 599
  },
  Processor: {
    sectioncat: 599,
    pagecat: 599
  },
  "Computer Cases": {
    sectioncat: 599,
    pagecat: 599
  },
  "Computer Case Deals": {
    sectioncat: 599,
    pagecat: 599
  },
  "Computer Fans & Coolers": {
    sectioncat: 599,
    pagecat: 599
  },
  "Computer Fans Coolers": {
    sectioncat: 599,
    pagecat: 599
  },
  "Hard Drives": {
    sectioncat: 599,
    pagecat: 599
  },
  Drives: {
    sectioncat: 599,
    pagecat: 599
  },
  "3.5-INCH": {
    sectioncat: 599,
    pagecat: 599
  },
  "External Hard Drives": {
    sectioncat: 599,
    pagecat: 599
  },
  "External Drive": {
    sectioncat: 599,
    pagecat: 599
  },
  "Portable Hard Drives": {
    sectioncat: 599,
    pagecat: 599
  },
  "Portable Hard Drive": {
    sectioncat: 599,
    pagecat: 599
  },
  "Solid State Drives (SSD)": {
    sectioncat: 599,
    pagecat: 599
  },
  Ssd: {
    sectioncat: 599,
    pagecat: 599
  },
  Memory: {
    sectioncat: 599,
    pagecat: 599
  },
  Motherboards: {
    sectioncat: 599,
    pagecat: 599
  },
  Motherboard: {
    sectioncat: 599,
    pagecat: 599
  },
  "Power Supplies": {
    sectioncat: 599,
    pagecat: 599
  },
  "Power Supply": {
    sectioncat: 599,
    pagecat: 599
  },
  "Video Cards": {
    sectioncat: 599,
    pagecat: 599
  },
  "Video Card": {
    sectioncat: 599,
    pagecat: 599
  },
  "Desktop Computers": {
    sectioncat: 599,
    pagecat: 617
  },
  Desktop: {
    sectioncat: 599,
    pagecat: 617
  },
  "Flash Storage": {
    sectioncat: 599,
    pagecat: 601
  },
  "SD Cards & Micro SD Cards": {
    sectioncat: 599,
    pagecat: 601
  },
  Microsd: {
    sectioncat: 599,
    pagecat: 601
  },
  "USB Flash Drives": {
    sectioncat: 599,
    pagecat: 601
  },
  "Flash Drive": {
    sectioncat: 599,
    pagecat: 601
  },
  "Internet & Websites": {
    sectioncat: 599,
    pagecat: 619
  },
  Internet: {
    sectioncat: 599,
    pagecat: 619
  },
  VPNS: {
    sectioncat: 599,
    pagecat: 602
  },
  "Vpn Service": {
    sectioncat: 599,
    pagecat: 602
  },
  Laptops: {
    sectioncat: 599,
    pagecat: 630
  },
  "Laptop Deals": {
    sectioncat: 599,
    pagecat: 630
  },
  Monitors: {
    sectioncat: 599,
    pagecat: 601
  },
  "Monitor Deals": {
    sectioncat: 599,
    pagecat: 601
  },
  "Gaming Monitors": {
    sectioncat: 599,
    pagecat: 601
  },
  "Gaming Monitor": {
    sectioncat: 599,
    pagecat: 601
  },
  Printers: {
    sectioncat: 599,
    pagecat: 601
  },
  Printer: {
    sectioncat: 599,
    pagecat: 601
  },
  "3D Printers": {
    sectioncat: 599,
    pagecat: 601
  },
  "3d Printer": {
    sectioncat: 599,
    pagecat: 601
  },
  "All In One Printers": {
    sectioncat: 599,
    pagecat: 601
  },
  "Ink and Toner": {
    sectioncat: 599,
    pagecat: 601
  },
  "Ink Cartridge": {
    sectioncat: 599,
    pagecat: 601
  },
  "Inkjet Printers": {
    sectioncat: 599,
    pagecat: 601
  },
  "Inkjet Printer": {
    sectioncat: 599,
    pagecat: 601
  },
  "Laser Printers": {
    sectioncat: 599,
    pagecat: 601
  },
  "Laser Printer": {
    sectioncat: 599,
    pagecat: 601
  },
  "Servers & NAS": {
    sectioncat: 599,
    pagecat: 616
  },
  Servers: {
    sectioncat: 599,
    pagecat: 616
  },
  Software: {
    sectioncat: 599,
    pagecat: 602
  },
  "Antivirus Software": {
    sectioncat: 599,
    pagecat: 608
  },
  Antivirus: {
    sectioncat: 599,
    pagecat: 608
  },
  Apps: {
    sectioncat: 599,
    pagecat: 602
  },
  "Windows Software": {
    sectioncat: 599,
    pagecat: 602
  },
  Windows: {
    sectioncat: 599,
    pagecat: 602
  },
  "Tablets & eReaders": {
    sectioncat: 632,
    pagecat: 636
  },
  Tablets: {
    sectioncat: 632,
    pagecat: 636
  },
  Education: {
    sectioncat: 132,
    pagecat: 132
  },
  "Student Discounts": {
    sectioncat: 132,
    pagecat: 132
  },
  Entertainment: {
    sectioncat: "JLBCU7",
    pagecat: "JLBCU7"
  },
  Anime: {
    sectioncat: "JLBCU7",
    pagecat: "JLBCU7"
  },
  "Games, Board Games & Card Games": {
    sectioncat: 269,
    pagecat: 270
  },
  Movies: {
    sectioncat: 324,
    pagecat: 324
  },
  "Blu-ray & 4K Blu-ray": {
    sectioncat: "JLBCU7",
    pagecat: "JLBCU7"
  },
  DVD: {
    sectioncat: "JLBCU7",
    pagecat: "JLBCU7"
  },
  "Digital Movie Download & Streaming": {
    sectioncat: 324,
    pagecat: 324
  },
  "Movie Rentals": {
    sectioncat: 324,
    pagecat: 324
  },
  "Star Wars": {
    sectioncat: 324,
    pagecat: 324
  },
  Music: {
    sectioncat: 338,
    pagecat: 338
  },
  "Digital Music Download & Streaming": {
    sectioncat: 338,
    pagecat: 338
  },
  "Musical Instruments": {
    sectioncat: 338,
    pagecat: 338
  },
  Guitars: {
    sectioncat: 338,
    pagecat: 338
  },
  "Vinyl & LPs": {
    sectioncat: 338,
    pagecat: 338
  },
  "Streaming Services": {
    sectioncat: "JLBCU7",
    pagecat: "JLBCU7"
  },
  "TV Series & TV Shows": {
    sectioncat: 640,
    pagecat: 640
  },
  "Tickets & Admission": {
    sectioncat: 150,
    pagecat: 150
  },
  "Financial Tools & Services": {
    sectioncat: 410,
    pagecat: 410
  },
  "Financial Tools": {
    sectioncat: 410,
    pagecat: 410
  },
  "Flowers & Gifts": {
    sectioncat: 476,
    pagecat: 476
  },
  "Flowers Gifts": {
    sectioncat: 476,
    pagecat: 476
  },
  "Cigars, Cigarettes & E-Cigs": {
    sectioncat: 476,
    pagecat: 260
  },
  "Cigars Cigarettes E Cigs": {
    sectioncat: 476,
    pagecat: 260
  },
  Costumes: {
    sectioncat: 476,
    pagecat: 202
  },
  "Gift Baskets": {
    sectioncat: 476,
    pagecat: 476
  },
  "Gift Basket": {
    sectioncat: 476,
    pagecat: 476
  },
  "Gift Cards": {
    sectioncat: 476,
    pagecat: 476
  },
  "Gift Card": {
    sectioncat: 476,
    pagecat: 476
  },
  "Greeting Cards & Invitations": {
    sectioncat: 476,
    pagecat: 476
  },
  Gift: {
    sectioncat: 476,
    pagecat: 476
  },
  "Party Supplies": {
    sectioncat: 476,
    pagecat: 161
  },
  "Personalized Gifts": {
    sectioncat: 476,
    pagecat: 476
  },
  Grocery: {
    sectioncat: 477,
    pagecat: 477
  },
  "Baking and Cooking": {
    sectioncat: 477,
    pagecat: 216
  },
  Baking: {
    sectioncat: 477,
    pagecat: 216
  },
  "Breakfast Foods": {
    sectioncat: 477,
    pagecat: 210
  },
  Breakfast: {
    sectioncat: 477,
    pagecat: 210
  },
  "Candy, Chocolate & Gum": {
    sectioncat: 477,
    pagecat: 477
  },
  Candy: {
    sectioncat: 477,
    pagecat: 477
  },
  "Cleaning Supplies": {
    sectioncat: 477,
    pagecat: 477
  },
  "Kitchen & Bathroom Cleaning Supplies": {
    sectioncat: 477,
    pagecat: 477
  },
  "Bathroom Cleaner": {
    sectioncat: 477,
    pagecat: 477
  },
  Laundery: {
    sectioncat: 477,
    pagecat: 477
  },
  "Laundery Detergent": {
    sectioncat: 477,
    pagecat: 477
  },
  Condiments: {
    sectioncat: 477,
    pagecat: 477
  },
  Condiment: {
    sectioncat: 477,
    pagecat: 477
  },
  Dairy: {
    sectioncat: 477,
    pagecat: 210
  },
  Dessert: {
    sectioncat: 477,
    pagecat: 217
  },
  "Drinks & Beverages": {
    sectioncat: 477,
    pagecat: 477
  },
  Drink: {
    sectioncat: 477,
    pagecat: 477
  },
  Alcohol: {
    sectioncat: 477,
    pagecat: 211
  },
  Coffee: {
    sectioncat: 477,
    pagecat: 210
  },
  "Coffee & Espresso": {
    sectioncat: 477,
    pagecat: 210
  },
  "Energy Drinks & Sports Drinks": {
    sectioncat: 477,
    pagecat: 210
  },
  "Energy Drink": {
    sectioncat: 477,
    pagecat: 210
  },
  "Soda & Soft Drinks": {
    sectioncat: 477,
    pagecat: 210
  },
  Soda: {
    sectioncat: 477,
    pagecat: 210
  },
  Tea: {
    sectioncat: 477,
    pagecat: 210
  },
  Water: {
    sectioncat: 477,
    pagecat: 210
  },
  "Health Food": {
    sectioncat: 477,
    pagecat: 210
  },
  "Household Goods": {
    sectioncat: 477,
    pagecat: 477
  },
  "Household Items": {
    sectioncat: 477,
    pagecat: 477
  },
  "Facial Tissue": {
    sectioncat: 477,
    pagecat: 477
  },
  "Paper Towels": {
    sectioncat: 477,
    pagecat: 477
  },
  "Toilet Paper": {
    sectioncat: 477,
    pagecat: 477
  },
  "Meal Prep & Food Containers": {
    sectioncat: 477,
    pagecat: 477
  },
  "Meal Prep Food Containers": {
    sectioncat: 477,
    pagecat: 477
  },
  "Meat, Fish, & Poultry": {
    sectioncat: 477,
    pagecat: 210
  },
  Meat: {
    sectioncat: 477,
    pagecat: 210
  },
  "Deli & Cold Cuts": {
    sectioncat: 477,
    pagecat: 210
  },
  Deli: {
    sectioncat: 477,
    pagecat: 210
  },
  "Hot Dogs": {
    sectioncat: 477,
    pagecat: 210
  },
  "Hot Dog": {
    sectioncat: 477,
    pagecat: 210
  },
  Pasta: {
    sectioncat: 477,
    pagecat: 210
  },
  "Rice & Grains": {
    sectioncat: 477,
    pagecat: 210
  },
  Rice: {
    sectioncat: 477,
    pagecat: 210
  },
  "Snacks, Nuts & Chips": {
    sectioncat: 477,
    pagecat: 210
  },
  Snacks: {
    sectioncat: 477,
    pagecat: 210
  },
  "Soups, Sauces, Packaged Meals & Canned Goods": {
    sectioncat: 477,
    pagecat: 210
  },
  "Soups Sauces Canned Goods": {
    sectioncat: 477,
    pagecat: 210
  },
  "Health & Beauty": {
    sectioncat: 552,
    pagecat: 553
  },
  Beauty: {
    sectioncat: 552,
    pagecat: 553
  },
  "Contacts & Glasses": {
    sectioncat: 479,
    pagecat: 479
  },
  "Contacts Glasses": {
    sectioncat: 479,
    pagecat: 479
  },
  "Face Masks & Gloves": {
    sectioncat: 479,
    pagecat: 479
  },
  "Face Mask": {
    sectioncat: 479,
    pagecat: 479
  },
  "Fitness & Wellness": {
    sectioncat: 483,
    pagecat: 225
  },
  Supplement: {
    sectioncat: 225,
    pagecat: 225
  },
  "Fragrances, Cologne & Perfume": {
    sectioncat: 553,
    pagecat: 558
  },
  "Fragrance Cologne Perfume": {
    sectioncat: 553,
    pagecat: 558
  },
  "Hand Sanitizer": {
    sectioncat: 479,
    pagecat: 479
  },
  Makeup: {
    sectioncat: 553,
    pagecat: 555
  },
  "Massage & Spa": {
    sectioncat: 671,
    pagecat: 671
  },
  "Massage And Spa": {
    sectioncat: 671,
    pagecat: 671
  },
  "Personal Care": {
    sectioncat: 590,
    pagecat: 590
  },
  "Body Wash, Bar Soap & Hand Soap": {
    sectioncat: 590,
    pagecat: 591
  },
  "Body Wash": {
    sectioncat: 590,
    pagecat: 591
  },
  "Protein Powder & Shakes": {
    sectioncat: 223,
    pagecat: 229
  },
  "Protein Powder": {
    sectioncat: 223,
    pagecat: 229
  },
  "Razors & Shaving Supplies": {
    sectioncat: 590,
    pagecat: 594
  },
  Razor: {
    sectioncat: 590,
    pagecat: 594
  },
  "Shampoo & Hair Care": {
    sectioncat: 553,
    pagecat: 554
  },
  Shampoo: {
    sectioncat: 553,
    pagecat: 554
  },
  "Skin Care": {
    sectioncat: 553,
    pagecat: 559
  },
  Supplements: {
    sectioncat: 223,
    pagecat: 229
  },
  "Toothpaste, Toothbrushes & Oral Care": {
    sectioncat: 590,
    pagecat: 593
  },
  Toothbrush: {
    sectioncat: 590,
    pagecat: 593
  },
  Vitamins: {
    sectioncat: 590,
    pagecat: 593
  },
  Hobbies: {
    sectioncat: 239,
    pagecat: 239
  },
  "Arts & Crafts": {
    sectioncat: 239,
    pagecat: 248
  },
  Crafts: {
    sectioncat: 239,
    pagecat: 248
  },
  Collectibles: {
    sectioncat: 239,
    pagecat: 261
  },
  Drones: {
    sectioncat: 239,
    pagecat: 638
  },
  "Home & Home Improvement": {
    sectioncat: 274,
    pagecat: 274
  },
  Home: {
    sectioncat: 274,
    pagecat: 274
  },
  "Bed & Bath": {
    sectioncat: 274,
    pagecat: 274
  },
  Bed: {
    sectioncat: 274,
    pagecat: 274
  },
  "Sheets & Bedding": {
    sectioncat: 274,
    pagecat: 274
  },
  Sheets: {
    sectioncat: 274,
    pagecat: 274
  },
  "Shower Curtains": {
    sectioncat: 274,
    pagecat: 274
  },
  "Shower Curtain": {
    sectioncat: 274,
    pagecat: 274
  },
  Towels: {
    sectioncat: 274,
    pagecat: 274
  },
  "Building & Remodeling Supplies": {
    sectioncat: 274,
    pagecat: 276
  },
  Remodeling: {
    sectioncat: 274,
    pagecat: 276
  },
  Furniture: {
    sectioncat: 274,
    pagecat: 274
  },
  "Furniture Deals": {
    sectioncat: 274,
    pagecat: 274
  },
  "Bedroom Furniture": {
    sectioncat: 274,
    pagecat: 274
  },
  "Dining Room Furniture": {
    sectioncat: 274,
    pagecat: 274
  },
  "Family Room Furniture": {
    sectioncat: 274,
    pagecat: 274
  },
  "Home Office Furniture": {
    sectioncat: 274,
    pagecat: 274
  },
  "Living Room Furniture": {
    sectioncat: 274,
    pagecat: 274
  },
  "Living Room": {
    sectioncat: 274,
    pagecat: 274
  },
  "Outdoor & Patio Furniture": {
    sectioncat: 274,
    pagecat: 285
  },
  "Outdoor Furniture": {
    sectioncat: 274,
    pagecat: 285
  },
  Garage: {
    sectioncat: 274,
    pagecat: 274
  },
  "Gardening & Outdoor": {
    sectioncat: 274,
    pagecat: 275
  },
  Gardening: {
    sectioncat: 274,
    pagecat: 275
  },
  "Fire Pits": {
    sectioncat: 274,
    pagecat: 285
  },
  Fire: {
    sectioncat: 274,
    pagecat: 285
  },
  "Garden & Outdoor Tools": {
    sectioncat: 274,
    pagecat: 275
  },
  "Garden Tools": {
    sectioncat: 274,
    pagecat: 275
  },
  Generators: {
    sectioncat: 274,
    pagecat: 274
  },
  Griddles: {
    sectioncat: 274,
    pagecat: 274
  },
  "Grills & Grilling Accessories": {
    sectioncat: 274,
    pagecat: 274
  },
  Grill: {
    sectioncat: 274,
    pagecat: 274
  },
  "Outdoor Heaters": {
    sectioncat: 274,
    pagecat: 274
  },
  "Outdoor Heater": {
    sectioncat: 274,
    pagecat: 274
  },
  "Patio & Pool": {
    sectioncat: 274,
    pagecat: 274
  },
  "Patio And Pool": {
    sectioncat: 274,
    pagecat: 274
  },
  "Pest Control": {
    sectioncat: 274,
    pagecat: 274
  },
  "Plants and Supplies": {
    sectioncat: 274,
    pagecat: 275
  },
  Plants: {
    sectioncat: 274,
    pagecat: 275
  },
  "Snow Blowers & Leaf Blowers": {
    sectioncat: 274,
    pagecat: 274
  },
  "Snow Blower": {
    sectioncat: 274,
    pagecat: 274
  },
  "Trimmers, Edgers & Lawn Mowers": {
    sectioncat: 274,
    pagecat: 274
  },
  Trimmer: {
    sectioncat: 274,
    pagecat: 274
  },
  "Home Automation": {
    sectioncat: 274,
    pagecat: 277
  },
  "Home Decor": {
    sectioncat: 274,
    pagecat: 283
  },
  Art: {
    sectioncat: 274,
    pagecat: 283
  },
  "Candles & Home Fragrances": {
    sectioncat: 274,
    pagecat: 274
  },
  Candle: {
    sectioncat: 274,
    pagecat: 274
  },
  Clocks: {
    sectioncat: 274,
    pagecat: 274
  },
  Clock: {
    sectioncat: 274,
    pagecat: 274
  },
  "Decorative Pillows & Blankets": {
    sectioncat: 274,
    pagecat: 283
  },
  "Decorative Pillows And Blankets": {
    sectioncat: 274,
    pagecat: 283
  },
  "Holiday Decor": {
    sectioncat: 274,
    pagecat: 283
  },
  "Holiday Decorations": {
    sectioncat: 274,
    pagecat: 283
  },
  "Indoor Plants": {
    sectioncat: 274,
    pagecat: 274
  },
  "Lamps and Shades": {
    sectioncat: 274,
    pagecat: 274
  },
  "Lamp and Shades": {
    sectioncat: 274,
    pagecat: 274
  },
  Mirrors: {
    sectioncat: 274,
    pagecat: 274
  },
  "Pictures & Frames": {
    sectioncat: 274,
    pagecat: 283
  },
  "Pictures And Frames": {
    sectioncat: 274,
    pagecat: 283
  },
  Rugs: {
    sectioncat: 274,
    pagecat: 274
  },
  "Wall Decor": {
    sectioncat: 274,
    pagecat: 283
  },
  "Window Treatments": {
    sectioncat: 274,
    pagecat: 274
  },
  "Home Security & Safety": {
    sectioncat: 274,
    pagecat: 281
  },
  "Kitchenware & Cookware": {
    sectioncat: 274,
    pagecat: 274
  },
  Kitchenware: {
    sectioncat: 274,
    pagecat: 274
  },
  "Dinnerware & Bakeware": {
    sectioncat: 274,
    pagecat: 274
  },
  Dinnerware: {
    sectioncat: 274,
    pagecat: 274
  },
  Utensils: {
    sectioncat: 274,
    pagecat: 274
  },
  "Large Appliances": {
    sectioncat: 274,
    pagecat: 278
  },
  Appliance: {
    sectioncat: 274,
    pagecat: 278
  },
  "Air Conditioners": {
    sectioncat: 274,
    pagecat: 274
  },
  Dishwashers: {
    sectioncat: 274,
    pagecat: 278
  },
  Dishwasher: {
    sectioncat: 274,
    pagecat: 278
  },
  "Refrigerators & Freezers": {
    sectioncat: 274,
    pagecat: 278
  },
  Refrigerator: {
    sectioncat: 274,
    pagecat: 278
  },
  Stoves: {
    sectioncat: 274,
    pagecat: 278
  },
  Stove: {
    sectioncat: 274,
    pagecat: 278
  },
  "Vacuums, Carpet Cleaners & Floor Cleaners": {
    sectioncat: 274,
    pagecat: 274
  },
  Vacuum: {
    sectioncat: 274,
    pagecat: 274
  },
  "Washers & Dryers": {
    sectioncat: 274,
    pagecat: 278
  },
  "Washing Machine": {
    sectioncat: 274,
    pagecat: 278
  },
  Lighting: {
    sectioncat: 274,
    pagecat: 274
  },
  "Small Appliances": {
    sectioncat: 274,
    pagecat: 278
  },
  "Air Fryers & Deep Fryers": {
    sectioncat: 274,
    pagecat: 278
  },
  "Air Fryer": {
    sectioncat: 274,
    pagecat: 278
  },
  "Blenders & Juicers": {
    sectioncat: 274,
    pagecat: 278
  },
  Blender: {
    sectioncat: 274,
    pagecat: 278
  },
  "Coffee Makers, Espresso Machines & Tea Kettles": {
    sectioncat: 274,
    pagecat: 278
  },
  "Coffee Maker": {
    sectioncat: 274,
    pagecat: 278
  },
  Fans: {
    sectioncat: 274,
    pagecat: 274
  },
  Fan: {
    sectioncat: 274,
    pagecat: 274
  },
  Microwaves: {
    sectioncat: 274,
    pagecat: 278
  },
  Microwave: {
    sectioncat: 274,
    pagecat: 278
  },
  Mixers: {
    sectioncat: 274,
    pagecat: 278
  },
  Mixer: {
    sectioncat: 274,
    pagecat: 278
  },
  "Precision Cookers": {
    sectioncat: 274,
    pagecat: 278
  },
  "Precision Cooker": {
    sectioncat: 274,
    pagecat: 278
  },
  "Pressure Cookers": {
    sectioncat: 274,
    pagecat: 278
  },
  "Pressure Cooker": {
    sectioncat: 274,
    pagecat: 278
  },
  "Rice Cookers": {
    sectioncat: 274,
    pagecat: 278
  },
  "Rice Cooker": {
    sectioncat: 274,
    pagecat: 278
  },
  "Slow Cookers": {
    sectioncat: 274,
    pagecat: 278
  },
  "Slow Cooker": {
    sectioncat: 274,
    pagecat: 278
  },
  "Space Heaters": {
    sectioncat: 274,
    pagecat: 274
  },
  "Space Heater": {
    sectioncat: 274,
    pagecat: 274
  },
  "Toasters & Toaster Ovens": {
    sectioncat: 274,
    pagecat: 278
  },
  Toaster: {
    sectioncat: 274,
    pagecat: 278
  },
  "Storage & Cleaning": {
    sectioncat: 274,
    pagecat: 274
  },
  Cleaning: {
    sectioncat: 274,
    pagecat: 274
  },
  Tools: {
    sectioncat: 274,
    pagecat: 274
  },
  "Drills & Power Tools": {
    sectioncat: 274,
    pagecat: 274
  },
  Drill: {
    sectioncat: 274,
    pagecat: 274
  },
  "Extension cords": {
    sectioncat: 274,
    pagecat: 274
  },
  Flashlights: {
    sectioncat: 274,
    pagecat: 274
  },
  Flashlight: {
    sectioncat: 274,
    pagecat: 274
  },
  "Hand Tools": {
    sectioncat: 274,
    pagecat: 274
  },
  "Hand Tool": {
    sectioncat: 274,
    pagecat: 274
  },
  Ladders: {
    sectioncat: 274,
    pagecat: 274
  },
  "Saws & Chainsaws": {
    sectioncat: 274,
    pagecat: 274
  },
  Chainsaw: {
    sectioncat: 274,
    pagecat: 274
  },
  "Tool Boxes & Tool Chests": {
    sectioncat: 274,
    pagecat: 274
  },
  "Tool Box": {
    sectioncat: 274,
    pagecat: 274
  },
  "Tool Sets": {
    sectioncat: 274,
    pagecat: 274
  },
  "Tool Set": {
    sectioncat: 274,
    pagecat: 274
  },
  Occasions: {
    sectioncat: 481,
    pagecat: 478
  },
  "Office & School Supplies": {
    sectioncat: 479,
    pagecat: 479
  },
  Office: {
    sectioncat: 479,
    pagecat: 479
  },
  "Blank Media": {
    sectioncat: 479,
    pagecat: 479
  },
  Media: {
    sectioncat: 479,
    pagecat: 479
  },
  "Office Furniture": {
    sectioncat: 479,
    pagecat: 479
  },
  Paper: {
    sectioncat: 479,
    pagecat: 479
  },
  "Pencils, Pens & Markers": {
    sectioncat: 479,
    pagecat: 479
  },
  Other: {
    sectioncat: 473,
    pagecat: 473
  },
  Pets: {
    sectioncat: 422,
    pagecat: 422
  },
  "Pet Care & Supplies": {
    sectioncat: 422,
    pagecat: 431
  },
  "Pet Care": {
    sectioncat: 422,
    pagecat: 431
  },
  "Pet Food": {
    sectioncat: 422,
    pagecat: 431
  },
  "Cat Food & Treats": {
    sectioncat: 422,
    pagecat: 424
  },
  "Cat Food": {
    sectioncat: 422,
    pagecat: 424
  },
  "Dog Food & Treats": {
    sectioncat: 422,
    pagecat: 425
  },
  "Dog Food And Treats": {
    sectioncat: 422,
    pagecat: 425
  },
  "Pet Toys": {
    sectioncat: 422,
    pagecat: 431
  },
  "Pet Toy": {
    sectioncat: 422,
    pagecat: 431
  },
  Restaurants: {
    sectioncat: 210,
    pagecat: 210
  },
  Restaurant: {
    sectioncat: 210,
    pagecat: 210
  },
  "Delivery & Take Out": {
    sectioncat: 210,
    pagecat: 218
  },
  "Delivery Out": {
    sectioncat: 210,
    pagecat: 218
  },
  "Fast Food": {
    sectioncat: 210,
    pagecat: 218
  },
  "Fast Food Coupons": {
    sectioncat: 210,
    pagecat: 218
  },
  Pizza: {
    sectioncat: 210,
    pagecat: 218
  },
  Services: {
    sectioncat: 473,
    pagecat: 473
  },
  "Daily Deals & Flash Sales": {
    sectioncat: 473,
    pagecat: 481
  },
  "Daily Deals And Flash Sales": {
    sectioncat: 473,
    pagecat: 481
  },
  "Dating Services": {
    sectioncat: 186,
    pagecat: 188
  },
  "Delivery Services": {
    sectioncat: 473,
    pagecat: 473
  },
  Memberships: {
    sectioncat: 473,
    pagecat: 473
  },
  Membership: {
    sectioncat: 473,
    pagecat: 473
  },
  "Online Services": {
    sectioncat: 473,
    pagecat: 473
  },
  "Phone Services": {
    sectioncat: 391,
    pagecat: 420
  },
  "Printing Services": {
    sectioncat: 473,
    pagecat: 473
  },
  "TV & Internet Providers": {
    sectioncat: 417,
    pagecat: 419
  },
  "TV And Internet Providers": {
    sectioncat: 417,
    pagecat: 419
  },
  "Tax Services": {
    sectioncat: 391,
    pagecat: 415
  },
  "Web Hosting & Domains": {
    sectioncat: 619,
    pagecat: 622
  },
  "Web Hosting And Domains": {
    sectioncat: 619,
    pagecat: 622
  },
  "Sporting Goods": {
    sectioncat: 483,
    pagecat: 483
  },
  Sport: {
    sectioncat: 483,
    pagecat: 483
  },
  "Bicycles & Bike Accessories": {
    sectioncat: 483,
    pagecat: 492
  },
  Bicycles: {
    sectioncat: 483,
    pagecat: 492
  },
  Ebikes: {
    sectioncat: 483,
    pagecat: 492
  },
  Ebike: {
    sectioncat: 483,
    pagecat: 492
  },
  "Mountain Bikes": {
    sectioncat: 483,
    pagecat: 492
  },
  "Mountain Bike": {
    sectioncat: 483,
    pagecat: 492
  },
  "Exercise Equipment": {
    sectioncat: 483,
    pagecat: 551
  },
  Golf: {
    sectioncat: 483,
    pagecat: 512
  },
  "Golf Clubs & Equipment": {
    sectioncat: 483,
    pagecat: 512
  },
  "Golf Clubs": {
    sectioncat: 483,
    pagecat: 512
  },
  Outdoors: {
    sectioncat: 483,
    pagecat: 483
  },
  Camping: {
    sectioncat: 677,
    pagecat: 677
  },
  Coolers: {
    sectioncat: 483,
    pagecat: 483
  },
  Fishing: {
    sectioncat: 483,
    pagecat: 483
  },
  Hiking: {
    sectioncat: 483,
    pagecat: 483
  },
  Hunting: {
    sectioncat: 483,
    pagecat: 514
  },
  Scooters: {
    sectioncat: 483,
    pagecat: 29
  },
  Scooter: {
    sectioncat: 483,
    pagecat: 29
  },
  "Ski & Snowboard": {
    sectioncat: 498,
    pagecat: 504
  },
  "Ski And Snowboard": {
    sectioncat: 498,
    pagecat: 504
  },
  "Sports Equipment": {
    sectioncat: 483,
    pagecat: 551
  },
  "Surf & Skate": {
    sectioncat: 498,
    pagecat: 506
  },
  "Surf And Skate": {
    sectioncat: 498,
    pagecat: 506
  },
  "Water Bottles": {
    sectioncat: 483,
    pagecat: 483
  },
  "Water Bottle": {
    sectioncat: 483,
    pagecat: 483
  },
  "Tech & Electronics": {
    sectioncat: 632,
    pagecat: 632
  },
  Tech: {
    sectioncat: 632,
    pagecat: 632
  },
  "Audio / Video": {
    sectioncat: 632,
    pagecat: 634
  },
  Audio: {
    sectioncat: 632,
    pagecat: 634
  },
  "Blu-ray & DVD Players": {
    sectioncat: 632,
    pagecat: 634
  },
  "Bluray Player": {
    sectioncat: 632,
    pagecat: 634
  },
  "Bluetooth Speakers & Smart Speakers": {
    sectioncat: 632,
    pagecat: 634
  },
  "Bluetooth Speaker": {
    sectioncat: 632,
    pagecat: 634
  },
  "Headphones, Headsets & Earbuds": {
    sectioncat: 632,
    pagecat: 637
  },
  Headphone: {
    sectioncat: 632,
    pagecat: 637
  },
  "Home Audio": {
    sectioncat: 632,
    pagecat: 634
  },
  "Home Theater": {
    sectioncat: 632,
    pagecat: 634
  },
  "Home Theater System": {
    sectioncat: 632,
    pagecat: 634
  },
  "Media Players": {
    sectioncat: 632,
    pagecat: 634
  },
  "Media Player": {
    sectioncat: 632,
    pagecat: 634
  },
  Receivers: {
    sectioncat: 632,
    pagecat: 634
  },
  Receiver: {
    sectioncat: 632,
    pagecat: 634
  },
  "Sound Bars": {
    sectioncat: 632,
    pagecat: 634
  },
  Soundbar: {
    sectioncat: 632,
    pagecat: 634
  },
  Speakers: {
    sectioncat: 632,
    pagecat: 634
  },
  Cameras: {
    sectioncat: 632,
    pagecat: 633
  },
  Photo: {
    sectioncat: 632,
    pagecat: 633
  },
  "Camera Accessories": {
    sectioncat: 632,
    pagecat: 633
  },
  "Camera Lenses": {
    sectioncat: 632,
    pagecat: 633
  },
  Lens: {
    sectioncat: 632,
    pagecat: 633
  },
  DSLR: {
    sectioncat: 632,
    pagecat: 633
  },
  "Dslr Camera Deals": {
    sectioncat: 632,
    pagecat: 633
  },
  "Dash Cams & Action Cams": {
    sectioncat: 632,
    pagecat: 633
  },
  "Dash Cam": {
    sectioncat: 632,
    pagecat: 633
  },
  Mirrorless: {
    sectioncat: 632,
    pagecat: 633
  },
  "Photo Prints": {
    sectioncat: 632,
    pagecat: 255
  },
  "Photo Prints And Services": {
    sectioncat: 632,
    pagecat: 255
  },
  "Security Cameras": {
    sectioncat: 632,
    pagecat: 633
  },
  Tripods: {
    sectioncat: 632,
    pagecat: 633
  },
  Tripod: {
    sectioncat: 632,
    pagecat: 633
  },
  GPS: {
    sectioncat: 632,
    pagecat: 637
  },
  Gps: {
    sectioncat: 632,
    pagecat: 637
  },
  Phones: {
    sectioncat: 632,
    pagecat: 635
  },
  Phone: {
    sectioncat: 632,
    pagecat: 635
  },
  "Cell Phone Plans & Services": {
    sectioncat: 632,
    pagecat: 635
  },
  "Cellphone Providers": {
    sectioncat: 632,
    pagecat: 635
  },
  "Cell Phones": {
    sectioncat: 632,
    pagecat: 635
  },
  "Cell Phone Deals": {
    sectioncat: 632,
    pagecat: 635
  },
  "Phone Accessories": {
    sectioncat: 632,
    pagecat: 635
  },
  "Prepaid Phones & Refill Cards": {
    sectioncat: 632,
    pagecat: 635
  },
  "Prepaid Phones": {
    sectioncat: 632,
    pagecat: 635
  },
  Smartphones: {
    sectioncat: 632,
    pagecat: 635
  },
  Smartphone: {
    sectioncat: 632,
    pagecat: 635
  },
  Projectors: {
    sectioncat: 632,
    pagecat: 634
  },
  Projector: {
    sectioncat: 632,
    pagecat: 634
  },
  "Smart Watches & Wearables": {
    sectioncat: 632,
    pagecat: 637
  },
  "Smart Watch": {
    sectioncat: 632,
    pagecat: 637
  },
  TV: {
    sectioncat: 632,
    pagecat: 634
  },
  "Tv Deals": {
    sectioncat: 632,
    pagecat: 634
  },
  "4K TVs": {
    sectioncat: 632,
    pagecat: 634
  },
  "8K TVs": {
    sectioncat: 632,
    pagecat: 634
  },
  HDTV: {
    sectioncat: 632,
    pagecat: 634
  },
  "LED TVs": {
    sectioncat: 632,
    pagecat: 634
  },
  "OLED TVs": {
    sectioncat: 632,
    pagecat: 634
  },
  "QLED TVs": {
    sectioncat: 632,
    pagecat: 634
  },
  "Smart TVs": {
    sectioncat: 632,
    pagecat: 634
  },
  "TV Accessories": {
    sectioncat: 632,
    pagecat: 634
  },
  "TV Mounts": {
    sectioncat: 632,
    pagecat: 634
  },
  "Tech Accessories": {
    sectioncat: 632,
    pagecat: 632
  },
  Accessories: {
    sectioncat: 632,
    pagecat: 632
  },
  Batteries: {
    sectioncat: 632,
    pagecat: 632
  },
  Cables: {
    sectioncat: 632,
    pagecat: 632
  },
  Cable: {
    sectioncat: 632,
    pagecat: 632
  },
  "Chargers & Power Banks": {
    sectioncat: 632,
    pagecat: 632
  },
  Chargers: {
    sectioncat: 632,
    pagecat: 632
  },
  "Phone & Tablet Cases": {
    sectioncat: 632,
    pagecat: 635
  },
  "Phone Case": {
    sectioncat: 632,
    pagecat: 635
  },
  "Portable Power Stations": {
    sectioncat: 632,
    pagecat: 632
  },
  "Portable Power Station": {
    sectioncat: 632,
    pagecat: 632
  },
  "Remote Controls": {
    sectioncat: 632,
    pagecat: 632
  },
  "Remote Control": {
    sectioncat: 632,
    pagecat: 632
  },
  "Uninterruptible Power Supply (UPS), Surge Protectors & Powerstrips": {
    sectioncat: 632,
    pagecat: 632
  },
  "Power Strip": {
    sectioncat: 632,
    pagecat: 632
  },
  "Travel & Vacations": {
    sectioncat: 653,
    pagecat: 653
  },
  "Travel Deals": {
    sectioncat: 653,
    pagecat: 653
  },
  "Car Rentals": {
    sectioncat: 653,
    pagecat: 41
  },
  Cruises: {
    sectioncat: 653,
    pagecat: 678
  },
  Flights: {
    sectioncat: 653,
    pagecat: 672
  },
  Airfares: {
    sectioncat: 653,
    pagecat: 672
  },
  Hotels: {
    sectioncat: 653,
    pagecat: 668
  },
  Hotel: {
    sectioncat: 653,
    pagecat: 668
  },
  "RV & Camper Van Rentals": {
    sectioncat: 653,
    pagecat: 41
  },
  "Rv And Camper Van Rentals": {
    sectioncat: 653,
    pagecat: 41
  },
  "Theme Parks & Attractions": {
    sectioncat: 53,
    pagecat: 151
  },
  "Theme Parks And Attractions": {
    sectioncat: 53,
    pagecat: 151
  },
  "Tours & Travel Packages": {
    sectioncat: 653,
    pagecat: 153
  },
  Tour: {
    sectioncat: 653,
    pagecat: 153
  },
  "Vacation Rentals": {
    sectioncat: 653,
    pagecat: 653
  },
  "Video Games": {
    sectioncat: 680,
    pagecat: 680
  },
  "Video Game Deals": {
    sectioncat: 680,
    pagecat: 680
  },
  "3DS": {
    sectioncat: 680,
    pagecat: 681
  },
  "3ds": {
    sectioncat: 680,
    pagecat: 681
  },
  "App Games": {
    sectioncat: 680,
    pagecat: 683
  },
  Arcade: {
    sectioncat: 680,
    pagecat: 680
  },
  "Computer & PC": {
    sectioncat: 680,
    pagecat: 684
  },
  "Pc Game": {
    sectioncat: 680,
    pagecat: 684
  },
  "Digital Game Downloads": {
    sectioncat: 680,
    pagecat: 680
  },
  "Digital Games": {
    sectioncat: 680,
    pagecat: 680
  },
  "Nintendo Switch": {
    sectioncat: 680,
    pagecat: 681
  },
  PS3: {
    sectioncat: 680,
    pagecat: 681
  },
  "Ps3 Game": {
    sectioncat: 680,
    pagecat: 681
  },
  PS4: {
    sectioncat: 680,
    pagecat: 681
  },
  "Ps4 Deals": {
    sectioncat: 680,
    pagecat: 681
  },
  PS5: {
    sectioncat: 680,
    pagecat: 681
  },
  "Ps5 Deals": {
    sectioncat: 680,
    pagecat: 681
  },
  "VR (Virtual Reality) Headsets, Games & Accessories": {
    sectioncat: 680,
    pagecat: 639
  },
  "Virtual Reality": {
    sectioncat: 680,
    pagecat: 639
  },
  "Video Game Accessories": {
    sectioncat: 680,
    pagecat: 680
  },
  "Game Accessories": {
    sectioncat: 680,
    pagecat: 680
  },
  "Video Game Consoles": {
    sectioncat: 680,
    pagecat: 681
  },
  Console: {
    sectioncat: 680,
    pagecat: 681
  },
  "Video Game Memberships": {
    sectioncat: 680,
    pagecat: 680
  },
  "Game Memberships": {
    sectioncat: 680,
    pagecat: 680
  },
  "Wii & Wii U": {
    sectioncat: 680,
    pagecat: 681
  },
  "Wii U Games": {
    sectioncat: 680,
    pagecat: 681
  },
  "Xbox 360": {
    sectioncat: 680,
    pagecat: 681
  },
  "Xbox Games": {
    sectioncat: 680,
    pagecat: 681
  },
  "Xbox One": {
    sectioncat: 680,
    pagecat: 681
  },
  "Xbox One Deals": {
    sectioncat: 680,
    pagecat: 681
  },
  "Xbox Series X and Series S": {
    sectioncat: 680,
    pagecat: 681
  },
  "Xbox Series X": {
    sectioncat: 680,
    pagecat: 681
  }
};

// src/providers/amazonProviderAdapter.ts
var __decorate16 = function(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
    r = Reflect.decorate(decorators, target, key, desc);
  else
    for (var i = decorators.length - 1; i >= 0; i--)
      if (d = decorators[i])
        r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata13 = function(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
    return Reflect.metadata(k, v);
};
var __param11 = function(paramIndex, decorator) {
  return function(target, key) {
    decorator(target, key, paramIndex);
  };
};
var name3 = "AmazonProviderAdapter";
var _a18;
var AmazonProviderAdapter = (_a18 = class {
  constructor(gptCommonProvider, adUnitManager) {
    this.gptCommonProvider = gptCommonProvider;
    this.adUnitManager = adUnitManager;
    this.adUnits = /* @__PURE__ */ new Map();
    this.amazonAdUnits = new Array();
    this.units = this.adUnitManager.getAdUnits();
  }
  async init() {
    if (!await this.awaitGlobals()) {
      return false;
    }
    const conf = this.getConf();
    this.sg = conf.signals;
    this.apsTag.init(conf);
    this.apsTag.queue.push(function() {
      window.apstag.nativeContent().enable();
      window.apstag.nativeContent().registerHook("nativeCommerceAds.updateClickUrl", (url, element) => {
        const encodedNcaUrl = encodeURIComponent(url);
        const currentUrl = String(element.href);
        if (currentUrl) {
          return `${currentUrl}&nca=${encodedNcaUrl}`;
        }
      });
      aps.record("protectedAudience/allSlots/activate");
    });
    document.addEventListener(AdEventListeners.DestroyAdsEvent, this.resetAds.bind(this));
    return true;
  }
  initAdUnit(adUnit) {
    const element = this.units.get(adUnit.name);
    if (!element) {
      return;
    }
    this.gptCommonProvider.initAdUnit(adUnit);
    this.gptCommonProvider.setAdUnitProvider(adUnit, this);
    const unit = {
      slotID: adUnit.name,
      slotName: adUnit.placement,
      sizes: adUnit.sizes,
      dynamic: adUnit.dynamic
    };
    this.adUnits.set(adUnit.name, unit);
    this.amazonAdUnits.push(unit);
  }
  start(adUnitId, refresh = false) {
    const adUnit = this.adUnits.get(adUnitId);
    if (!adUnit || !this.adUnits.has(adUnitId)) {
      return;
    }
    this.gptCommonProvider.startBiddingProcess(adUnit.slotID, refresh, () => {
      if (!GptCommonProvider.amazonBidsRequested || refresh) {
        const slots = refresh || adUnit.dynamic ? [
          adUnit
        ] : this.amazonAdUnits;
        aps.record("ad/gpid/define", {
          map: Object.fromEntries(slots.map((slot) => {
            return [
              slot.slotID,
              getGpid({
                adUnitPath: slot.slotName,
                divId: slot.slotID
              })
            ];
          }))
        });
        this.apsTag.fetchBids({
          slots,
          sg: this.sg
        }, () => {
          this.gptCommonProvider.googlePublisherTag.pushCommand(() => {
            this.apsTag.setDisplayBids();
            GptCommonProvider.amazonBidsReceived = true;
            this.gptCommonProvider.bidsCompleteHandler(refresh, this, adUnit.slotID);
          });
        });
        printDebug(`${adUnitId}: bids request sent to amazon...`, {
          slots
        });
        GptCommonProvider.amazonBidsRequested = true;
      }
    });
  }
  getConf() {
    const pageGroup = DataLayer.get("page")?.pageGroup;
    const conf = generalConfig;
    conf.signals.ortb2.site.page = this.getCanonicalUrl();
    if (pageGroup === "Deal Details") {
      const category = DataLayer.get("product")?.category.split("|")[0].trim();
      this.handleCaseExtraSignalsConfig(category);
    } else if (pageGroup === "category") {
      const categories = DataLayer.get("page")?.pageName.split("/");
      let category1 = categories[categories.length - 2].trim();
      category1 = this.cleanCategoryName(category1);
      this.handleCaseExtraSignalsConfig(category1);
    }
    return conf;
  }
  getCanonicalUrl() {
    const linkElement = document.querySelector('link[rel="canonical"]');
    const canonicalAttr = linkElement ? linkElement.attributes.getNamedItem("href") : null;
    return canonicalAttr ? canonicalAttr.value : "";
  }
  cleanCategoryName(name5) {
    if (name5.indexOf("-") === -1) {
      return name5.charAt(0).toUpperCase() + name5.slice(1);
    } else {
      let words = name5.split("-");
      words = words.map((word) => word.charAt(0).toUpperCase() + word.slice(1));
      return words.join(" ");
    }
  }
  handleCaseExtraSignalsConfig(category) {
    if (category && signalDataConfigMap[category]) {
      this.addExtraSignalsConfig(this.getExtraSignalsConfig(category));
    }
  }
  addExtraSignalsConfig(conf) {
    const data = {
      sectioncat: [
        conf.sectioncat.toString()
      ],
      pagecat: [
        conf.pagecat.toString()
      ]
    };
    Object.assign(generalConfig["signals"]["ortb2"]["site"], data);
  }
  getExtraSignalsConfig(key) {
    return signalDataConfigMap[key];
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars,class-methods-use-this,@typescript-eslint/no-empty-function
  unload(adUnitId) {
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars,class-methods-use-this,@typescript-eslint/no-empty-function
  destroy(adUnitId) {
  }
  async awaitGlobals() {
    if (!this.apsTag) {
      try {
        this.apsTag = await awaitProperty("apstag", window, 80);
      } catch (e) {
        Logger.error("Unable to initialize window.apstag", e);
        return false;
      }
    }
    return true;
  }
  resetAds() {
    this.adUnits.clear();
    this.amazonAdUnits = [];
  }
}, __name(_a18, "AmazonProviderAdapter"), _a18);
AmazonProviderAdapter = __decorate16([
  injectable16(),
  __param11(0, inject10(name2)),
  __param11(1, inject10("AdUnitManager")),
  __metadata13("design:type", Function),
  __metadata13("design:paramtypes", [
    typeof GptCommonProvider === "undefined" ? Object : GptCommonProvider,
    typeof AdUnitManager === "undefined" ? Object : AdUnitManager
  ])
], AmazonProviderAdapter);

// src/providers/prebidProviderAdapter.ts
import { injectable as injectable17, inject as inject11 } from "inversify";

// src/providers/prebid/config.ts
var generalConfig2 = {
  useBidCache: true,
  enableTIDs: true,
  disableAjaxTimeout: true,
  userSync: {
    filterSettings: {
      iframe: {
        filter: "include",
        bidders: [
          "openx",
          "criteo",
          "ix",
          "appnexus",
          "pubmatic",
          "triplelift",
          "ttd"
        ]
      }
    },
    syncsPerBidder: 50,
    iframeEnabled: true,
    syncDelay: 3e3,
    syncEnabled: true,
    pixelEnabled: true,
    userIds: [
      {
        // NOTE: https://docs.prebid.org/dev-docs/modules/userId.html#rampid
        name: "identityLink",
        params: {
          pid: "101"
        },
        storage: {
          type: "html5",
          name: "idl_env",
          expires: 15,
          refreshInSeconds: 1800
        }
      },
      {
        // NOTE: https://docs.prebid.org/dev-docs/modules/userId.html#id5-universal-id
        name: "id5Id",
        params: {
          partner: 913,
          // NOTE: https://support.id5.io/portal/en/kb/articles/passing-partner-data-to-id5#Deriving_the_Partner_Data_pd_Value
          pd: (() => {
            if (typeof window === "undefined") {
              return "";
            }
            const emailHashes = window.dataLayer?.visitor?.emailHashes ?? null;
            if (emailHashes !== null && Array.isArray(emailHashes) && emailHashes.length >= 3) {
              return `1-${emailHashes[2]}`;
            }
            return "";
          })()
        },
        storage: {
          type: "html5",
          name: "id5id",
          expires: 90,
          refreshInSeconds: 8 * 3600
        }
      }
    ]
  },
  maxRequestsPerOrigin: 4,
  consentManagement: {
    usp: {
      cmpApi: "iab",
      timeout: 8e3
    }
  },
  sizeConfig: [
    {
      mediaQuery: "(min-width: 0px)",
      labels: [
        "classic_desktop_300x250"
      ],
      sizesSupported: [
        [
          300,
          250
        ]
      ]
    },
    {
      mediaQuery: "(min-width: 0px)",
      labels: [
        "classic_desktop_728x90"
      ],
      sizesSupported: [
        [
          728,
          90
        ]
      ]
    },
    {
      mediaQuery: "(min-width: 0px)",
      labels: [
        "redesign_desktop_shield_160x600"
      ],
      sizesSupported: [
        [
          160,
          600
        ]
      ]
    },
    {
      mediaQuery: "(min-width: 0px)",
      labels: [
        "redesign_desktop_300x250_300x600"
      ],
      sizesSupported: [
        [
          300,
          250
        ],
        [
          300,
          600
        ]
      ]
    },
    {
      mediaQuery: "(min-width: 0px)",
      labels: [
        "redesign_desktop_shield_728x90"
      ],
      sizesSupported: [
        [
          728,
          90
        ]
      ]
    },
    {
      mediaQuery: "(min-width: 0px)",
      labels: [
        "mweb_320x50_300x250_300x100"
      ],
      sizesSupported: [
        [
          320,
          50
        ],
        [
          300,
          250
        ],
        [
          300,
          100
        ]
      ]
    },
    {
      mediaQuery: "(min-width: 0px)",
      labels: [
        "mweb_320x50"
      ],
      sizesSupported: [
        [
          320,
          50
        ]
      ]
    },
    {
      mediaQuery: "(min-width: 0px)",
      labels: [
        "sharethrough"
      ],
      sizesSupported: [
        [
          0,
          0
        ]
      ]
    },
    {
      mediaQuery: "(min-width: 0px)",
      labels: [
        "classic_desktop_160x600"
      ],
      sizesSupported: [
        [
          160,
          600
        ]
      ]
    },
    {
      mediaQuery: "(min-width: 0px)",
      labels: [
        "redesign_desktop_160x600"
      ],
      sizesSupported: [
        [
          160,
          600
        ]
      ]
    },
    {
      mediaQuery: "(min-width: 0px)",
      labels: [
        "classic_desktop_shield_300x250"
      ],
      sizesSupported: [
        [
          300,
          250
        ]
      ]
    },
    {
      mediaQuery: "(min-width: 0px)",
      labels: [
        "classic_desktop_728x90_970x250_468x60"
      ],
      sizesSupported: [
        [
          728,
          90
        ],
        [
          970,
          250
        ],
        [
          468,
          60
        ]
      ]
    },
    {
      mediaQuery: "(min-width: 0px)",
      labels: [
        "classic_desktop_728x90_970x250"
      ],
      sizesSupported: [
        [
          728,
          90
        ],
        [
          970,
          250
        ]
      ]
    },
    {
      mediaQuery: "(min-width: 0px)",
      labels: [
        "classic_desktop_shield_160x600"
      ],
      sizesSupported: [
        [
          160,
          600
        ]
      ]
    },
    {
      mediaQuery: "(min-width: 0px)",
      labels: [
        "classic_desktop_shield_728x90"
      ],
      sizesSupported: [
        [
          728,
          90
        ]
      ]
    },
    {
      mediaQuery: "(min-width: 0px)",
      labels: [
        "redesign_desktop_728x90"
      ],
      sizesSupported: [
        [
          728,
          90
        ]
      ]
    },
    {
      mediaQuery: "(min-width: 0px)",
      labels: [
        "redesign_desktop_300x250"
      ],
      sizesSupported: [
        [
          300,
          250
        ]
      ]
    },
    {
      mediaQuery: "(min-width: 0px)",
      labels: [
        "classic_desktop_300x600_300x250"
      ],
      sizesSupported: [
        [
          300,
          600
        ],
        [
          300,
          250
        ]
      ]
    },
    {
      mediaQuery: "(min-width: 0px)",
      labels: [
        "redesign_desktop_160x600_300x250_300x600"
      ],
      sizesSupported: [
        [
          160,
          600
        ],
        [
          300,
          250
        ],
        [
          300,
          600
        ]
      ]
    },
    {
      mediaQuery: "(min-width: 0px)",
      labels: [
        "redesign_desktop_728x90_468x60"
      ],
      sizesSupported: [
        [
          728,
          90
        ],
        [
          468,
          60
        ]
      ]
    },
    {
      mediaQuery: "(min-width: 0px)",
      labels: [
        "mweb_320x50_300x250"
      ],
      sizesSupported: [
        [
          320,
          50
        ],
        [
          300,
          250
        ]
      ]
    },
    {
      mediaQuery: "(min-width: 0px)",
      labels: [
        "redesign_desktop_728x90_970x250"
      ],
      sizesSupported: [
        [
          728,
          90
        ],
        [
          970,
          250
        ]
      ]
    },
    {
      mediaQuery: "(min-width: 0px)",
      labels: [
        "redesign_desktop_shield_300x250"
      ],
      sizesSupported: [
        [
          300,
          250
        ]
      ]
    },
    {
      mediaQuery: "(min-width: 0px)",
      labels: [
        "redesign_desktop_728x90_970x250_468x60"
      ],
      sizesSupported: [
        [
          728,
          90
        ],
        [
          970,
          250
        ],
        [
          468,
          60
        ]
      ]
    },
    {
      mediaQuery: "(min-width: 0px)",
      labels: [
        "redesign_desktop_300x600_300x250"
      ],
      sizesSupported: [
        [
          300,
          600
        ],
        [
          300,
          250
        ]
      ]
    },
    {
      mediaQuery: "(min-width: 0px)",
      labels: [
        "mweb_300x250"
      ],
      sizesSupported: [
        [
          300,
          250
        ]
      ]
    }
  ],
  timeoutBuffer: 400,
  priceGranularity: {
    buckets: [
      {
        max: 3,
        cap: "False",
        increment: 0.01,
        min: 0
      },
      {
        max: 8,
        cap: "False",
        increment: 0.05,
        min: 3
      },
      {
        max: 50,
        cap: "False",
        increment: 0.5,
        min: 8
      },
      {
        max: 100,
        cap: "True",
        increment: 1,
        min: 50
      }
    ],
    precision: "2"
  }
};
var analyticsConfig = [
  {
    // NOTE: https://docs.prebid.org/dev-docs/analytics/ats.html#sidebar
    provider: "atsAnalytics",
    options: {
      pid: "101",
      host: "https://analytics.rlcdn.com"
    }
  }
];
var v7bidderSettings = {
  // Recommended Global Bidder Settings: https://docs.prebid.org/dev-docs/publisher-api-reference/bidderSettings.html
  standard: {
    storageAllowed: true
  }
};

// src/providers/prebidProviderAdapter.ts
var __decorate17 = function(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
    r = Reflect.decorate(decorators, target, key, desc);
  else
    for (var i = decorators.length - 1; i >= 0; i--)
      if (d = decorators[i])
        r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata14 = function(k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
    return Reflect.metadata(k, v);
};
var __param12 = function(paramIndex, decorator) {
  return function(target, key) {
    decorator(target, key, paramIndex);
  };
};
var name4 = "PrebidProviderAdapter";
var _a19;
var PrebidProviderAdapter = (_a19 = class {
  constructor(gptCommonProvider, adUnitManager) {
    this.gptCommonProvider = gptCommonProvider;
    this.adUnitManager = adUnitManager;
    this.PREBID_TIMEOUT = 1500;
    this.adUnits = /* @__PURE__ */ new Map();
    this.prebidAdUnits = new Array();
    this.adUnitCodes = new Array();
    this.units = this.adUnitManager.getAdUnits();
  }
  async init() {
    if (!await this.awaitGlobals()) {
      return false;
    }
    this.pbjs.que.push(() => {
      this.pbjs.setConfig(generalConfig2);
      this.injectLiveIntentConfig();
      this.pbjs.enableAnalytics(analyticsConfig);
      this.pbjs.bidderSettings = v7bidderSettings;
    });
    document.addEventListener(AdEventListeners.DestroyAdsEvent, this.resetAds.bind(this));
    return true;
  }
  initAdUnit(adUnit, config) {
    const element = this.units.get(adUnit.name);
    if (!element) {
      return;
    }
    this.gptCommonProvider.initAdUnit(adUnit);
    this.gptCommonProvider.setAdUnitProvider(adUnit, this);
    const unit = {
      code: adUnit.placement,
      mediaTypes: config.mediaTypes,
      bids: config.bids,
      dynamic: adUnit.dynamic,
      ortb2Imp: {
        ext: {
          gpid: adUnit.getGpid()
        }
      }
    };
    this.adUnits.set(adUnit.name, unit);
    if (config.bids && !this.prebidAdUnits.some((ad) => ad.code === unit.code)) {
      this.prebidAdUnits.push(unit);
      this.adUnitCodes.push(adUnit.placement);
    }
  }
  start(adUnitId, refresh = false) {
    const adUnit = this.adUnits.get(adUnitId);
    if (!adUnit || !this.adUnits.has(adUnitId)) {
      return;
    }
    this.gptCommonProvider.startBiddingProcess(adUnitId, refresh, () => {
      this.pbjs.que.push(() => {
        if (!GptCommonProvider.prebidBidsRequested || refresh) {
          if (!refresh && !adUnit.dynamic) {
            this.pbjs.addAdUnits(this.prebidAdUnits);
          } else if (adUnit.dynamic) {
            this.pbjs.addAdUnits(this.prebidAdUnits.find((ad) => ad.code === adUnit.code));
          }
          const adUnitCodes = refresh || adUnit.dynamic ? [
            adUnit.code
          ] : this.adUnitCodes;
          this.pbjs.requestBids({
            adUnitCodes,
            bidsBackHandler: () => {
              this.gptCommonProvider.googlePublisherTag.pushCommand(() => {
                this.pbjs.setTargetingForGPTAsync();
                GptCommonProvider.prebidBidsReceived = true;
                this.gptCommonProvider.bidsCompleteHandler(refresh, this, adUnitId);
              });
            },
            timeout: this.PREBID_TIMEOUT
          });
          printDebug(`${adUnitId}: bids request sent to prebid`, {
            adUnitCodes
          });
          GptCommonProvider.prebidBidsRequested = true;
        }
      });
    });
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars,class-methods-use-this,@typescript-eslint/no-empty-function
  unload(adUnitId) {
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars,class-methods-use-this,@typescript-eslint/no-empty-function
  destroy(adUnitId) {
  }
  async awaitGlobals() {
    if (!this.pbjs) {
      try {
        await awaitProperty("pbjs", window, 80);
        this.pbjs = window.pbjs;
      } catch (e) {
        Logger.error("Unable to initialize window.pbjs", e);
        return false;
      }
    }
    return true;
  }
  resetAds() {
    this.pbjs.removeAdUnit();
    this.adUnits.clear();
    this.prebidAdUnits = [];
    this.adUnitCodes = [];
  }
  injectLiveIntentConfig() {
    const TREATMENT_RATE = 0.95;
    const LI_REPORTING_KEY = "li-module-enabled";
    const auctionsEnriched = {};
    if (window.liModuleEnabled === void 0) {
      window.liModuleEnabled = Math.random() < TREATMENT_RATE;
      window.liTreatmentRate = TREATMENT_RATE;
    }
    function setTargeting(enriched) {
      googletag.cmd.push(function() {
        let targeting = window.liModuleEnabled ? "t1" : "t0";
        if (enriched !== void 0)
          targeting += enriched ? "-e1" : "-e0";
        googletag.pubads().setTargeting(LI_REPORTING_KEY, targeting);
      });
    }
    __name(setTargeting, "setTargeting");
    setTargeting();
    this.pbjs.que.push(() => {
      if (window.liModuleEnabled) {
        this.pbjs.mergeConfig({
          userSync: {
            idPriority: {
              uid2: [
                "liveIntentId"
              ]
            },
            auctionDelay: 300,
            userIds: [
              {
                name: "liveIntentId",
                bidders: [
                  "openx",
                  "criteo",
                  "ix",
                  "appnexus",
                  "pubmatic",
                  "triplelift",
                  "ttd"
                ],
                params: {
                  publisherId: "58057",
                  emailHash: (() => {
                    const emailHashes = DataLayer.get("visitor")?.emailHashes ?? null;
                    if (emailHashes !== null && Array.isArray(emailHashes) && emailHashes.length >= 3) {
                      return `1-${emailHashes[2]}`;
                    }
                    return "";
                  })(),
                  requestedAttributesOverrides: {
                    pubmatic: true,
                    tripleLift: true,
                    openx: true,
                    sharethrough: true,
                    index: true
                  }
                },
                storage: {
                  type: "html5",
                  name: "__tamLIResolveResult",
                  expires: 1
                }
              }
            ]
          }
        });
      }
      this.pbjs.refreshUserIds({
        submoduleNames: [
          "liveIntentId"
        ]
      });
      this.pbjs.onEvent("auctionInit", (args) => {
        auctionsEnriched[args.auctionId] = args.adUnits && args.adUnits.some((au) => au.bids && au.bids.some((b) => b.userIdAsEids && b.userIdAsEids.some((eid) => eid.source === "liveintent.com" || eid.uids && eid.uids.some((uid) => uid.ext && uid.ext.provider === "liveintent.com"))));
        setTargeting(auctionsEnriched[args.auctionId]);
      });
    });
  }
}, __name(_a19, "PrebidProviderAdapter"), _a19);
PrebidProviderAdapter = __decorate17([
  injectable17(),
  __param12(0, inject11(name2)),
  __param12(1, inject11("AdUnitManager")),
  __metadata14("design:type", Function),
  __metadata14("design:paramtypes", [
    typeof GptCommonProvider === "undefined" ? Object : GptCommonProvider,
    typeof AdUnitManager === "undefined" ? Object : AdUnitManager
  ])
], PrebidProviderAdapter);

// src/hooks/useAdsCore.ts
var bindProvidersAndPlugins = /* @__PURE__ */ __name(() => {
  container.bind(name3).to(AmazonProviderAdapter).inSingletonScope();
  container.bind(name4).to(PrebidProviderAdapter).inSingletonScope();
  container.bind(name2).to(GptCommonProvider).inSingletonScope();
  container.bind(name).to(CcpaPluginAdapter);
}, "bindProvidersAndPlugins");
bindProvidersAndPlugins();
var startAds = /* @__PURE__ */ __name(async (controller, data, callbackOptions) => {
  callbackOptions?.beforeInitCallback?.();
  const gptCommonProvider = container.get(name2);
  const config = AdConfigurationLoader.loadConfig();
  const metricsReporter = container.get("MetricsReporter");
  await gptCommonProvider.init(true, data.envValue, data.segments);
  config.ads.forEach((adUnit) => {
    gptCommonProvider.initAdUnit(adUnit);
  });
  controller.init();
  metricsReporter.init(data.csrfToken);
  callbackOptions?.afterInitCallback?.();
}, "startAds");
var init = /* @__PURE__ */ __name((callbackOptions) => {
  callbackOptions?.beforeInitCallback?.();
  const eventManager = container.get("AdEventManager");
  const forumDisplay = "Forums:The Deals:";
  const forumIndex = "Forums:ForumList";
  try {
    let { pageGroup } = DataLayer.get("page");
    const { pageName } = DataLayer.get("page");
    if (pageName === forumIndex) {
      pageGroup = "forumIndex";
    } else if (pageName.includes(forumDisplay)) {
      pageGroup = "forumDisplay";
    }
    eventManager.registerPageName(pageGroup);
  } catch (e) {
    Logger.error("Unable to initialize DataLayer", e);
  }
  const adController = container.get("AdController");
  callbackOptions?.afterInitCallback?.();
  document.addEventListener(AdEventListeners.AdStackConfigurationData, (event) => {
    const data = event.detail;
    if (data.refreshStrategy) {
      const refreshManager = container.get("AdRefreshManager");
      refreshManager.setRefreshStrategy(data.refreshStrategy);
    }
    void startAds(adController, data);
  });
  document.dispatchEvent(new Event(AdEventListeners.AdLoaderReadiness));
  initAdsOnTabNavigation();
  initAdsOnClientSideNavigation();
  initDynamicAds();
}, "init");
var reinitializeAds = /* @__PURE__ */ __name(() => {
  const config = AdConfigurationLoader.loadConfig();
  const adUnitManager = container.get("AdUnitManager");
  adUnitManager.init(config);
  Object.values(config.ads).forEach((adUnit) => {
    if (!adUnit.providers) {
      return;
    }
    Object.entries(adUnit.providers).forEach(([providerName, config2]) => {
      const providerAdapter = container.get(providerName);
      if (!providerAdapter) {
        return;
      }
      providerAdapter.initAdUnit(adUnit, config2);
    });
  });
  Object.values(config.ads).forEach((adUnit) => {
    if (!adUnit.providers) {
      return;
    }
    Object.entries(adUnit.providers).forEach(([providerName]) => {
      const providerAdapter = container.get(providerName);
      if (!providerAdapter) {
        return;
      }
      providerAdapter.start(adUnit.name, false);
    });
  });
}, "reinitializeAds");
var initAdsOnTabNavigation = /* @__PURE__ */ __name(() => {
  document.addEventListener("slickdeals:core:mobileWebTabSwitch", () => {
    const destroyEvent = new CustomEvent(AdEventListeners.DestroyAdsEvent, {
      bubbles: true
    });
    document.dispatchEvent(destroyEvent);
    reinitializeAds();
  });
}, "initAdsOnTabNavigation");
var initAdsOnClientSideNavigation = /* @__PURE__ */ __name(() => {
  document.addEventListener("slickdeals:core:clientSideNavigation", (event) => {
    const { envValue, refreshStrategy, segments } = event.detail;
    document.dispatchEvent(new CustomEvent(AdEventListeners.DestroyAdsEvent, {
      bubbles: true
    }));
    if (refreshStrategy) {
      container.get("AdRefreshManager").setRefreshStrategy(refreshStrategy);
    }
    container.get(name2).init(true, envValue, segments).then(() => {
      reinitializeAds();
    }).catch((e) => {
      console.error("Failed to re-initialize ads", e);
    });
  });
}, "initAdsOnClientSideNavigation");
var initDynamicAds = /* @__PURE__ */ __name(() => {
  document.addEventListener("slickdeals:core:dynamicAdUnit", (event) => {
    const data = event.detail;
    const config = AdConfigurationLoader.loadConfig();
    const dynamicAdEvent = new CustomEvent("slickdeals:ads:dynamicAdEvent", {
      bubbles: true,
      detail: {
        id: data.id,
        config: config.ads.find((ad) => ad.name === data.id)
      }
    });
    const adContainer = document.getElementById(data.id)?.parentElement;
    if (adContainer && adContainer.id !== data.id && !adContainer.dataset.adContainerId) {
      adContainer.dataset.adContainerId = data.id;
    }
    adContainer?.dispatchEvent(dynamicAdEvent);
  });
}, "initDynamicAds");
var initAdStack = /* @__PURE__ */ __name(() => {
  const page = DataLayer.get("page");
  if (page.layout === "Mobile Web") {
    readyState.domready.then(() => init());
  } else {
    init();
  }
}, "initAdStack");
var useAdsCore = /* @__PURE__ */ __name(() => {
  return {
    initAdStack
  };
}, "useAdsCore");

// src/ads/ad_flags.json
var ad_flags_default = {
  providers: {
    AmazonProviderAdapter: true,
    PrebidProviderAdapter: true
  },
  plugins: {
    CcpaPluginAdapter: true
  }
};

// src/ads/category.json
var category_default = {
  metrics: ["biddingStarted", "biddingCompleted", "adUnitPopulated"],
  refresh: {
    rate: 30,
    limit: 10
  },
  plugins: {
    CcpaPluginAdapter: {
      connector: "CcpaPluginAdapter",
      data: {
        none: "none"
      }
    }
  },
  ads: {
    "top-728-468": {
      placement: "/1006041/cat728BTF1",
      sizes: [
        [468, 60],
        [728, 90]
      ],
      breakpoints: ["desktop"],
      metrics: ["refreshBiddingStarted", "refreshBiddingCompleted", "refreshAdUnitPopulated"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 13893852
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/cat728BTF1"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "540215145"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "LAoBExGnc9nDUoMZdZDcgoH4"
              },
              labelAny: ["sharethrough"]
            },
            {
              bidder: "ix",
              params: {
                siteId: "290253",
                size: [460, 60]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "290253",
                size: [728, 90]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-cat728BTF1-redesign_desktop_728x90"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_cat728BTF1_728x90"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [
                [468, 60],
                [728, 90]
              ]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    "rightcol-160x600": {
      placement: "/1006041/cat160BTF",
      sizes: [[160, 600]],
      breakpoints: ["desktop"],
      metrics: ["refreshBiddingStarted", "refreshBiddingCompleted", "refreshAdUnitPopulated"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 29331271
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "537154325"
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "952275",
                size: [160, 600]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-cat160BTF-redesign_desktop_160x600"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [[160, 600]]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    "middle-728x90": {
      placement: "/1006041/cat728BTF2",
      sizes: [
        [728, 90],
        [468, 60]
      ],
      breakpoints: ["desktop"],
      metrics: ["refreshBiddingStarted", "refreshBiddingCompleted", "refreshAdUnitPopulated"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 13893853
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/cat728BTF2"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "540215146"
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "290254",
                size: [468, 60]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "290254",
                size: [728, 90]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-cat728BTF2-redesign_desktop_728x90"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "cat728BTF2"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [
                [468, 60],
                [728, 90]
              ]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    "bottom-728": {
      placement: "/1006041/cat728BTF3",
      sizes: [
        [468, 60],
        [728, 90]
      ],
      breakpoints: ["desktop"],
      metrics: ["refreshBiddingStarted", "refreshBiddingCompleted", "refreshAdUnitPopulated"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 29331229
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "558912876"
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "952274",
                size: [468, 60]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "952274",
                size: [728, 90]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "1006041-cat728BTF3-redesign_desktop_728x90"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [
                [468, 60],
                [728, 90]
              ]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    adSlot1: {
      placement: "/1006041/cat320ATFMBL3",
      sizes: [[320, 50]],
      breakpoints: ["mobile"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 12854844
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/cat320ATFMBL3"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "539825463"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "iFTzYP3R7PWU3xMRHBeN4nCL"
              },
              labelAny: ["sharethrough"]
            },
            {
              bidder: "ix",
              params: {
                siteId: "255420",
                size: [320, 50]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-cat320ATFMBL3-mweb_320x50"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_cat320ATFMBL3_HDX"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [320, 50]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    adSlot2: {
      placement: "/1006041/cat320BTFMBL3",
      sizes: [[320, 50]],
      breakpoints: ["mobile"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 12854845
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/cat320BTFMBL3"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "539825464"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "eddCXzvzFFLKUzFS2VroAnu8"
              },
              labelAny: ["sharethrough"]
            },
            {
              bidder: "ix",
              params: {
                siteId: "255421",
                size: [320, 50]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-cat320BTFMBL3-mweb_320x50"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_cat320BTFMBL3_HDX"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [320, 50]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    adSlot3: {
      placement: "/1006041/cat320FTRMBL3",
      sizes: [[320, 50]],
      breakpoints: ["mobile"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 12854846
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/cat320FTRMBL3"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "539825465"
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "255422",
                size: [320, 50]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-cat320FTRMBL3-mweb_320x50"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_cat320FTRMBL3_HDX"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [320, 50]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    }
  }
};

// src/ads/dealDetails.json
var dealDetails_default = {
  metrics: ["biddingStarted", "biddingCompleted", "adUnitPopulated"],
  refresh: {
    rate: 30,
    limit: 10
  },
  plugins: {
    CcpaPluginAdapter: {
      connector: "CcpaPluginAdapter",
      data: {
        none: "none"
      }
    }
  },
  ads: {
    "bottom-728": {
      placement: "/1006041/deal728BTF",
      sizes: [[728, 90]],
      breakpoints: ["desktop"],
      metrics: ["refreshBiddingStarted", "refreshBiddingCompleted", "refreshAdUnitPopulated"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 10004820
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/deal728BTF"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "538813694"
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "226335",
                size: [468, 60]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "226335",
                size: [970, 250]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "226335",
                size: [728, 90]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-deal728BTF-redesign_desktop_728x90"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_deal728BTF_970x250"
              }
            },
            {
              bidder: "ttd",
              params: {
                supplySourceId: "directu7djtqsz",
                publisherId: "1"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [
                [468, 60],
                [970, 250],
                [728, 90]
              ]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    rightCol01: {
      placement: "/1006041/deal300ATF1",
      sizes: [
        [300, 250],
        [300, 600]
      ],
      breakpoints: ["desktop"],
      metrics: ["refreshBiddingStarted", "refreshBiddingCompleted", "refreshAdUnitPopulated"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 10004825
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/deal300ATF1"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "538813699"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "1VfReR3JGVrpMUsMcyqQNPf4"
              },
              labelAny: ["sharethrough"]
            },
            {
              bidder: "ix",
              params: {
                siteId: "226340",
                size: [300, 600]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "226340",
                size: [300, 250]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-deal300ATF1-redesign_desktop_300x600"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_deal300ATF1_300x600"
              }
            },
            {
              bidder: "ttd",
              params: {
                supplySourceId: "directu7djtqsz",
                publisherId: "1"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [
                [300, 600],
                [300, 250]
              ]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    rightCol02: {
      placement: "/1006041/deal300ATF2",
      sizes: [
        [300, 250],
        [300, 600]
      ],
      breakpoints: ["desktop"],
      metrics: ["refreshBiddingStarted", "refreshBiddingCompleted", "refreshAdUnitPopulated"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 10004826
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/deal300ATF2"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "538813700"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "uTUUApAARanZa6LPsRx4rErY"
              },
              labelAny: ["sharethrough"]
            },
            {
              bidder: "ix",
              params: {
                siteId: "226341",
                size: [300, 600]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "226341",
                size: [300, 250]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-deal300ATF2-redesign_desktop_300x600"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_deal300ATF2_300x600"
              }
            },
            {
              bidder: "ttd",
              params: {
                supplySourceId: "directu7djtqsz",
                publisherId: "1"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [
                [300, 600],
                [300, 250]
              ]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    rightCol03: {
      placement: "/1006041/deal300BTF1",
      sizes: [
        [300, 250],
        [300, 600]
      ],
      breakpoints: ["desktop"],
      metrics: ["refreshBiddingStarted", "refreshBiddingCompleted", "refreshAdUnitPopulated"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 10004822
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/deal300BTF1"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "538813696"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "u8q2mSEYpDXUxyRunqUGb8rk"
              },
              labelAny: ["sharethrough"]
            },
            {
              bidder: "ix",
              params: {
                siteId: "226337",
                size: [300, 600]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "226337",
                size: [300, 250]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-deal300BTF1-redesign_desktop_300x600"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_deal300BTF1_300x600"
              }
            },
            {
              bidder: "ttd",
              params: {
                supplySourceId: "directu7djtqsz",
                publisherId: "1"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [
                [300, 600],
                [300, 250]
              ]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    rightCol04: {
      placement: "/1006041/deal300BTF2",
      sizes: [
        [300, 250],
        [300, 600]
      ],
      breakpoints: ["desktop"],
      metrics: ["refreshBiddingStarted", "refreshBiddingCompleted", "refreshAdUnitPopulated"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 10004823
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/deal300BTF2"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "538813697"
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "226338",
                size: [300, 600]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "226338",
                size: [300, 250]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-deal300BTF2-redesign_desktop_300x600"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_deal300BTF2_300x600"
              }
            },
            {
              bidder: "ttd",
              params: {
                supplySourceId: "directu7djtqsz",
                publisherId: "1"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [
                [300, 600],
                [300, 250]
              ]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    rightCol05: {
      placement: "/1006041/deal300BTF3",
      sizes: [
        [300, 250],
        [300, 600]
      ],
      breakpoints: ["desktop"],
      metrics: ["refreshBiddingStarted", "refreshBiddingCompleted", "refreshAdUnitPopulated"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 10004824
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/deal300BTF3"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "538813698"
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "226339",
                size: [300, 600]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "226339",
                size: [300, 250]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-deal300BTF3-redesign_desktop_300x600"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_deal300BTF3_300x600"
              }
            },
            {
              bidder: "ttd",
              params: {
                supplySourceId: "directu7djtqsz",
                publisherId: "1"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [
                [300, 600],
                [300, 250]
              ]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    rightCol06: {
      placement: "/1006041/deal300BTF4",
      sizes: [
        [300, 250],
        [300, 600]
      ],
      breakpoints: ["desktop"],
      metrics: ["refreshBiddingStarted", "refreshBiddingCompleted", "refreshAdUnitPopulated"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 26615006
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/deal300BTF4"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "557743066"
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "855362",
                size: [300, 600]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "855362",
                size: [300, 250]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-deal300BTF4-redesign_desktop_300x600"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_deal300BTF4_300x600"
              }
            },
            {
              bidder: "ttd",
              params: {
                supplySourceId: "directu7djtqsz",
                publisherId: "1"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [
                [300, 600],
                [300, 250]
              ]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    rightCol07: {
      placement: "/1006041/deal160BTF",
      sizes: [
        [300, 250],
        [300, 600],
        [160, 600]
      ],
      breakpoints: ["desktop"],
      metrics: ["refreshBiddingStarted", "refreshBiddingCompleted", "refreshAdUnitPopulated"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 10004821
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/deal160BTF"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "538813695"
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "226336",
                size: [160, 600]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "226336",
                size: [300, 250]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "226336",
                size: [300, 600]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-deal160BTF-redesign_desktop_300x600"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_deal160BTF_300x600"
              }
            },
            {
              bidder: "ttd",
              params: {
                supplySourceId: "directu7djtqsz",
                publisherId: "1"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [
                [160, 600],
                [300, 250],
                [300, 600]
              ]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    "unreg-728-1": {
      placement: "/1006041/deal728unreg1",
      sizes: [[728, 90]],
      breakpoints: ["desktop"],
      metrics: ["refreshBiddingStarted", "refreshBiddingCompleted", "refreshAdUnitPopulated"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 10004827
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/deal728unreg1"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "538813701"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "ja7mXhRMX5gWhSR6SKgzQut8"
              },
              labelAny: ["sharethrough"]
            },
            {
              bidder: "ix",
              params: {
                siteId: "226342",
                size: [468, 60]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "226342",
                size: [728, 90]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-deal728unreg1-redesign_desktop_728x90"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_deal728unreg1_728x90"
              }
            },
            {
              bidder: "ttd",
              params: {
                supplySourceId: "directu7djtqsz",
                publisherId: "1"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [
                [468, 60],
                [728, 90]
              ]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    "unreg-728-7": {
      placement: "/1006041/deal728unreg2",
      sizes: [[728, 90]],
      breakpoints: ["desktop"],
      metrics: ["refreshBiddingStarted", "refreshBiddingCompleted", "refreshAdUnitPopulated"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 10004828
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/deal728unreg2"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "538813703"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "WtuQEDc7tugoiZFPfAkzitJA"
              },
              labelAny: ["sharethrough"]
            },
            {
              bidder: "ix",
              params: {
                siteId: "226344",
                size: [468, 60]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "226344",
                size: [728, 90]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-deal728unreg2-redesign_desktop_728x90"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_deal728unreg2_728x90"
              }
            },
            {
              bidder: "ttd",
              params: {
                supplySourceId: "directu7djtqsz",
                publisherId: "1"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [
                [468, 60],
                [728, 90]
              ]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    "unreg-728-14": {
      placement: "/1006041/deal728unreg3",
      sizes: [[728, 90]],
      breakpoints: ["desktop"],
      metrics: ["refreshBiddingStarted", "refreshBiddingCompleted", "refreshAdUnitPopulated"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 10004829
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/deal728unreg3"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "538813702"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "6Cbajnuihzfr8H37h8Xo99Yi"
              },
              labelAny: ["sharethrough"]
            },
            {
              bidder: "ix",
              params: {
                siteId: "226343",
                size: [468, 60]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "226343",
                size: [728, 90]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-deal728unreg3-redesign_desktop_728x90"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_deal728unreg3_728x90"
              }
            },
            {
              bidder: "ttd",
              params: {
                supplySourceId: "directu7djtqsz",
                publisherId: "1"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [
                [468, 60],
                [728, 90]
              ]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    adSlot1: {
      placement: "/1006041/thread320BTFp1MBL3",
      sizes: [
        [320, 50],
        [300, 250],
        [300, 100]
      ],
      breakpoints: ["mobile"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 12854876
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/thread320BTFp1MBL3"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "539825496"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "yp1JBs8PTQvccF2DXWpLfGbX"
              },
              labelAny: ["sharethrough"]
            },
            {
              bidder: "ix",
              params: {
                siteId: "255452",
                size: [320, 50]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-thread320BTFp1MBL3-mweb_320x50"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_thread320BTFp1MBL3_HDX"
              }
            },
            {
              bidder: "ttd",
              params: {
                supplySourceId: "directu7djtqsz",
                publisherId: "1"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [[320, 50]]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    adSlot2: {
      placement: "/1006041/thread320BTFp2MBL3",
      sizes: [[320, 50]],
      breakpoints: ["mobile"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 12854877
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/thread320BTFp2MBL3"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "539825497"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "gDxeACrkezUqnNuxuDLTm3xB"
              },
              labelAny: ["sharethrough"]
            },
            {
              bidder: "ix",
              params: {
                siteId: "255453",
                size: [320, 50]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-thread320BTFp2MBL3-mweb_320x50"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_thread320BTFp2MBL3_HDX"
              }
            },
            {
              bidder: "ttd",
              params: {
                supplySourceId: "directu7djtqsz",
                publisherId: "1"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [[320, 50]]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    adSlot3: {
      placement: "/1006041/thread320BTFp3MBL3",
      sizes: [[320, 50]],
      breakpoints: ["mobile"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 12854878
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/thread320BTFp3MBL3"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "539825498"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "DUFmoZYLW9CfgB5N939CoCDS"
              },
              labelAny: ["sharethrough"]
            },
            {
              bidder: "ix",
              params: {
                siteId: "255454",
                size: [320, 50]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-thread320BTFp3MBL3-mweb_320x50"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [[320, 50]]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    adSlotFTR: {
      placement: "/1006041/thread320FTRMBL3",
      sizes: [
        [320, 50],
        [300, 250]
      ],
      breakpoints: ["mobile"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 12854879
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/thread320FTRMBL3"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "539825499"
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "255455",
                size: [320, 50]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-thread320FTRMBL3-mweb_320x50"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_thread320FTRMBL3_HDX"
              }
            },
            {
              bidder: "ttd",
              params: {
                supplySourceId: "directu7djtqsz",
                publisherId: "1"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [[320, 50]]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    }
  }
};

// src/ads/forumDisplay.json
var forumDisplay_default = {
  metrics: ["biddingStarted", "biddingCompleted", "adUnitPopulated"],
  refresh: {
    rate: 30,
    limit: 10
  },
  plugins: {
    CcpaPluginAdapter: {
      connector: "CcpaPluginAdapter",
      data: {
        none: "none"
      }
    }
  },
  ads: {
    adSlot1: {
      placement: "/1006041/forum320ATFMBL3",
      sizes: [[320, 50]],
      breakpoints: ["mobile"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 12854847
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/forum320ATFMBL3"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "539825466"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "87jVTeNErL98M8yM2DLeUSML"
              },
              labelAny: ["sharethrough"]
            },
            {
              bidder: "ix",
              params: {
                siteId: "255423",
                size: [320, 50]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-forum320ATFMBL3-mweb_320x50"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_forum320ATFMBL3_HDX"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [320, 50]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    adSlot2: {
      placement: "/1006041/forum320BTFp1MBL3",
      sizes: [[320, 50]],
      breakpoints: ["mobile"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 12854848
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/forum320BTFp1MBL3"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "539825467"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "b5F1avm8THXw3TYvKxtbbBKy"
              },
              labelAny: ["sharethrough"]
            },
            {
              bidder: "ix",
              params: {
                siteId: "255424",
                size: [320, 50]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-forum320BTFp1MBL3-mweb_320x50"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_forum320BTFp1MBL3_HDX"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [320, 50]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    adSlot3: {
      placement: "/1006041/forum320BTFp2MBL3",
      sizes: [[320, 50]],
      breakpoints: ["mobile"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 12854849
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/forum320BTFp2MBL3"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "539825468"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "Kbc7eK9X8hkkbhCQUgbdVeeX"
              },
              labelAny: ["sharethrough"]
            },
            {
              bidder: "ix",
              params: {
                siteId: "255425",
                size: [320, 50]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-forum320BTFp2MBL3-mweb_320x50"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_forum320BTFp2MBL3_HDX"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [320, 50]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    adSlot4: {
      placement: "/1006041/forum320BTFp3MBL3",
      sizes: [[320, 50]],
      breakpoints: ["mobile"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 12854850
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/forum320BTFp3MBL3"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "539825469"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "VCocHsdCaTpoP3axUjN19wNb"
              },
              labelAny: ["sharethrough"]
            },
            {
              bidder: "ix",
              params: {
                siteId: "255426",
                size: [320, 50]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-forum320BTFp3MBL3-mweb_320x50"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_forum320BTFp3MBL3_HDX"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [320, 50]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    "top-728": {
      placement: "/1006041/forum728ATF",
      sizes: [[728, 90]],
      breakpoints: ["desktop"],
      metrics: ["refreshBiddingStarted", "refreshBiddingCompleted", "refreshAdUnitPopulated"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 10498478
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/forum728ATF"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "538813712"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "Pp9K98J2WPRmHajCBX3aaawZ"
              },
              labelAny: ["sharethrough"]
            },
            {
              bidder: "ix",
              params: {
                siteId: "226353",
                size: [728, 90]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-forum728ATF-redesign_desktop_728x90"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_forum728ATF_728x90"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [[728, 90]]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    "rightcol-300x250-A": {
      placement: "/1006041/forum300ATF",
      sizes: [[300, 250]],
      breakpoints: ["desktop"],
      metrics: ["refreshBiddingStarted", "refreshBiddingCompleted", "refreshAdUnitPopulated"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 10498491
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/forum300ATF"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "538813711"
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "226354",
                size: [300, 250]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-forum300ATF-redesign_desktop_300x250"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_forum300ATF_300x250"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [[300, 250]]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    "rightcol-300x250-B": {
      placement: "/1006041/forum300BTF",
      sizes: [[300, 250]],
      breakpoints: ["desktop"],
      metrics: ["refreshBiddingStarted", "refreshBiddingCompleted", "refreshAdUnitPopulated"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 10004949
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/forum300BTF"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "538813710"
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "226350",
                size: [300, 250]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-forum300BTF-redesign_desktop_300x250"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_Forum300BTF_300x250"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [[300, 250]]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    "bottom-728": {
      placement: "/1006041/forum728BTF",
      sizes: [[728, 90]],
      breakpoints: ["desktop"],
      metrics: ["refreshBiddingStarted", "refreshBiddingCompleted", "refreshAdUnitPopulated"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 10004951
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/forum728BTF"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "538813709"
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "226356",
                size: [728, 90]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-forum728BTF-redesign_desktop_728x90"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_forum728BTF_728x90"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [[728, 90]]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    "bottom-300": {
      placement: "/1006041/forum300bottom",
      sizes: [[300, 250]],
      breakpoints: ["desktop"],
      metrics: ["refreshBiddingStarted", "refreshBiddingCompleted", "refreshAdUnitPopulated"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 10004950
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/forum300bottom"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "538813713"
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "226352",
                size: [300, 250]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-forum300bottom-redesign_desktop_300x250"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_forum300bottom_300x250"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [[300, 250]]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    }
  }
};

// src/ads/forumsIndex.json
var forumsIndex_default = {
  metrics: ["biddingStarted", "biddingCompleted", "adUnitPopulated"],
  refresh: {
    rate: 30,
    limit: 10
  },
  plugins: {
    CcpaPluginAdapter: {
      connector: "CcpaPluginAdapter",
      data: {
        none: "none"
      }
    }
  },
  ads: {
    "top-300x250-A": {
      placement: "/1006041/forum300ATF",
      sizes: [[300, 250]],
      breakpoints: ["desktop"],
      metrics: ["refreshBiddingStarted", "refreshBiddingCompleted", "refreshAdUnitPopulated"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 10498491
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/forum300ATF"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "538813711"
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "226354",
                size: [300, 250]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-forum300ATF-redesign_desktop_300x250"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_forum300ATF_300x250"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [[300, 250]]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    "top-300x250-B": {
      placement: "/1006041/forum300BTF",
      sizes: [[300, 250]],
      breakpoints: ["desktop"],
      metrics: ["refreshBiddingStarted", "refreshBiddingCompleted", "refreshAdUnitPopulated"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 10004949
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/forum300BTF"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "538813710"
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "226350",
                size: [300, 250]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-forum300BTF-redesign_desktop_300x250"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_Forum300BTF_300x250"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [[300, 250]]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    "rightcol-300x250-B": {
      placement: "/1006041/forum300bottom",
      sizes: [[300, 250]],
      breakpoints: ["desktop"],
      metrics: ["refreshBiddingStarted", "refreshBiddingCompleted", "refreshAdUnitPopulated"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 10004950
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/forum300bottom"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "538813713"
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "226352",
                size: [300, 250]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-forum300bottom-redesign_desktop_300x250"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_forum300bottom_300x250"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [[300, 250]]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    "bottom-728": {
      placement: "/1006041/forum728BTF",
      sizes: [[728, 90]],
      breakpoints: ["desktop"],
      metrics: ["refreshBiddingStarted", "refreshBiddingCompleted", "refreshAdUnitPopulated"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 10004951
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/forum728BTF"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "538813709"
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "226356",
                size: [728, 90]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-forum728BTF-redesign_desktop_728x90"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_forum728BTF_728x90"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [[728, 90]]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    }
  }
};

// src/ads/frontpage.json
var frontpage_default = {
  metrics: ["biddingStarted", "biddingCompleted", "adUnitPopulated"],
  refresh: {
    rate: 30,
    limit: 10
  },
  plugins: {
    CcpaPluginAdapter: {
      connector: "CcpaPluginAdapter",
      data: {
        none: "none"
      }
    }
  },
  ads: {
    "top-300x250-300x600-A": {
      placement: "/1006041/hp300ATF1A",
      sizes: [
        [300, 600],
        [300, 250]
      ],
      breakpoints: ["desktop"],
      metrics: ["refreshBiddingStarted", "refreshBiddingCompleted", "refreshAdUnitPopulated"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 10004780
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/hp300ATF1A"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "538813746"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "5tSE52TG7Ekr66oKr7Lfn681"
              },
              labelAny: ["sharethrough"]
            },
            {
              bidder: "ix",
              params: {
                siteId: "226389",
                size: [300, 600]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "226389",
                size: [300, 250]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-hp300ATF1A-redesign_desktop_300x600"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_hp300ATF1A_300x600"
              }
            },
            {
              bidder: "ttd",
              params: {
                supplySourceId: "directu7djtqsz",
                publisherId: "1"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [
                [300, 600],
                [300, 250]
              ]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    "top-300x250-300x600-B": {
      placement: "/1006041/hp300ATF2A",
      sizes: [
        [300, 600],
        [300, 250]
      ],
      breakpoints: ["desktop"],
      metrics: ["refreshBiddingStarted", "refreshBiddingCompleted", "refreshAdUnitPopulated"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 10004781
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/hp300ATF2A"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "538813747"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "8pKsQrAYcaMvBU9syb6UaRQ2"
              },
              labelAny: ["sharethrough"]
            },
            {
              bidder: "ix",
              params: {
                siteId: "226390",
                size: [300, 600]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "226390",
                size: [300, 250]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-hp300ATF2A-redesign_desktop_300x600"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_hp300ATF2A_300x600"
              }
            },
            {
              bidder: "ttd",
              params: {
                supplySourceId: "directu7djtqsz",
                publisherId: "1"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [
                [300, 600],
                [300, 250]
              ]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    "middle-728x90": {
      placement: "/1006041/hp728BTF",
      sizes: [
        [728, 90],
        [468, 60]
      ],
      breakpoints: ["desktop"],
      metrics: ["refreshBiddingStarted", "refreshBiddingCompleted", "refreshAdUnitPopulated"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 10004774
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/hp728BTF"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "538813740"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "CFA2GDTeh4LkRjJmwU8YPxAY"
              },
              labelAny: ["sharethrough"]
            },
            {
              bidder: "ix",
              params: {
                siteId: "226383",
                "size:": [728, 90]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-hp728BTF-redesign_desktop_728x90"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_hp728BTF_728x90"
              }
            },
            {
              bidder: "ttd",
              params: {
                supplySourceId: "directu7djtqsz",
                publisherId: "1"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [[728, 90]]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    "rightcol-300x250-300x600-B": {
      placement: "/1006041/hp300BTF1",
      sizes: [
        [300, 600],
        [300, 250]
      ],
      breakpoints: ["desktop"],
      metrics: ["refreshBiddingStarted", "refreshBiddingCompleted", "refreshAdUnitPopulated"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 10004777
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/hp300BTF1"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "538813743"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "mtpynjXNpqbURc8igv8btHW1"
              },
              labelAny: ["sharethrough"]
            },
            {
              bidder: "ix",
              params: {
                siteId: "226386",
                size: [300, 600]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "226386",
                size: [300, 250]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-hp300BTF1-redesign_desktop_300x600"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_hp300BTF1_300x600"
              }
            },
            {
              bidder: "ttd",
              params: {
                supplySourceId: "directu7djtqsz",
                publisherId: "1"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [
                [300, 600],
                [300, 250]
              ]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    "rightcol-300x250-300x600-C": {
      placement: "/1006041/hp300BTF2",
      sizes: [
        [300, 600],
        [300, 250]
      ],
      breakpoints: ["desktop"],
      metrics: ["refreshBiddingStarted", "refreshBiddingCompleted", "refreshAdUnitPopulated"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 10004778
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/hp300BTF2"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "538813744"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "xowZ1i4fVSnLMUZ3jiz373VQ"
              },
              labelAny: ["sharethrough"]
            },
            {
              bidder: "ix",
              params: {
                siteId: "226387",
                size: [300, 600]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "226387",
                size: [300, 250]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-hp300BTF2-redesign_desktop_300x600"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_hp300BTF2_300x600"
              }
            },
            {
              bidder: "ttd",
              params: {
                supplySourceId: "directu7djtqsz",
                publisherId: "1"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [
                [300, 600],
                [300, 250]
              ]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    "rightcol-300x250-300x600-D": {
      placement: "/1006041/hp300BTF3",
      sizes: [
        [300, 600],
        [300, 250]
      ],
      breakpoints: ["desktop"],
      metrics: ["refreshBiddingStarted", "refreshBiddingCompleted", "refreshAdUnitPopulated"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 10004779
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/hp300BTF3"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "538813745"
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "226388",
                size: [300, 600]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "226388",
                size: [300, 250]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-hp300BTF3-redesign_desktop_300x600"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_hp300BTF3_300x600"
              }
            },
            {
              bidder: "ttd",
              params: {
                supplySourceId: "directu7djtqsz",
                publisherId: "1"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [
                [300, 600],
                [300, 250]
              ]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    "rightcol-300x250-300x600-160x600": {
      placement: "/1006041/hp160BTF",
      sizes: [
        [160, 600],
        [300, 250],
        [300, 600]
      ],
      breakpoints: ["desktop"],
      metrics: ["refreshBiddingStarted", "refreshBiddingCompleted", "refreshAdUnitPopulated"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 10004776
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/hp160BTF"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "538813742"
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "226385",
                size: [160, 600]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "226385",
                size: [300, 250]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "226385",
                size: [300, 600]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-hp160BTF-redesign_desktop_300x600"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_hp160BTF"
              }
            },
            {
              bidder: "ttd",
              params: {
                supplySourceId: "directu7djtqsz",
                publisherId: "1"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [
                [160, 600],
                [300, 250],
                [300, 600]
              ]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    "middle-728x90-970x250": {
      placement: "/1006041/hp728BTF1",
      sizes: [
        [728, 90],
        [468, 60]
      ],
      breakpoints: ["desktop"],
      metrics: ["refreshBiddingStarted", "refreshBiddingCompleted", "refreshAdUnitPopulated"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 10004775
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/hp728BTF1"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "538813741"
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "226384",
                size: [728, 90]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-hp728BTF1-redesign_desktop_728x90"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_hp728BTF1_728x90"
              }
            },
            {
              bidder: "ttd",
              params: {
                supplySourceId: "directu7djtqsz",
                publisherId: "1"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [[728, 90]]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    allAdSlot1: {
      placement: "/1006041/fy320ATFp1MBL3",
      sizes: [[300, 250], [320, 50], [300, 100], ["fluid"]],
      breakpoints: ["mobile"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 21364391
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/fy320ATFp1MBL3"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "544021911"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "PoFABfuYPDX9UKKTxvwUoNUA"
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "657709",
                size: [300, 250]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "657709",
                size: [320, 50]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "657709",
                size: [300, 100]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "fy320ATFp1MBL3_"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_fy320ATFp1MBL3_300x250"
              }
            },
            {
              bidder: "ttd",
              params: {
                supplySourceId: "directu7djtqsz",
                publisherId: "1"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [
                [300, 250],
                [320, 50],
                [300, 100]
              ]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    allAdSlot2: {
      placement: "/1006041/fy300BTFp2MBL3",
      sizes: [[300, 250], [320, 50], [300, 100], ["fluid"]],
      breakpoints: ["mobile"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 21364405
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/fy300BTFp2MBL3"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "544021913"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "gHZPLCFQrSq2adhE6E2373kM"
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "657710",
                size: [300, 250]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "657710",
                size: [320, 50]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "657710",
                size: [300, 100]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "fy300BTFp2MBL3_"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_fy300BTFp2MBL3_300x250"
              }
            },
            {
              bidder: "ttd",
              params: {
                supplySourceId: "directu7djtqsz",
                publisherId: "1"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [
                [300, 250],
                [320, 50],
                [300, 100]
              ]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    allAdSlot3: {
      placement: "/1006041/fy320BTFp3MBL3",
      sizes: [[300, 250], [320, 50], [300, 100], ["fluid"]],
      breakpoints: ["mobile"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 21364541
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/fy320BTFp3MBL3"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "544021914"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "5xPBQmGSvFiJok1ft6TB6WW8"
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "657720",
                size: [300, 250]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "657720",
                size: [320, 50]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "657720",
                size: [300, 100]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "fy320BTFp3MBL3_"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_fy320BTFp3MBL3_300x250"
              }
            },
            {
              bidder: "ttd",
              params: {
                supplySourceId: "directu7djtqsz",
                publisherId: "1"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [
                [300, 250],
                [320, 50],
                [300, 100]
              ]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    allAdSlot4: {
      placement: "/1006041/fy300BTFp4MBL3",
      sizes: [[300, 250], [320, 50], [300, 100], ["fluid"]],
      breakpoints: ["mobile"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 21364545
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/fy300BTFp4MBL3"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "544021915"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "qR6eAgTvDJp9VCvSJCeEQYLe"
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "657711",
                size: [300, 250]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "657711",
                size: [320, 50]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "657711",
                size: [300, 100]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "fy300BTFp4MBL3_"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_fy300BTFp4MBL3_300x250"
              }
            },
            {
              bidder: "ttd",
              params: {
                supplySourceId: "directu7djtqsz",
                publisherId: "1"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [
                [300, 250],
                [320, 50],
                [300, 100]
              ]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    allAdSlot5: {
      placement: "/1006041/fy320BTFp5MBL3",
      sizes: [[300, 250], [320, 50], [300, 100], ["fluid"]],
      breakpoints: ["mobile"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 21364546
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/fy320BTFp5MBL3"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "544021916"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "XnpygWFfFfuhjmq2RB6qt5dr"
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "657712",
                size: [300, 250]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "657712",
                size: [320, 50]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "657712",
                size: [300, 100]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "fy320BTFp5MBL3_"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_fy320BTFp5MBL3_300x250"
              }
            },
            {
              bidder: "ttd",
              params: {
                supplySourceId: "directu7djtqsz",
                publisherId: "1"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [
                [300, 250],
                [320, 50],
                [300, 100]
              ]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    allAdSlot6: {
      placement: "/1006041/fy320BTFp6MBL3",
      sizes: [[300, 250], [320, 50], [300, 100], ["fluid"]],
      breakpoints: ["mobile"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 21364547
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/fy320BTFp6MBL3"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "544021917"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "C5yup1Rm7U4WCJbnPk6qJMqE"
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "657714",
                size: [300, 250]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "657714",
                size: [320, 50]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "657714",
                size: [300, 100]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "fy320BTFp6MBL3_"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_fy320BTFp6MBL3_300x250"
              }
            },
            {
              bidder: "ttd",
              params: {
                supplySourceId: "directu7djtqsz",
                publisherId: "1"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [
                [300, 250],
                [320, 50],
                [300, 100]
              ]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    allAdSlot7: {
      placement: "/1006041/fy320BTFp7MBL3",
      sizes: [[300, 250], [320, 50], [300, 100], ["fluid"]],
      breakpoints: ["mobile"],
      metrics: ["dynamicBiddingStarted", "dynamicBiddingCompleted", "dynamicAdUnitPopulated"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 21364549
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/fy320BTFp7MBL3"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "544021918"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "oLTmCM5epUfTtfxwchnfGt6k"
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "657715",
                size: [300, 250]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "657715",
                size: [320, 50]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "657715",
                size: [300, 100]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "fy320BTFp7MBL3_"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_fy320BTFp7MBL3_300x250"
              }
            },
            {
              bidder: "ttd",
              params: {
                supplySourceId: "directu7djtqsz",
                publisherId: "1"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [
                [300, 250],
                [320, 50],
                [300, 100]
              ]
            }
          }
        },
        AmazonProviderAdapter: {}
      },
      dynamic: true
    },
    allAdSlot8: {
      placement: "/1006041/fy320BTFp8MBL3",
      sizes: [[300, 250], [320, 50], [300, 100], ["fluid"]],
      breakpoints: ["mobile"],
      metrics: ["dynamicBiddingStarted", "dynamicBiddingCompleted", "dynamicAdUnitPopulated"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 21364550
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/fy320BTFp8MBL3"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "544021919"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "z3z7dedew24fRWUka3pTREoL"
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "657716",
                size: [300, 250]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "657716",
                size: [320, 50]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "657716",
                size: [300, 100]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "fy320BTFp8MBL3_"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_fy320BTFp8MBL3_300x250"
              }
            },
            {
              bidder: "ttd",
              params: {
                supplySourceId: "directu7djtqsz",
                publisherId: "1"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [
                [300, 250],
                [320, 50],
                [300, 100]
              ]
            }
          }
        },
        AmazonProviderAdapter: {}
      },
      dynamic: true
    },
    allAdSlot9: {
      placement: "/1006041/fy320BTFp9MBL3",
      sizes: [[300, 250], [320, 50], [300, 100], ["fluid"]],
      breakpoints: ["mobile"],
      metrics: ["dynamicBiddingStarted", "dynamicBiddingCompleted", "dynamicAdUnitPopulated"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 21364566
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/fy320BTFp9MBL3"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "544021920"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "gQY6NazFUNqNwewsiq7po4n1"
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "657717",
                size: [300, 250]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "657717",
                size: [320, 50]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "657717",
                size: [300, 100]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "fy320BTFp9MBL3_"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_fy320BTFp9MBL3_300x250"
              }
            },
            {
              bidder: "ttd",
              params: {
                supplySourceId: "directu7djtqsz",
                publisherId: "1"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [
                [300, 250],
                [320, 50],
                [300, 100]
              ]
            }
          }
        },
        AmazonProviderAdapter: {}
      },
      dynamic: true
    },
    frontpageAdSlot1: {
      placement: "/1006041/hp320ATFp1MBL3",
      sizes: [
        [300, 250],
        [320, 50],
        [300, 100]
      ],
      breakpoints: ["mobile"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 12854860
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/hp320ATFp1MBL3"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "539825480"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "seJ3M85dZiyMrSQELS9jxsgc"
              },
              labelAny: ["sharethrough"]
            },
            {
              bidder: "ix",
              params: {
                siteId: "255436",
                size: [300, 250]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "255436",
                size: [320, 50]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "255436",
                size: [300, 100]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-hp320ATFp1MBL3-mweb_320x50"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_hp320ATFp1MBL3_300x250"
              }
            },
            {
              bidder: "ttd",
              params: {
                supplySourceId: "directu7djtqsz",
                publisherId: "1"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [
                [300, 250],
                [320, 50],
                [300, 100]
              ]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    frontpageAdSlot2: {
      placement: "/1006041/hp300BTFp2MBL3",
      sizes: [
        [300, 250],
        [320, 50],
        [300, 100]
      ],
      breakpoints: ["mobile"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 12854857
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/hp300BTFp2MBL3"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "539825476"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "f7xDZT7LzicKZuzzAoZkVmqb"
              },
              labelAny: ["sharethrough"]
            },
            {
              bidder: "ix",
              params: {
                siteId: "255433",
                size: [300, 250]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "255433",
                size: [320, 50]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-hp300BTFp2MBL3-mweb_300x250"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_hp300BTFp2MBL3_300x250"
              }
            },
            {
              bidder: "ttd",
              params: {
                supplySourceId: "directu7djtqsz",
                publisherId: "1"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [
                [300, 250],
                [320, 50]
              ]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    frontpageAdSlot3: {
      placement: "/1006041/hp320BTFp3MBL3",
      sizes: [
        [300, 250],
        [320, 50],
        [300, 100]
      ],
      breakpoints: ["mobile"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 12854861
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/hp320BTFp3MBL3"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "539825481"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "b1doh4dUG9EbASWc74mJpapU"
              },
              labelAny: ["sharethrough"]
            },
            {
              bidder: "ix",
              params: {
                siteId: "255437",
                size: [300, 250]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "255437",
                size: [320, 50]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "255437",
                size: [300, 100]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-hp320BTFp3MBL3-mweb_320x50"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_hp320BTFp3MBL3_300x250"
              }
            },
            {
              bidder: "ttd",
              params: {
                supplySourceId: "directu7djtqsz",
                publisherId: "1"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [
                [300, 250],
                [320, 50],
                [300, 100]
              ]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    frontpageAdSlot4: {
      placement: "/1006041/hp300BTFp4MBL3",
      sizes: [
        [300, 250],
        [320, 50],
        [300, 100]
      ],
      breakpoints: ["mobile"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 12854859
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/hp300BTFp4MBL3"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "539825479"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "67sihENJ3iL87Rxq8WHg6bwJ"
              },
              labelAny: ["sharethrough"]
            },
            {
              bidder: "ix",
              params: {
                siteId: "255435",
                size: [300, 250]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "255435",
                size: [320, 50]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-hp300BTFp4MBL3-mweb_300x250"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_hp300BTFp4MBL3_300x250"
              }
            },
            {
              bidder: "ttd",
              params: {
                supplySourceId: "directu7djtqsz",
                publisherId: "1"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [
                [300, 250],
                [320, 50]
              ]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    frontpageAdSlot5: {
      placement: "/1006041/hp320BTFp5MBL3",
      sizes: [
        [300, 250],
        [320, 50],
        [300, 100]
      ],
      breakpoints: ["mobile"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 12854862
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/hp320BTFp5MBL3"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "539825482"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "NWVY37DRVgoLV7QuadpfebLd"
              },
              labelAny: ["sharethrough"]
            },
            {
              bidder: "ix",
              params: {
                siteId: "255438",
                size: [300, 250]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "255438",
                size: [320, 50]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "255438",
                size: [300, 100]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-hp320BTFp5MBL3-mweb_320x50"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_hp320BTFp5MBL3_300x250"
              }
            },
            {
              bidder: "ttd",
              params: {
                supplySourceId: "directu7djtqsz",
                publisherId: "1"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [
                [300, 250],
                [320, 50],
                [300, 100]
              ]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    frontpageAdSlot6: {
      placement: "/1006041/hp320BTFp6MBL3",
      sizes: [
        [300, 250],
        [320, 50],
        [300, 100]
      ],
      breakpoints: ["mobile"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 12854863
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/hp320BTFp6MBL3"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "539825483"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "kUjCbXK23PZLu3EMGu2TV2yk"
              },
              labelAny: ["sharethrough"]
            },
            {
              bidder: "ix",
              params: {
                siteId: "255439",
                size: [300, 250]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "255439",
                size: [320, 50]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "255439",
                size: [300, 100]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-hp320BTFp6MBL3-mweb_320x50"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_hp320BTFp6MBL3_300x250"
              }
            },
            {
              bidder: "ttd",
              params: {
                supplySourceId: "directu7djtqsz",
                publisherId: "1"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [
                [300, 250],
                [320, 50],
                [300, 100]
              ]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    frontpageAdSlot7: {
      placement: "/1006041/hp320BTFp7MBL3",
      sizes: [[300, 250], [320, 50], [300, 100], ["fluid"]],
      breakpoints: ["mobile"],
      metrics: ["dynamicBiddingStarted", "dynamicBiddingCompleted", "dynamicAdUnitPopulated"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 12854864
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/hp320BTFp7MBL3"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "539825484"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "zDwjsL87YJFG2u53oB2kSYAn"
              },
              labelAny: ["sharethrough"]
            },
            {
              bidder: "ix",
              params: {
                siteId: "255440",
                size: [300, 250]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "255440",
                size: [320, 50]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "255440",
                size: [300, 100]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-hp320BTFp7MBL3-mweb_320x50"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_hp320BTFp7MBL3_300x250"
              }
            },
            {
              bidder: "ttd",
              params: {
                supplySourceId: "directu7djtqsz",
                publisherId: "1"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [
                [300, 250],
                [320, 50],
                [300, 100]
              ]
            }
          }
        },
        AmazonProviderAdapter: {}
      },
      dynamic: true
    },
    frontpageAdSlot8: {
      placement: "/1006041/hp320BTFp8MBL3",
      sizes: [[300, 250], [320, 50], [300, 100], ["fluid"]],
      breakpoints: ["mobile"],
      metrics: ["dynamicBiddingStarted", "dynamicBiddingCompleted", "dynamicAdUnitPopulated"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 12854865
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/hp320BTFp8MBL3"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "539825485"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "jK6pT3DdW1ZQ7AJqt61g8KLq"
              },
              labelAny: ["sharethrough"]
            },
            {
              bidder: "ix",
              params: {
                siteId: "255441",
                size: [300, 250]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "255441",
                size: [320, 50]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "255441",
                size: [300, 100]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-hp320BTFp8MBL3-mweb_320x50"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_hp320BTFp8MBL3_300x250"
              }
            },
            {
              bidder: "ttd",
              params: {
                supplySourceId: "directu7djtqsz",
                publisherId: "1"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [
                [300, 250],
                [320, 50],
                [300, 100]
              ]
            }
          }
        },
        AmazonProviderAdapter: {}
      },
      dynamic: true
    },
    frontpageAdSlot9: {
      placement: "/1006041/hp320BTFp9MBL3",
      sizes: [[300, 250], [320, 50], [300, 100], ["fluid"]],
      breakpoints: ["mobile"],
      metrics: ["dynamicBiddingStarted", "dynamicBiddingCompleted", "dynamicAdUnitPopulated"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 12854866
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/hp320BTFp9MBL3"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "539825486"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "R2d5m43WSay9WD91yvnnfMYn"
              },
              labelAny: ["sharethrough"]
            },
            {
              bidder: "ix",
              params: {
                siteId: "255442",
                size: [300, 250]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "255442",
                size: [320, 50]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "255442",
                size: [300, 100]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-hp320BTFp9MBL3-mweb_320x50"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_hp320BTFp9MBL3_300x250"
              }
            },
            {
              bidder: "ttd",
              params: {
                supplySourceId: "directu7djtqsz",
                publisherId: "1"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [
                [300, 250],
                [320, 50],
                [300, 100]
              ]
            }
          }
        },
        AmazonProviderAdapter: {}
      },
      dynamic: true
    },
    popularAdSlot1: {
      placement: "/1006041/pop320ATFMBL3",
      sizes: [[300, 250], [320, 50], [300, 100], ["fluid"]],
      breakpoints: ["mobile"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 12854869
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/pop320ATFMBL3"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "539825489"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "mB1EQiLi7cqScmTkw2eedSgM"
              },
              labelAny: ["sharethrough"]
            },
            {
              bidder: "ix",
              params: {
                siteId: "255445",
                size: [320, 50]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-pop320ATFMBL3-mweb_320x50"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_pop320ATFMBL3_300x250"
              }
            },
            {
              bidder: "ttd",
              params: {
                supplySourceId: "directu7djtqsz",
                publisherId: "1"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [[320, 50]]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    popularAdSlot2: {
      placement: "/1006041/pop300BTFp1MBL3",
      sizes: [[300, 250], [320, 50], [300, 100], ["fluid"]],
      breakpoints: ["mobile"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 12854867
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/pop300BTFp1MBL3"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "539825487"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "CQyHiaShzQKr7vwgeHmuV5tz"
              },
              labelAny: ["sharethrough"]
            },
            {
              bidder: "ix",
              params: {
                siteId: "255443",
                size: [300, 250]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "255443",
                size: [320, 50]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-pop300BTFp1MBL3-mweb_300x250"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_pop300BTFp1MBL3_300x250"
              }
            },
            {
              bidder: "ttd",
              params: {
                supplySourceId: "directu7djtqsz",
                publisherId: "1"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [
                [300, 250],
                [320, 50]
              ]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    popularAdSlot3: {
      placement: "/1006041/pop320BTFp2MBL3",
      sizes: [[300, 250], [320, 50], [300, 100], ["fluid"]],
      breakpoints: ["mobile"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 12854870
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/pop320BTFp2MBL3"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "539825490"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "DXQLPoN7ZJ1m4NVkSZD5Daep"
              },
              labelAny: ["sharethrough"]
            },
            {
              bidder: "ix",
              params: {
                siteId: "255446",
                size: [320, 50]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-pop320BTFp2MBL3-mweb_320x50"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_pop320BTFp2MBL3_300x250"
              }
            },
            {
              bidder: "ttd",
              params: {
                supplySourceId: "directu7djtqsz",
                publisherId: "1"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [[320, 50]]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    popularAdSlot4: {
      placement: "/1006041/pop300BTFp3MBL3",
      sizes: [[300, 250], [320, 50], [300, 100], ["fluid"]],
      breakpoints: ["mobile"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 12854868
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/pop300BTFp3MBL3"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "539825488"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "i6tWUb5KM3fwc9t9H59BnEW8"
              },
              labelAny: ["sharethrough"]
            },
            {
              bidder: "ix",
              params: {
                siteId: "255444",
                size: [300, 250]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "255444",
                size: [320, 50]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-pop300BTFp3MBL3-mweb_300x250"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_pop300BTFp3MBL3_300x250"
              }
            },
            {
              bidder: "ttd",
              params: {
                supplySourceId: "directu7djtqsz",
                publisherId: "1"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [
                [300, 250],
                [320, 50]
              ]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    popularAdSlot5: {
      placement: "/1006041/pop320BTFp4MBL3",
      sizes: [[300, 250], [320, 50], [300, 100], ["fluid"]],
      breakpoints: ["mobile"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 12854871
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/pop320BTFp4MBL3"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "539825491"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "wH3dnE457CVaC4vku61fQDbb"
              },
              labelAny: ["sharethrough"]
            },
            {
              bidder: "ix",
              params: {
                siteId: "255447",
                size: [320, 50]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-pop320BTFp4MBL3-mweb_320x50"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_pop320BTFp4MBL3_300x250"
              }
            },
            {
              bidder: "ttd",
              params: {
                supplySourceId: "directu7djtqsz",
                publisherId: "1"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [[320, 50]]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    }
  }
};

// src/ads/popularDeals.json
var popularDeals_default = {
  metrics: ["biddingStarted", "biddingCompleted", "adUnitPopulated"],
  refresh: {
    rate: 30,
    limit: 10
  },
  plugins: {
    CcpaPluginAdapter: {
      connector: "CcpaPluginAdapter",
      data: {
        none: "none"
      }
    }
  },
  ads: {
    "top-300x250-300x600-A": {
      placement: "/1006041/pop300ATF",
      sizes: [
        [300, 250],
        [300, 600]
      ],
      breakpoints: ["desktop"],
      metrics: ["refreshBiddingStarted", "refreshBiddingCompleted", "refreshAdUnitPopulated"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 10004915
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/pop300ATF"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "538813756"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "6uPe2HnWt7Nx5ow75PZ8zT17"
              },
              labelAny: ["sharethrough"]
            },
            {
              bidder: "ix",
              params: {
                siteId: "226399",
                size: [300, 600]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "226399",
                size: [300, 250]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-pop300ATF-redesign_desktop_300x600"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_pop300ATF_300x600"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [
                [300, 600],
                [300, 250]
              ]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    "top-300x250-300x600-B": {
      placement: "/1006041/pop300ATF2",
      sizes: [
        [300, 250],
        [300, 600]
      ],
      breakpoints: ["desktop"],
      metrics: ["refreshBiddingStarted", "refreshBiddingCompleted", "refreshAdUnitPopulated"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 10004916
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/pop300ATF2"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "538813757"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "MrVqjj5CgLs7L6YQJCeBzjrQ"
              },
              labelAny: ["sharethrough"]
            },
            {
              bidder: "ix",
              params: {
                siteId: "226400",
                size: [300, 600]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "226400",
                size: [300, 250]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-pop300ATF2-redesign_desktop_300x600"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_pop300ATF2_300x600"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [
                [300, 600],
                [300, 250]
              ]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    "rightcol-300x250-B": {
      placement: "/1006041/pop300BTF1",
      sizes: [
        [300, 250],
        [300, 600],
        [160, 600]
      ],
      breakpoints: ["desktop"],
      metrics: ["refreshBiddingStarted", "refreshBiddingCompleted", "refreshAdUnitPopulated"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 10004912
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/pop300BTF1"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "538813755"
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "226398",
                size: [300, 250]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-pop300BTF1-redesign_desktop_300x250"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_pop300BTF1_300x600"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [[300, 250]]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    "bottom-728x90-970x250": {
      placement: "/1006041/pop728BTF",
      sizes: [
        [970, 250],
        [728, 90]
      ],
      breakpoints: ["desktop"],
      metrics: ["refreshBiddingStarted", "refreshBiddingCompleted", "refreshAdUnitPopulated"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 10004914
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/pop728BTF"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "538813754"
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "226397",
                size: [970, 250]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "226397",
                size: [728, 90]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-pop728BTF-redesign_desktop_728x90"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_pop728BTF_970x250"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [
                [970, 250],
                [728, 90]
              ]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    }
  }
};

// src/ads/search.json
var search_default = {
  metrics: ["biddingStarted", "biddingCompleted", "adUnitPopulated"],
  refresh: {
    rate: 30,
    limit: 10
  },
  plugins: {
    CcpaPluginAdapter: {
      connector: "CcpaPluginAdapter",
      data: {
        none: "none"
      }
    }
  },
  ads: {
    "leftcol-160x600": {
      placement: "/1006041/search160BTF",
      sizes: [[160, 600]],
      breakpoints: ["desktop"],
      metrics: ["refreshBiddingStarted", "refreshBiddingCompleted", "refreshAdUnitPopulated"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 10004887
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/search160BTF"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "538813762"
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "226405",
                size: [160, 600]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-search160BTF-redesign_desktop_160x600"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_search160BTF_HDX"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [[160, 600]]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    "top-300x250-A": {
      placement: "/1006041/search300ATF1",
      sizes: [[300, 250]],
      breakpoints: ["desktop"],
      metrics: ["refreshBiddingStarted", "refreshBiddingCompleted", "refreshAdUnitPopulated"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 10004885
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/search300ATF1"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "538813763"
              }
            },
            {
              bidder: "sharethrough",
              params: {
                pkey: "cBgk61Dwrzfn1xWGM3YiiSQd"
              },
              labelAny: ["sharethrough"]
            },
            {
              bidder: "ix",
              params: {
                siteId: "226406",
                size: [300, 250]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-search300ATF1-redesign_desktop_300x250"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_search300ATF1_300x250"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [[300, 250]]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    "bottom-728": {
      placement: "/1006041/search728BTF",
      sizes: [
        [728, 90],
        [468, 60]
      ],
      breakpoints: ["desktop"],
      metrics: ["refreshBiddingStarted", "refreshBiddingCompleted", "refreshAdUnitPopulated"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 10004886
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/search728BTF"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "538813761"
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "226404",
                size: [468, 60]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "226404",
                size: [970, 250]
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "226404",
                size: [728, 90]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-search728BTF-redesign_desktop_728x90"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_search728BTF_728x90"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [
                [468, 60],
                [970, 250],
                [728, 90]
              ]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    adSlot1: {
      placement: "/1006041/search320ATFMBL3",
      sizes: [[320, 50], ["fluid"]],
      breakpoints: ["mobile"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 12854873
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/search320ATFMBL3"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "539825493"
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "255449",
                size: [320, 50]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-search320ATFMBL3-mweb_320x50"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_search320ATFMBL3_HDX"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [[320, 50]]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    adSlot2: {
      placement: "/1006041/search320BTFMBL3",
      sizes: [[320, 50], [300, 100], [300, 250], ["fluid"]],
      breakpoints: ["mobile"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 12854874
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/search320BTFMBL3"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "539825494"
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "255450",
                size: [320, 50]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-search320BTFMBL3-mweb_320x50"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_search320BTFMBL3_HDX"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [[320, 50]]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    adSlot3: {
      placement: "/1006041/search320BTFp1MBL3",
      sizes: [[320, 50], [300, 250], ["fluid"]],
      breakpoints: ["mobile"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 34226831
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/search320BTFp1MBL3"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "561332553"
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "1142378",
                size: [320, 50]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-search320BTFp1MBL3-mweb_320x50"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_search320BTFp1MBL3_HDX"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [[320, 50]]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    adSlot4: {
      placement: "/1006041/search320BTFp2MBL3",
      sizes: [[320, 50], [300, 250], ["fluid"]],
      breakpoints: ["mobile"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 34226832
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/search320BTFp2MBL3"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "561332554"
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "1142379",
                size: [320, 50]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-search320BTFp2MBL3-mweb_320x50"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_search320BTFp2MBL3_HDX"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [[320, 50]]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    adSlot5: {
      placement: "/1006041/search320BTFp3MBL3",
      sizes: [[320, 50], [300, 250], ["fluid"]],
      breakpoints: ["mobile"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 34226835
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/search320BTFp3MBL3"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "561332555"
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "1142380",
                size: [320, 50]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-search320BTFp3MBL3-mweb_320x50"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_search320BTFp3MBL3_HDX"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [[320, 50]]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    },
    adSlotFTR: {
      placement: "/1006041/search320FTRMBL3",
      sizes: [[320, 50], [300, 100], [300, 250], ["fluid"]],
      breakpoints: ["mobile"],
      providers: {
        PrebidProviderAdapter: {
          bids: [
            {
              bidder: "appnexus",
              params: {
                placementId: 12854875
              }
            },
            {
              bidder: "criteo",
              params: {
                networkId: 1290,
                publisherSubId: "/1006041/search320FTRMBL3"
              }
            },
            {
              bidder: "openx",
              params: {
                delDomain: "slickdeals-d.openx.net",
                unit: "539825495"
              }
            },
            {
              bidder: "ix",
              params: {
                siteId: "255451",
                size: [320, 50]
              }
            },
            {
              bidder: "pubmatic",
              params: {
                publisherId: "158048",
                adSlot: "-1006041-search320FTRMBL3-mweb_320x50"
              }
            },
            {
              bidder: "triplelift",
              params: {
                inventoryCode: "slickdeals_search320FTRMBL3_HDX"
              }
            }
          ],
          mediaTypes: {
            banner: {
              sizes: [[320, 50]]
            }
          }
        },
        AmazonProviderAdapter: {}
      }
    }
  }
};

// src/ads/durangoConfiguration/adBlockEndpoints.json
var adBlockEndpoints_default = {
  adBlockEndpoints: {
    endpoints: ["/scripts/sd/ads/gpt.min.js"]
  }
};

// src/ads/durangoConfiguration/breakpoints.json
var breakpoints_default = {
  breakpoints: {
    mobile: {
      name: "mobile",
      minimum: 0,
      maximum: 768
    },
    tablet: {
      name: "tablet",
      minimum: 768,
      maximum: 1024
    },
    desktop: {
      name: "desktop",
      minimum: 1024,
      maximum: 65536
    }
  }
};

// src/ads/durangoConfiguration/metricsReporter.json
var metricsReporter_default = {
  metricsReporter: {
    maxRequestsPerBatch: 100,
    batchFireTimeout: 3e3,
    endpointUrl: "/ad-stats/1/ad-events"
  }
};

// src/ads/durangoConfiguration/whitelist.json
var whitelist_default = {
  whitelist: {
    firstParty: ["slickdeals.net", "slickdealscdn.com"]
  }
};

// src/hooks/useHeadAdStack.ts
var adConfigurations = {
  category: category_default,
  dealDetails: dealDetails_default,
  forumDisplay: forumDisplay_default,
  forumsIndex: forumsIndex_default,
  frontpage: frontpage_default,
  popularDeals: popularDeals_default,
  search: search_default
};
var useHeadAdStack = /* @__PURE__ */ __name(({ isMobile, adConfig, segments, csrfToken }) => {
  function getA9Scripts() {
    return [
      `
        const aps=((e="3097")=>{window._aps=window._aps||new Map,_aps.has(e)||_aps.set(e,{queue:[],store:new Map([["listeners",new Map]])});let t={accountID:e,record:function(e,t){return new Promise((r,n)=>{_aps.get(this.accountID).queue.push(new CustomEvent(e,{detail:{...t,resolve:r,reject:n}}))})},read:function(e){return this.record("bootstrap/store/willRead",{name:e}),_aps.get(this.accountID).store.get(e)},run:function(e,t){_aps.get("_system")?.store.get("listeners").has(e)?this.record(e,t):this.record("bootstrap/run/willDrop",{name:e,detail:t})},react:function(e,t){_aps.get(this.accountID).store.get("listeners").set(e,t);this.record("bootstrap/react/didExecute",{name:e})}};return t.record("bootstrap/version/declare",{version:5}),t})();((t=aps)=>{window.apstag=window.apstag||{init:function(e,r){t.record("legacy/init/enqueue",{config:e,callback:r})},fetchBids:function(e,r){t.record("legacy/fetchBids/enqueue",{bidConfig:e,callback:r})},setDisplayBids:function(){t.run("legacy/setDisplayBids/enqueue",{arguments:arguments})},targetingKeys:function(){return t.read("legacy/targetingKeys")??[]},rpa:function(e,r,n){t.record("legacy/rpa/enqueue",{tokenConfig:e,callback:r,setCookie:n})},upa:function(e,r,n){t.record("legacy/upa/enqueue",{tokenConfig:e,callback:r,setCookie:n})},dpa:function(e){t.record("legacy/dpa/enqueue",{callback:e})}};t.record("bootstrapExtAPStag/version/declare",{version:1})})();((t=aps)=>{window.apstag={...window.apstag,queue:{push:function(e){t.record("legacy/queue/push",{callback:e})}}};t.record("bootstrapExtQueue/version/declare",{version:1})})();((t=aps)=>{window.apstag={...window.apstag,nativeContent:function(){return{enable:function(){t.record("nativeCommerceAds/service/enable")},registerHook:function(e,r){if(e==="nativeCommerceAds.updateClickUrl"){t.react("nativeCommerceAds/clickUrl/update",k=>{return{status:"completed",value:{url:r(k?.detail?.url,k?.detail?.element)}}})}else{throw new Error("Unsupported event type")}}}}};t.record("bootstrapExtNCA/version/declare",{version:1})})();
      `,
      {
        async: true,
        src: "https://config.aps.amazon-adsystem.com/configs/3097",
        fetchPriority: "high"
      },
      {
        async: true,
        src: "https://client.aps.amazon-adsystem.com/publisher.js",
        fetchPriority: "high"
      }
    ];
  }
  __name(getA9Scripts, "getA9Scripts");
  function getA9Links() {
    return [
      {
        rel: "dns-prefetch",
        href: "//c.aps.amazon-adsystem.com"
      },
      {
        rel: "dns-prefetch",
        href: "//config.aps.amazon-adsystem.com"
      },
      {
        rel: "preconnect",
        href: "https://c.aps.amazon-adsystem.com"
      },
      {
        rel: "preload",
        href: "https://config.aps.amazon-adsystem.com/configs/3097",
        as: "script",
        fetchPriority: "high"
      },
      {
        rel: "preload",
        href: "https://client.aps.amazon-adsystem.com/publisher.js",
        as: "script",
        fetchPriority: "high"
      }
    ];
  }
  __name(getA9Links, "getA9Links");
  function getPrebidScript() {
    return [
      {
        src: "https://static.slickdealscdn.com/scripts/providerV10.js?5",
        async: true
      },
      {
        src: "//b-code.liadm.com/a-06kx.min.js",
        async: true
      }
    ];
  }
  __name(getPrebidScript, "getPrebidScript");
  const adConfigJson = adConfigurations[adConfig];
  if (!adConfigJson) {
    console.error(`Failed to load ad config for "${adConfig}"`);
  }
  const adReadinessData = {
    csrfToken,
    envValue: "",
    segments: JSON.stringify(segments)
  };
  const script = [
    {
      src: "https://securepubads.g.doubleclick.net/tag/js/gpt.js",
      async: true
    },
    ...getA9Scripts(),
    ...getPrebidScript(),
    {
      type: "application/json",
      id: "productionConfig",
      innerHTML: adConfigJson
    },
    {
      type: "application/json",
      id: "featureFlags",
      innerHTML: ad_flags_default
    },
    `
      window.durangoConfiguration = {
        ...${JSON.stringify(adBlockEndpoints_default)},
        ...${JSON.stringify(breakpoints_default)},
        ...${JSON.stringify(metricsReporter_default)},
        ...${JSON.stringify(whitelist_default)},
      };
    `,
    `
      document.addEventListener('slickdeals:ads:adLoaderReadiness', () => {
        const event = new CustomEvent('slickdeals:ads:adStackConfigurationData', {
          detail: ${JSON.stringify(adReadinessData)},
        })

        document.dispatchEvent(event);
      });
    `
  ];
  if (!isMobile) {
    script.unshift({
      // blockthrough
      src: "https://btloader.com/tag?o=5687405443022848&upapi=true",
      async: true
    });
  }
  const link = [
    ...getA9Links(),
    {
      rel: "dns-prefetch",
      href: "//slickdeals-d.openx.net"
    }
  ];
  return {
    script,
    link
  };
}, "useHeadAdStack");
export {
  AbTest,
  AbTestTransformer,
  Ad,
  AdBlockEndpointNamespace,
  AdConfigurationLoader,
  AdController,
  AdEvent,
  AdEventListeners,
  AdEventManager,
  AdEventType,
  AdOverride,
  AdRefreshManager,
  AdTransformer,
  AdUnit,
  AdUnitConfig,
  AdUnitConfigTransformer,
  AdUnitManager,
  AdUnitOverride,
  AdUnitTransformer,
  AdblockDetect,
  BreakpointTypes,
  BroadcastChannel,
  Configuration,
  ConfigurationLoader,
  ConfigurationTransformer,
  DataLayer,
  EventTypes,
  FeatureFlagLoader,
  Features,
  IntervalTimer,
  Logger,
  MetricsReporter,
  Observable,
  OverridesConfig,
  OverridesConfigTransformer,
  Page,
  PageEventType,
  PageOverride,
  PageSlotsConfig,
  PageSlotsConfigTransformer,
  PageTransformer,
  Plugin,
  PluginManager,
  PluginTransformer,
  PluginsConfig,
  PluginsConfigTransformer,
  ProductionAdSlot,
  ProductionAdSlotTransformer,
  ProductionConfig,
  ProductionConfigTransformer,
  ProviderManager,
  ReplayObservable,
  Rule,
  RuleTransformer,
  adEventTypes,
  awaitProperty,
  channelName,
  configurationKey,
  container,
  dynamicEventTypes,
  featureFlagLoaderScriptId,
  getBreakpoint,
  getBreakpointByName,
  getCurrentBreakpoint,
  init,
  isAdEventObject,
  isAdMetrics,
  isAdSizes,
  isAdUnitProviders,
  isBreakpointTypes,
  isCurrentBreakpoint,
  isDestroyablePlugin,
  isDynamicMetrics,
  isEventType,
  isPageMetrics,
  isPageRefresh,
  isPluginAdapter,
  isProviderAdapter,
  isProvidersConfig,
  isRefreshMetrics,
  isReinitializeMetrics,
  isRuleDefinition,
  pageEventTypes,
  refreshEventTypes,
  reinitializeEventTypes,
  scriptTagId,
  startAds,
  useAdsCore,
  useHeadAdStack
};
